<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del" ref="SetBtn"></buttonlist>
		<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li class="left" ref="left">
				<div style="min-width: 600px;margin-top: 2px">
					<el-button type="primary" size="mini" @click="BatchBalance_Click" :disabled="!btn.BatchBalance">{{ $t('getapi[5078]') }}</el-button>
					<el-button type="primary" size="mini" @click="BatchNoBalance_Click" :disabled="!btn.BatchNoBalance">{{ $t('getapi[5079]') }}</el-button>
					<el-button type="primary" size="mini" @click="taxDifImp">{{ $t('getapi[8910]') }}</el-button>
					<el-button type="primary" size="mini" @click="BatchUpdateSalInvVirtual" :disabled="!btn.BatchUpVirtual">{{ $t('getapi[12310]') }}</el-button>
					<el-button type="primary" size="mini" @click="cusDate">{{ $t('getapi[12843]') }}</el-button>
				</div>
				<wTable
					id="xpane-0"
					:data="dataSet"
					ref="singleTable"
					:loading="loading"
					queryData="SalInvoiceListViewInfo"
					:filter_language="['virtual_flag','BalanceMode_Name','Invoice_Status','Charge_Invoice_Flag','negative_flag','img','existfiles']"
					:filter_thousandth="['Tax_Dif_Amount','Customer_Remain_Amount','Net_Total_Amount','Total_Amount','Customer_Net_Total_Amount','Tax_Total_Amount']"
					:header="tableHeader"
					:option="tableOption"
					@handleSelectionChange="handleSelectionChange"
					@edits="edits"
					@rowdblclick="openEdit"
				></wTable>
			</li>
			<li class="resize" ref="resize">
				<i class="el-icon-caret-right" @click="leftt(0)"></i>
				<i class="el-icon-caret-left" @click="leftt(1)"></i>
			</li>
			<li class="mid" ref="mid">
				<div  style="float:right;position: relative;">
					<el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
				</div>
				<!---	明细页面	-->
				<div v-if="negative_flag == 0">
					<div>
						<div style="width:100%;display: flex">
							<el-button type="primary" size="mini" @click="RequestAudit" :disabled="!btn.mnuRequestAudit">{{ $t('getapi[3001]') }}</el-button>
							<el-button type="primary" size="mini" @click="RequestAudit_Cancel" :disabled="!btn.mnuRRequestAudit">
								{{ $t('getapi[3875]') }}
							</el-button>

							<el-button type="primary" size="mini" @click="beforeAuditPurInvoice" :disabled="!btn.mnuAudit">{{ $t('getapi[3876]') }}</el-button>
							<el-button type="primary" size="mini" @click="InvoiceAudit_Cancel" :disabled="!btn.mnuRAudit">{{ $t('getapi[3877]') }}</el-button>

							<el-button type="primary" size="mini" @click="InvoiceHook" :disabled="!btn.mnuBalance">{{ $t('getapi[1868]') }}</el-button>
							<el-button type="primary" size="mini" @click="InvoiceHook_Cancel" :disabled="!btn.mnuRBalance">{{ $t('getapi[1869]') }}</el-button>
							<el-button type="primary" size="mini" @click="beforeSetRatePurInvoice" :disabled="!btn.SetRate">{{ $t('getapi[3720]') }}</el-button>

							<el-button type="primary" size="mini" @click="beforeSetTaxRatePurInvoice" :disabled="!btn.SetTaxRate">{{ $t('getapi[7224]') }}</el-button>
							<el-button type="primary" size="mini" @click="beforeSetChangeTaxRatePurInvoice" :disabled="!btn.SetTaxRateBack">
								{{ $t('getapi[7225]') }}
							</el-button>

							<el-button type="primary" size="mini" @click="beforeChangeAuditDate" :disabled="!btn.editAuditDate">
								{{ $t('getapi[3722]') }}
							</el-button>

							<el-button type="primary" size="mini" @click="beforeChangeInvoiceNo" :disabled="!btn.mnuEditInvoice">
								{{ $t('getapi[3879]') }}
							</el-button>
							<el-button type="primary" size="mini" @click="proformaInovice" :disabled="!btn.mnuProforma">{{ $t('getapi[7258]') }}</el-button>
							<el-button type="primary" size="mini" @click="beforeChangeAuditDay" :disabled="$limits.fnIsEmpty(dataDetail.Head.Audit_Date)">{{ $t('getapi[8235]') }}</el-button>
							<el-button type="primary" size="mini" @click="beforeCusDueDate">{{ $t('getapi[12843]') }}</el-button>
						</div>
						<!-- <div style="margin-top:10px">
							<el-radio v-model="billmode" label="1" style="margin-left: 8px">整单模式</el-radio>
							<el-radio v-model="billmode" label="2">行模式</el-radio>
						</div> -->
						<div style="width:990px;min-width:990px">
							<table>
								<tr>
									<td style="width:60px;min-width:60px">{{ $t('getapi[2992]') }}</td>
									<td style="width:160px;min-width:160px"><el-input type="text" size="mini" v-model="dataDetail.Head.Invoice_No" :readonly="true" class="readO"></el-input></td>
									<td style="width:60px;min-width:60px">{{ $t('getapi[3682]') }}</td>
									<td style="width:160px;min-width:160px">
										<el-select filterable v-model="dataDetail.Head.Invoice_Type_Code" size="mini" :disabled="dataDetail.Head.Invoice_Status != 0">
											<el-option
													v-for="item in invoiceType"
													:key="item.Invoice_type_code"
													:label="item.Invoice_type_name"
													:value="item.Invoice_type_code"
													:disabled="dataDetail.Head.Invoice_Status != 0"
											></el-option>
										</el-select>
									</td>
									<td style="width:60px;min-width:60px">{{ $t('getapi[3861]') }}</td>
									<td style="width:160px;min-width:160px">
										<el-date-picker v-model="dataDetail.Head.Payment_Date" type="date" size="mini" style="width:100%" :readonly="true" class="readO"></el-date-picker>
									</td>
									<td style="width:60px;min-width:60px">{{ $t('getapi[3694]') }}</td>
									<td style="width:80px;min-width:80px"><el-input type="text" size="mini" :value="expStatus(dataDetail.Head.Invoice_Status)" :readonly="true" class="readO"></el-input></td>
									<td style="width:30px;min-width:30px">{{ $t('getapi[3287]') }}</td>
									<td style="width:160px;min-width:160px"><el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.Exchange_rate" :readonly="true" class="readO"></el-input></td>
								</tr>
								<tr>
									<td>{{ $t('getapi[3681]') }}</td>
									<td><el-input type="text" size="mini" v-model="dataDetail.Head.Invoice_Code" :readonly="dataDetail.Head.Invoice_Status != 0" :class="{'readO':dataDetail.Head.Invoice_Status != 0}"></el-input></td>
									<td>{{ $t('getapi[3683]') }}</td>
									<td>
										<el-date-picker
												v-model="dataDetail.Head.Invoice_Date"
												type="date"
												size="mini"
												value-format="yyyy-MM-dd"
												style="width:100%"
												:readonly="dataDetail.Head.Invoice_Status != 0"
												:class="{'readO':dataDetail.Head.Invoice_Status != 0}"
										></el-date-picker>
									</td>
									<td>{{ $t('getapi[1976]') }}</td>
									<td>
										<el-select filterable v-model="dataDetail.Head.Order_Type_Code" size="mini" :disabled="dataDetail.Head.Invoice_Status != 0">
											<el-option v-for="item in invoiceOrderType" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
										</el-select>
									</td>
									<td>{{ $t('getapi[3748]') }}</td>
									<td ><el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :value="dataDetail.Head.Total_Amount" :readonly="true" class="readO"></el-input></td>
									<td >
										<el-checkbox v-model="dataDetail.Head.Charge_Invoice_Flag" true-label="1" false-label="0" :disabled="true"></el-checkbox>
										{{ $t('getapi[3724]') }}
									</td>
									<td >
										<el-checkbox v-model="dataDetail.Head.e_invoice" true-label="1" false-label="0" :disabled="dataDetail.Head.Invoice_Status != 0"></el-checkbox>
										{{ $t('getapi[12667]') }}
									</td>
								</tr>
								<tr>
									<td>{{ $t('getapi[2610]') }}</td>
									<td>
										<routejump :urlNo="31" v-show="dataDetail.Head.Invoice_Status == 0">
										<el-input type="text" v-model="dataDetail.Head.Customer_Code" readonly class="mcolor" size="mini">
											<i class="el-icon-edit el-input__icon" slot="suffix" @click="selectSupplier()"></i>
										</el-input>
										</routejump>
										<el-input v-model="dataDetail.Head.Customer_Code" size="mini" v-show="dataDetail.Head.Invoice_Status != 0" :readonly="true" class="readO"></el-input>
									</td>
									<td>{{ $t('getapi[2958]') }}</td>
									<td colspan="3"><el-input type="text" size="mini" v-model="dataDetail.Head.Customer_Name" :readonly="true" class="readO"></el-input></td>
									<td>{{ $t('getapi[3704]') }}</td>
									<td ><el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.Tax_Total_Amount" :readonly="true" class="readO"></el-input></td>
									<td colspan="2">
										<el-checkbox v-model="dataDetail.Head.Negative_Flag" true-label="0" false-label="1" :disabled="true"></el-checkbox>
										{{ $t('getapi[2096]') }}
									</td>
								</tr>
								<tr>
									<td>{{ $t('getapi[3697]') }}</td>
									<td><el-input type="text" size="mini" v-model="dataDetail.Head.Audit_Period" :readonly="true" class="readO"></el-input></td>
									<td>{{ $t('getapi[3855]') }}</td>
									<td><el-input type="text" size="mini" v-model="dataDetail.Head.Request_No" :readonly="true" class="readO"></el-input></td>
									<td>{{ $t('getapi[3880]') }}</td>

									<td><el-input type="text" size="mini" :value="dataDetail.Head.DiffAmount" :readonly="true" class="readO"></el-input></td>

									<td>
										<el-checkbox
												v-model="dataDetail.Head.virtual_flag"
												true-label="1"
												false-label="0"
												:disabled="dataDetail.Head.Invoice_Status != 0 && dataDetail.Head.Invoice_Status != 6"
										></el-checkbox>
										{{ $t('getapi[3700]') }}

									</td>
									<td>
										<el-radio v-model="billmode" label="1" style="margin-left: 3px">{{ $t('getapi[3978]') }}</el-radio>
									</td>
									<td><el-radio v-model="billmode" label="2">{{ $t('getapi[3979]') }}</el-radio></td>
									<td v-if="dataDetail.Head.Invoice_Status == 0">
										<el-checkbox v-model="dataDetail.Head.ERD_Flag" true-label="1" false-label="0"></el-checkbox>
										{{ $t('getapi[13279]') }}
									</td>
								</tr>
								<tr>
									<td>{{ $t('getapi[3688]') }}</td>
									<td>
										<el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.remain_amount" :readonly="true" class="readO"></el-input>
									</td>
									<td>{{ $t('getapi[3689]') }}</td>
									<td>
										<el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.Customer_Remain_Amount" :readonly="true" class="readO"></el-input>
									</td>
									<td>{{ $t('getapi[6986]') }}</td>
									<td><el-input type="text"  v-model="dataDetail.Head.Customs_Dcl_Number"></el-input></td>
									<td>{{ $t('getapi[12601]') }}</td>
									<td><el-input type="text"  v-model="dataDetail.Head.waybill_number"></el-input></td>
									<td>{{ $t('getapi[12602]') }}</td>
									<td style="width:200px;">
										<el-date-picker
											v-model="dataDetail.Head.arrival_date"
											type="date"
											size="mini"
											value-format="yyyy-MM-dd"
											style="width:100%"
										></el-date-picker>
									</td>
								</tr>
								<tr>
									<td>{{ $t('getapi[7222]') }}</td>
									<td colspan="4"><el-input v-model="dataDetail.Head.InvoiceNumLst" type="text"></el-input></td>
									<td><el-button type="primary" size="mini" @click="ShowInvoiceNumLst"  :disabled="code==null || code==''" >{{ $t('getapi[7259]') }}</el-button></td>
									<td>{{ $t('getapi[8071]') }}</td>
									<td><el-input v-model="dataDetail.Head.remark" type="text"></el-input></td>
									<td>{{ $t('getapi[5120]') }}</td>
									<td>
										<el-date-picker
												v-model="dataDetail.Head.CusDue_Date"
												type="date"
												size="mini"
												value-format="yyyy-MM-dd"
												style="width:100%"
												:readonly="true" class="readO">
										></el-date-picker>
									</td>
								</tr>	
							</table>
						</div>
					</div>
					<el-tabs :tab-position="'top'" type="" style="margin-top:	0px" @tab-click="selectInfo">
						<el-tab-pane :label="$t('getapi[3726]')" name="0">
							<div>
								<el-button type="primary" size="mini" @click="showAddOrder('')" :disabled="!btn.batchadd">{{ $t('getapi[878]') }}</el-button>
								<el-button type="primary" size="mini" @click="batchDel_Click()" :disabled="!btn.batchdel">{{ $t('getapi[1522]') }}</el-button>
								<el-button type="primary" size="mini" @click="batchCreateInvoiceNo" :disabled="addoredit == 0">{{ $t('getapi[7260]') }}</el-button>
								<el-button type="primary" size="mini" @click="coverInvoice_No">{{ $t('getapi[12598]') }}</el-button>
								<el-button type="primary" size="mini" @click="coverBlankInvoice_No">{{ $t('getapi[13480]') }}</el-button>
							</div>
							<el-table
								id="xdetilpane-0"
								:data="dataDetail.Line"
								v-loading="dloading"
								@selection-change="handleSelectionChangeDetail"
								:row-class-name="tableRowClassNameDetail"
								:highlight-current-row="true"
								:height="tableHeight - 320"
								header-row-class-name="headerclass"
								border
								size="mini"
								style="width: 100%; margin-top:3px"
								@sort-change="sortChange"
								ref="singleTable1"
							>
								<el-table-column type="selection"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Line_No" :label="$t('getapi[1425]')" sortable="custom"></el-table-column>
								<el-table-column show-overflow-tooltip prop="sal_code" :label="$t('getapi[3884]')" width="120" sortable="custom"></el-table-column>
								<el-table-column prop="Issue_Order_No" :label="$t('getapi[3867]')" width="150" sortable="custom">
									<template scope="scope" v-if="dataDetail.Head.Invoice_Status == 0">
										<el-input v-model="scope.row.Issue_Order_No" type="text" readonly class="mcolor" size="mini">
											<i class="el-icon-edit el-input__icon" slot="suffix" @click="showAddOrder(scope)"></i>
										</el-input>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="Issue_Order_Line_No" :label="$t('getapi[3868]')" sortable="custom"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Part_Code" :label="$t('getapi[112]')" sortable="custom"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Part_Version" :label="$t('getapi[149]')" sortable="custom"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Part_Name" :label="$t('getapi[116]')" width="150" sortable="custom"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Part_Model" :label="$t('getapi[124]')" sortable="custom"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Part_Spec" :label="$t('getapi[125]')" sortable="custom"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Already_Invoice_Qty" :label="$t('getapi[2004]')" align="right" sortable="custom"></el-table-column>
								<el-table-column prop="Invoice_Qty" :label="$t('getapi[1628]')" align="right" sortable="custom">
									<template scope="scope" v-if="dataDetail.Head.Invoice_Status == 0">
										<el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Invoice_Qty" @change="sums(scope, 0)"></el-input>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="Measure_Unit" :label="$t('getapi[888]')" sortable="custom"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Customer_Net_Unit_Price" :label="$t('getapi[2009]')" align="right" width="120" sortable="custom" >
                                    <template scope="scope">
                                        <span v-if="scope.row.baseprice_flag == 0">{{scope.row.Customer_Net_Unit_Price}}</span>
                                        <span v-if="scope.row.baseprice_flag != 0">{{(parseFloat(scope.row.Customer_Unit_Price) / parseFloat(1+dataDetail.Head.Tax_rate/100)).toFixed(6)}}</span>
                                    </template>
                                </el-table-column>
								<el-table-column prop="Customer_Unit_Price" :label="$t('getapi[2011]')" align="right" width="120" sortable="custom" >
									<template scope="scope">
                                        <span v-if="scope.row.baseprice_flag == 0">{{(parseFloat(scope.row.Customer_Net_Unit_Price) * parseFloat(1+dataDetail.Head.Tax_rate/100)).toFixed(6)}}</span>
                                        <span v-if="scope.row.baseprice_flag != 0">{{scope.row.Customer_Unit_Price}}</span>
									</template>
								</el-table-column>
								<el-table-column prop="Customer_Line_Net_Total_Amount" :label="$t('getapi[2010]')" align="right" width="120" sortable="custom" >
									<template scope="scope" v-if="dataDetail.Head.Invoice_Status == 0 && IsEditPriceTaxHJ==0">
										<el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Customer_Line_Net_Total_Amount" @change="sums(scope, 1)"></el-input>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="Net_Unit_Price" :label="$t('getapi[2007]')" align="right" width="120" sortable="custom" >
                                    <template scope="scope">
                                        <span v-if="scope.row.baseprice_flag == 0">{{scope.row.Net_Unit_Price}}</span>
                                        <span v-if="scope.row.baseprice_flag != 0">{{(parseFloat(scope.row.Unit_Price) / parseFloat(1+dataDetail.Head.Tax_rate/100)).toFixed(6)}}</span>
                                    </template>
                                </el-table-column>
								<el-table-column prop="Unit_Price" :label="$t('getapi[3744]')" align="right" width="120" sortable="custom" >
									<template scope="scope">
                                        <span v-if="scope.row.baseprice_flag == 0">{{(parseFloat(scope.row.Net_Unit_Price) * parseFloat(1+dataDetail.Head.Tax_rate/100)).toFixed(6)}}</span>
                                        <span v-if="scope.row.baseprice_flag != 0">{{scope.row.Unit_Price}}</span>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="Line_Net_Total_Amount" :label="$t('getapi[2008]')" align="right" width="120" sortable="custom" ></el-table-column>
								<el-table-column prop="Tax_Amount" :label="$t('getapi[3732]')" align="right" width="120" sortable="custom">
									<template scope="scope" v-if="dataDetail.Head.Invoice_Status == 0">
										<el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Tax_Amount" @change="calcAmount(scope, 2)"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="Line_Total_Amount" :label="$t('getapi[3733]')" align="right" width="120" sortable="custom">
									<template scope="scope" v-if="IsEditPriceTaxHJ == 1">
										<el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Line_Total_Amount" @change="pricetaxhj(scope, 1)"></el-input>
									</template>
								</el-table-column>

								<!-- <el-table-column show-overflow-tooltip prop="Line_Total_Amount" :label="$t('getapi[3733]')" align="right" width="120" sortable ></el-table-column> -->
								<el-table-column prop="Line_Remark" :label="$t('getapi[4279]')" sortable="custom">
									<template scope="scope">
										<el-input size="mini" v-model="scope.row.Line_Remark"></el-input>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="Cust_Part" :label="$t('getapi[2390]')" align="right" sortable="custom"></el-table-column>
								<el-table-column show-overflow-tooltip prop="备注" :label="$t('getapi[7963]')" align="right" sortable="custom">
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="remark2" :label="$t('getapi[7962]')" align="right" sortable="custom">
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="b_line_net_total_amount" :label="$t('getapi[3885]')" align="right" width="120" sortable="custom" ></el-table-column>
								<el-table-column prop="Base_Net_Amount_Diff" :label="$t('getapi[3865]')" align="right" sortable="custom">
									<template scope="scope">
										{{ scope.row.Base_Net_Amount_Diff | tofixed2 }}
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="Contract_info" :label="$t('getapi[3915]')" align="right" sortable="custom"></el-table-column>
								<el-table-column show-overflow-tooltip prop="customer_item" :label="$t('getapi[2707]')" align="right" sortable="custom"></el-table-column>
								<el-table-column prop="negative_flag" :label="$t('getapi[2096]')" align="right" sortable="custom">
									<template scope="scope">
										<span>{{ scope.row.negative_flag | lanchange}}</span>
									</template>
								</el-table-column>
								<el-table-column prop="Proforma_Invoice_No" label="Invoice No" align="right" sortable="custom" width="120">
									<template scope="scope" v-if="dataDetail.Head.Invoice_Status == 0 || btn.EditInvoiceNo">
										<el-input v-model="scope.row.Proforma_Invoice_No" type="text" ></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="Issue_Part_Flow" :label="$t('getapi[12533]')" align="right" sortable="custom">
									<template scope="scope">
										<span :value="scope.row.Issue_Part_Flow == 0?$t('getapi[2053]'):$t('getapi[2052]')" type="text" ></span>
									</template>
								</el-table-column>
							</el-table>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[3887]')" name="1">
							<table :height="tableHeight - 300">
								<table>
									<tr>
										<td style="width:60px;min-width:60px">{{ $t('getapi[1228]') }}</td>
										<td style="width:120px;min-width:120px">
											<el-select filterable v-model="dataDetail.Head.Balance_Mode" size="mini" disabled>
												<el-option v-for="item in balanceMode" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
											</el-select>
										</td>
										<td style="width:60px;min-width:60px">{{ $t('getapi[1221]') }}</td>
										<td style="width:120px;min-width:120px"><el-input v-model="dataDetail.Head.Payment_period" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input></td>
										<td>{{ $t('getapi[3740]') }}</td>
										<td><el-input v-model="dataDetail.Head.Currency_Code" size="mini" :readonly="true" class="readO"></el-input></td>
										<!-- <td style="width:60px">{{ $t('getapi[1249]')	}}</td>
										<td	style="width:120px"><el-input	v-model="dataDetail.Head.Tax_code" size="mini" :disabled="true"></el-input></td>
										<td	style="width:60px">{{	$t('getapi[1225]') }}</td>
										<td	style="width:120px"><el-input	v-model="dataDetail.Head.Tax_rate" type="number" autocomplete="off" title="" size="mini" :disabled="true"></el-input></td> -->
									</tr>
									<!-- <tr>
										<td>{{ $t('getapi[3740]')	}}</td>
										<td><el-input	v-model="dataDetail.Head.Currency_Code"	size="mini"	:disabled="true"></el-input></td>
										<td>{{ $t('getapi[1219]')	}}</td>
										<td><el-input	v-model="dataDetail.Head.bank_account_name"	size="mini"	:disabled="true"></el-input></td>
										<td>{{ $t('getapi[1220]')	}}</td>
										<td	colspan="3"><el-input	v-model="dataDetail.Head.bank_account_number"	size="mini"	:disabled="true"></el-input></td>
									</tr>
									<tr>
										<td>{{ $t('getapi[1224]')	}}</td>
										<td><el-input	v-model="dataDetail.Head.tax_number" size="mini" :disabled="true"></el-input></td>
									</tr>	-->
								</table>
							</table>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[3741]')" name="2">
							<div>
								<el-button type="primary" size="mini" @click="showAddOrders('')" :disabled="!btn.batchaddcost">{{ $t('getapi[6708]') }}</el-button>
								<el-button type="primary" size="mini" @click="batchDelOtherCostLine" :disabled="!btn.batchdelcost">{{ $t('getapi[4097]') }}</el-button>
							</div>
							<el-table
								id="xdetilpane-2"
								:data="dataDetail.OtherCostLine"
								:highlight-current-row="true"
								show-overflow-tooltip="true"
								:height="tableHeight - 320"
								header-row-class-name="headerclass"
								@selection-change="handleSelectionChangeDetailCost"
								:row-class-name="tableRowClassNameDetailCost"
								border
								stripe
								size="mini"
								style="width:	100%;margin-top:3px"
								ref="singleTable2"
							>
								<el-table-column type="selection"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Line_No" :label="$t('getapi[1425]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Charge_Name" :label="$t('getapi[2728]')"></el-table-column>
								<el-table-column prop="CO_Code" width="210" :label="$t('getapi[2291]')">
									<template scope="scope" v-if="dataDetail.Head.Invoice_Status == 0">
										<el-input v-model="scope.row.CO_Code" type="text" readonly class="mcolor" size="mini">
											<i class="el-icon-edit el-input__icon" slot="suffix" @click="showAddOrders(scope)"></i>
										</el-input>
									</template>
								</el-table-column>
								<el-table-column prop="Sale_Discount" :label="$t('getapi[12342]')">
									<template scope="scope">
										<!--{{scope.row.Sale_Discount == true?$t('getapi[561]'):$t('getapi[866]')}}-->
										<el-checkbox v-model="scope.row.Sale_Discount"></el-checkbox>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="CO_Line_No" :label="$t('getapi[1586]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Charge_Qty" :label="$t('getapi[3101]')">
									<template scope="scope">
										{{(dataDetail.Head.ERD_Flag == 1 && (scope.row.Charge_Name.includes('视同内销') || scope.row.Charge_Name.includes('汇率差')))?'':scope.row.Charge_Qty}}
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="Net_Unit_Price" :label="$t('getapi[3714]')">
									<template scope="scope">
										{{(dataDetail.Head.ERD_Flag == 1 && (scope.row.Charge_Name.includes('视同内销') || scope.row.Charge_Name.includes('汇率差')))?'':scope.row.Net_Unit_Price}}
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="Unit_Price" :label="$t('getapi[3806]')">
									<template scope="scope">
										{{(dataDetail.Head.ERD_Flag == 1 && (scope.row.Charge_Name.includes('视同内销') || scope.row.Charge_Name.includes('汇率差')))?'':scope.row.Unit_Price}}
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="Net_Total_Amount" :label="$t('getapi[2010]')">
									<template scope="scope">
										<span v-if="(dataDetail.Head.ERD_Flag == 1 && (scope.row.Charge_Name.includes('视同内销') || scope.row.Charge_Name.includes('汇率差')))"> </span>
										<el-input size="mini" type="text" v-model="scope.row.Net_Total_Amount" v-else-if="dataDetail.Head.Invoice_Status == 0 && scope.row.after_flag == 'Y'" @change="getPriceWithAfterFlag(scope)"></el-input>
										<span v-else>{{scope.row.Net_Total_Amount}}</span>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="Total_Amount" :label="$t('getapi[2012]')">
									<template scope="scope">
										{{(dataDetail.Head.ERD_Flag == 1 && (scope.row.Charge_Name.includes('视同内销') || scope.row.Charge_Name.includes('汇率差')))?'':scope.row.Total_Amount}}
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="Base_Net_Unit_Price" :label="$t('getapi[2007]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Base_Unit_Price" :label="$t('getapi[3744]')">
									<template scope="scope">
										<span>{{scope.row.Base_Unit_Price}}</span>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="Base_Net_Total_Amount" :label="$t('getapi[2008]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Base_Total_Amount" :label="$t('getapi[3745]')"></el-table-column>
								<el-table-column prop="Proforma_Invoice_No" label="Invoice No">
									<template scope="scope" v-if="dataDetail.Head.Invoice_Status == 0 || btn.EditInvoiceNo">
										<el-input size="mini" type="text" v-model="scope.row.Proforma_Invoice_No"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="remark" :label="$t('getapi[143]')">
									<template scope="scope" v-if="dataDetail.Head.Invoice_Status == 0">
										<el-input size="mini" type="text" v-model="scope.row.remark"></el-input>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="Customer_Order" :label="$t('getapi[2693]')"></el-table-column>
							</el-table>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[7227]')" name="3">
							<table :height="tableHeight - 300" v-if="!showpdf">
								<div style="height:100%;overflow-y:	auto" class="demo-image__lazy">
									<el-image v-for="data in dataDetail.Imgs" :key="data.Invoice_No" :src="data.HttpFilePath"></el-image>
								</div>
							</table>
							<div :height="tableHeight - 300" class="pdf" v-if="showpdf">
								<iframe v-bind:src="src" width="100%" :height="tableHeight - 300"></iframe>
							</div>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[6487]')" name="4">
							<el-upload
								class="upload-demo"
								ref="upload"
								:action="uploadurl"
								:on-preview="handlePreview"
								:on-remove="handleRemove"
								:on-change="handleChange"
								:on-success="handleSuccess"
								:on-error="handleError"
								:before-upload="beforeAvatarUpload"
								:file-list="fileList3"
								:data="fileparm"
								:limit="1000"
							>
								<el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6422]')}}</el-button>
								<div slot="tip" class="el-upload__tip"></div>
							</el-upload>
							<el-table
								id="xdetilpane-4"
								:data="dataDetail.Files"
								v-loading="loading"
								:height="tableHeight - 320"
								:highlight-current-row="false"
								show-overflow-tooltip="true"
								border
								stripe
								size="mini"
								header-row-class-name="headerclass"
							>
								<el-table-column show-overflow-tooltip prop="Node_Name" :label="$t('getapi[3590]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Doc_Type" :label="$t('getapi[6423]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Doc_Size" :label="$t('getapi[7875]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Upload_Person" :label="$t('getapi[6425]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Upload_Time" :label="$t('getapi[6426]')"></el-table-column>
								<el-table-column prop="operate" :label="$t('getapi[6048]')">
									<template slot-scope="scope">
										<el-button @click.native.prevent="open(scope)" type="text" size="mini">{{$t('getapi[7261]')}}</el-button>
										<el-button @click.native.prevent="filedel(scope)" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-tab-pane>
					</el-tabs>
					<div style="width:960px;min-width:960px">
						<table>
							<tr>
								<td style="width:100px;min-width:100px">{{ $t('getapi[1890]') }}</td>
								<td style="width:140px;min-width:140px"><el-input v-model="dataDetail.Head.Create_Person" size="mini" :readonly="true" class="readO"></el-input></td>
								<td style="width:100px;min-width:100px">{{ $t('getapi[4043]') }}</td>
								<td style="width:140px;min-width:140px"><el-input v-model="dataDetail.Head.Audit_Person" size="mini" :readonly="true" class="readO"></el-input></td>
								<td style="width:100px;min-width:100px">{{ $t('getapi[733]') }}</td>
								<td style="width:140px;min-width:140px"><el-input v-model="dataDetail.Head.Modify_Person" type="text" size="mini" :readonly="true" class="readO"></el-input></td>
								<td style="width:100px;min-width:100px">{{ $t('getapi[3749]') }}</td>
								<td style="width:140px;min-width:140px"><el-input v-model="dataDetail.Head.Net_Total_Amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input></td>
							</tr>
							<tr>
								<td>{{ $t('getapi[1859]') }}</td>
								<td>
									<el-date-picker v-model="dataDetail.Head.Create_Date" type="date" size="mini" style="width:100%" :readonly="true" class="readO"></el-date-picker>
								</td>
								<td>{{ $t('getapi[3692]') }}</td>
								<td>
									<el-date-picker v-model="dataDetail.Head.Audit_Date" type="date" size="mini" style="width:100%" :readonly="true" class="readO"></el-date-picker>
								</td>
								<td>{{ $t('getapi[734]') }}</td>
								<td>
									<el-date-picker v-model="dataDetail.Head.Modify_Time" type="date" size="mini" style="width:100%" :readonly="true" class="readO"></el-date-picker>
								</td>
								<td>{{ $t('getapi[3746]') }}</td>
								<td><el-input v-model="dataDetail.Head.Customer_Net_Total_Amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input></td>
							</tr>
							<tr>
								<td>{{ $t('getapi[3882]') }}</td>
								<td>
									<el-input v-model="dataDetail.Head.Request_Person" type="text" size="mini" :readonly="true" class="readO"></el-input>
								</td>
								<td>{{ $t('getapi[3881]') }}</td>
								<td>
									<el-date-picker
										v-model="dataDetail.Head.Request_Date"
										type="date"
										size="mini"
										style="width:100%"
										:readonly="true" class="readO"
									></el-date-picker>
								</td>
								<td>{{ $t('getapi[12902]') }}</td>
								<td><el-input v-model="dataDetail.Head.Customer_Total_Amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input></td>
							</tr>
						</table>
					</div>
				</div>
				<div v-else-if="negative_flag == 1">
					<div>
						<div style="width:100%;display: flex">
							<el-button type="primary" size="mini" @click="RequestAudit" :disabled="!btn.mnuRequestAudit">{{ $t('getapi[3001]') }}</el-button>
							<el-button type="primary" size="mini" @click="RequestAudit_Cancel" :disabled="!btn.mnuRRequestAudit">
								{{ $t('getapi[3875]') }}
							</el-button>

							<el-button type="primary" size="mini" @click="beforeAuditPurInvoice" :disabled="!btn.mnuAudit">{{ $t('getapi[3876]') }}</el-button>
							<el-button type="primary" size="mini" @click="InvoiceAudit_Cancel" :disabled="!btn.mnuRAudit">{{ $t('getapi[3877]') }}</el-button>

							<el-button type="primary" size="mini" @click="InvoiceHook" :disabled="!btn.mnuBalance">{{ $t('getapi[1868]') }}</el-button>
							<el-button type="primary" size="mini" @click="InvoiceHook_Cancel" :disabled="!btn.mnuRBalance">{{ $t('getapi[1869]') }}</el-button>
							<el-button type="primary" size="mini" @click="beforeSetRatePurInvoice" :disabled="!btn.SetRate">{{ $t('getapi[3720]') }}</el-button>

							<el-button type="primary" size="mini" @click="beforeSetTaxRatePurInvoice" :disabled="!btn.SetTaxRate">{{ $t('getapi[7224]') }}</el-button>
							<el-button type="primary" size="mini" @click="beforeSetChangeTaxRatePurInvoice" :disabled="!btn.SetTaxRateBack">
								{{ $t('getapi[7225]') }}
							</el-button>

							<el-button type="primary" size="mini" @click="beforeChangeAuditDate" :disabled="!btn.editAuditDate">
								{{ $t('getapi[3722]') }}
							</el-button>

							<el-button type="primary" size="mini" @click="beforeChangeInvoiceNo" :disabled="!btn.mnuEditInvoice">
								{{ $t('getapi[3879]') }}
							</el-button>
							<el-button type="primary" size="mini" @click="beforeChangeAuditDay" :disabled="$limits.fnIsEmpty(dataDetailRed.Head.audit_date)">{{ $t('getapi[8235]') }}</el-button>
						</div>
						<!-- 	<div style="margin-top:10px">
							<el-radio v-model="billmode" label="1" style="margin-left: 8px">整单模式</el-radio>
							<el-radio v-model="billmode" label="2">行模式</el-radio>
						</div> -->
						<div style="width:990px;min-width:990px">
							<table>
							<tr>
								<td style="width:60px;min-width:60px">{{ $t('getapi[2992]') }}</td>
								<td style="width:160px;min-width:160px"><el-input type="text" size="mini" v-model="dataDetailRed.Head.invoice_no" :readonly="true" class="readO"></el-input></td>
								<td style="width:60px;min-width:60px">{{ $t('getapi[3682]') }}</td>
								<td style="width:160px;min-width:160px">
									<el-select filterable v-model="dataDetailRed.Head.invoice_type_code" size="mini" :disabled="dataDetailRed.Head.invoice_status != 0">
										<el-option
											v-for="item in invoiceType"
											:key="item.Invoice_type_code"
											:label="item.Invoice_type_name"
											:value="item.Invoice_type_code"
											:disabled="dataDetailRed.Head.invoice_status != 0"
										></el-option>
									</el-select>
								</td>
								<td style="width:60px;min-width:60px">{{ $t('getapi[3861]') }}</td>
								<td style="width:160px;min-width:160px">
									<el-date-picker v-model="dataDetailRed.Head.payment_date" type="date" size="mini" style="width:100%" :readonly="true" class="readO"></el-date-picker>
								</td>
								<td style="width:60px;min-width:60px">{{ $t('getapi[3694]') }}</td>
								<td style="width:80px;min-width:80px"><el-input type="text" size="mini" :value="expStatus(dataDetailRed.Head.invoice_status)" :readonly="true" class="readO"></el-input></td>
								<td style="width:30px;min-width:30px">{{ $t('getapi[3287]') }}</td>
								<td style="width:160px;min-width:160px"><el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetailRed.Head.exchange_rate" :readonly="true" class="readO"></el-input></td>
							</tr>
							<tr>
								<td>{{ $t('getapi[3681]') }}</td>
								<td><el-input type="text" size="mini" v-model="dataDetailRed.Head.invoice_code" :readonly="dataDetailRed.Head.invoice_status != 0" :class="{'readO':dataDetailRed.Head.invoice_status != 0}"></el-input></td>
								<td>{{ $t('getapi[3683]') }}</td>
								<td>
									<el-date-picker
										v-model="dataDetailRed.Head.invoice_date"
										type="date"
										size="mini"
										value-format="yyyy-MM-dd"
										style="width:100%"
										:readonly="dataDetailRed.Head.invoice_status != 0"
										:class="{'readO':dataDetailRed.Head.invoice_status != 0}"
									></el-date-picker>
								</td>
								<td>{{ $t('getapi[1976]') }}</td>
								<td>
									<el-select filterable v-model="dataDetailRed.Head.order_type_code" size="mini" :disabled="dataDetailRed.Head.invoice_status != 0">
										<el-option v-for="item in invoiceOrderType" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
									</el-select>
								</td>
								<td>{{ $t('getapi[3748]') }}</td>
								<td><el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :value="dataDetailRed.Head.total_amount" :readonly="true" class="readO"></el-input></td>
								<td>
									<el-checkbox v-model="dataDetailRed.Head.charge_invoice_flag" true-label="1" false-label="0" :disabled="true"></el-checkbox>
									{{ $t('getapi[3724]') }}
								</td>
								<td>
									<el-checkbox v-model="dataDetailRed.Head.e_invoice" true-label="1" false-label="0" :disabled="dataDetailRed.Head.Invoice_Status != 0"></el-checkbox>
									{{ $t('getapi[12667]') }}
								</td>
							</tr>
							<tr>
								<td>{{ $t('getapi[2610]') }}</td>
								<td>
									<routejump :urlNo="31" v-show="dataDetailRed.Head.invoice_status == 0">
									<el-input
										type="text"
										v-model="dataDetailRed.Head.customer_code"
										readonly
										class="mcolor"
										size="mini"
									>
										<i class="el-icon-edit el-input__icon" slot="suffix" @click="selectSupplierred()"></i>
									</el-input>
									</routejump>
									<el-input v-model="dataDetailRed.Head.customer_code" size="mini" v-show="dataDetailRed.Head.invoice_status != 0" :readonly="true" class="readO"></el-input>
								</td>
								<td>{{ $t('getapi[2958]') }}</td>
								<td colspan="3"><el-input type="text" size="mini" v-model="dataDetailRed.Head.customer_name" :readonly="true" class="readO"></el-input></td>
								<td>{{ $t('getapi[3704]') }}</td>
								<td><el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetailRed.Head.tax_total_amount" :readonly="true" class="readO"></el-input></td>
								<td colspan="2">
									<el-checkbox v-model="dataDetailRed.Head.negative_flag" true-label="1" false-label="0" :disabled="true"></el-checkbox>
									{{ $t('getapi[2096]') }}
								</td>
							</tr>
							<tr>
								<td>{{ $t('getapi[3697]') }}</td>
								<td><el-input type="text" size="mini" v-model="dataDetailRed.Head.audit_period" :readonly="true" class="readO"></el-input></td>
								<td>{{ $t('getapi[3855]') }}</td>
								<td><el-input type="text" size="mini" v-model="dataDetailRed.Head.request_no" :readonly="true" class="readO"></el-input></td>
								<td>{{ $t('getapi[3880]') }}</td>

								<td><el-input type="text" size="mini" :value="dataDetailRed.Head.diffAmount" :readonly="true" class="readO"></el-input></td>

								<td>
									<el-checkbox
										v-model="dataDetailRed.Head.virtual_flag"
										true-label="1"
										false-label="0"
										:disabled="dataDetailRed.Head.invoice_status != 0"
									></el-checkbox>
									{{ $t('getapi[3700]') }}
								</td>
							</tr>
							<tr>
								<td>{{ $t('getapi[3688]') }}</td>
                                <td>
                                    <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.remain_amount" :readonly="true" class="readO"></el-input>
                                </td>
								<td>{{ $t('getapi[3689]') }}</td>
								<td>
                                    <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.customer_remain_amount" :readonly="true" class="readO"></el-input>
                                </td>
								<td>{{ $t('getapi[6986]') }}</td>
								<td><el-input type="text"  v-model="dataDetail.Head.Customs_Dcl_Number"></el-input></td>
								<td>{{ $t('getapi[12601]') }}</td>
								<td><el-input type="text"  v-model="dataDetail.Head.waybill_number"></el-input></td>
								<td>{{ $t('getapi[12602]') }}</td>
								<td style="width:130px;">
									<el-date-picker
										v-model="dataDetail.Head.arrival_date"
										type="date"
										size="mini"
										value-format="yyyy-MM-dd"
										style="width:100%"
									></el-date-picker>
								</td>
							</tr>
							<tr>
								<td>{{ $t('getapi[7222]') }}</td>
								<td colspan="4"><el-input v-model="dataDetailRed.Head.invoicenumlst" type="text" ></el-input></td>
								<td><el-button type="primary" size="mini" @click="ShowInvoiceNumLst" :disabled="code==null || code==''" >{{ $t('getapi[7259]') }}</el-button></td>
								<td>{{ $t('getapi[8071]') }}</td>
								<td colspan="5"><el-input v-model="dataDetailRed.Head.remark" type="text"></el-input></td>
							</tr>
						</table>
						</div>
					</div>
					<el-tabs :tab-position="'top'" type="" style="margin-top:	0px" @tab-click="selectInfo">
						<el-tab-pane :label="$t('getapi[3726]')" name="10">
							<div>
								<el-button type="primary" size="mini" @click="showAddOrderRed('')" :disabled="!btn.batchadd">{{ $t('getapi[878]') }}</el-button>
								<el-button type="primary" size="mini" @click="batchDelRed()" :disabled="!btn.batchdel">{{ $t('getapi[1522]') }}</el-button>
								<el-button type="primary" size="mini" @click="batchCreateInvoiceNoRed" :disabled="addoredit == 0">{{ $t('getapi[7260]') }}</el-button>
								<el-button type="primary" size="mini" @click="coverInvoice_NoRed">{{ $t('getapi[12598]') }}</el-button>
								<el-button type="primary" size="mini" @click="coverBlankInvoice_NoRed">{{ $t('getapi[13480]') }}</el-button>
							</div>
							<el-table
								id="xdetilpane-10"
								:data="dataDetailRed.Lists"
								v-loading="dloading"
								@selection-change="handleSelectionChangeDetailRed"
								:row-class-name="tableRowClassNameDetail"
								:highlight-current-row="true"
								:height="tableHeight - 400"
								header-row-class-name="headerclass"
								border
								size="mini"
								style="width: 100%; margin-top:3px"
								ref="singleTable3"
							>
								<el-table-column type="selection"></el-table-column>
								<el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')" sortable></el-table-column>
								<el-table-column show-overflow-tooltip prop="customer_order" :label="$t('getapi[3884]')" width="120" sortable></el-table-column>
								<el-table-column prop="issue_order_no" :label="$t('getapi[3867]')" width="150" sortable>
									<template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0">
										<el-input v-model="scope.row.issue_order_no" type="text" readonly class="mcolor" size="mini">
											<i class="el-icon-edit el-input__icon" slot="suffix" @click="showAddOrder(scope)"></i>
										</el-input>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="issue_order_line_no" :label="$t('getapi[3868]')" sortable></el-table-column>
								<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" sortable></el-table-column>
								<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" sortable></el-table-column>
								<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')" sortable></el-table-column>
								<el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')" sortable></el-table-column>
								<el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')" sortable></el-table-column>
								<el-table-column show-overflow-tooltip prop="already_invoice_qty" :label="$t('getapi[2004]')" align="right" sortable></el-table-column>
								<el-table-column prop="invoice_qty" :label="$t('getapi[1628]')" align="right" sortable>
									<template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0">
										<el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.invoice_qty" @change="sums(scope, 0)"></el-input>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[888]')" width="120" sortable></el-table-column>
								<el-table-column show-overflow-tooltip prop="customer_net_unit_price" :label="$t('getapi[2009]')" align="right" width="120" sortable>
                                    <template scope="scope">
                                        <span>{{scope.row.customer_net_unit_price}}</span>
                                    </template>
                                </el-table-column>
								<el-table-column show-overflow-tooltip prop="customer_unit_price" :label="$t('getapi[2011]')" align="right" width="120" sortable>
									<template scope="scope">
										<span>{{scope.row.customer_unit_price}}</span>
									</template>
								</el-table-column>
								<el-table-column prop="customer_line_net_total_amount" :label="$t('getapi[2010]')" align="right" width="120" sortable>
									<template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0">
										<el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.customer_line_net_total_amount" @change="sums(scope, 1)"></el-input>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="net_unit_price" :label="$t('getapi[2007]')" align="right" width="120" sortable>
                                    <template scope="scope">
                                        <span>{{scope.row.net_unit_price}}</span>
                                    </template>
                                </el-table-column>
								<el-table-column show-overflow-tooltip prop="unit_price" :label="$t('getapi[3744]')" align="right" width="120" sortable>
									<template scope="scope">
										<span>{{scope.row.unit_price}}</span>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="line_net_total_amount" :label="$t('getapi[2008]')" align="right" width="120" sortable></el-table-column>
								<el-table-column prop="tax_amount" :label="$t('getapi[3732]')" align="right" width="120" sortable>
									<template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0">
										<el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.tax_amount" @change="sums(scope, 2)"></el-input>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="line_total_amount" :label="$t('getapi[3733]')" align="right" sortable></el-table-column>
								<el-table-column prop="remark" :label="$t('getapi[4279]')" sortable>
									<template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0">
										<el-input size="mini" v-model="scope.row.remark"></el-input>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="cust_part" :label="$t('getapi[2390]')" align="right" sortable></el-table-column>
								<el-table-column show-overflow-tooltip prop="line_remark" :label="$t('getapi[3870]')" align="right" sortable></el-table-column>
								<el-table-column show-overflow-tooltip prop="order_line_total_amount" :label="$t('getapi[3885]')" align="right" sortable></el-table-column>
								<el-table-column show-overflow-tooltip prop="diff_amount" :label="$t('getapi[3865]')" align="right" sortable></el-table-column>
								<el-table-column show-overflow-tooltip prop="contract_info" :label="$t('getapi[3915]')" sortable>
									<template scope="scope">
										<span>{{ scope.row.contract_info}}</span>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="customer_item" :label="$t('getapi[2707]')" align="right" sortable></el-table-column>
								<el-table-column prop="negative_flag" :label="$t('getapi[2096]')" align="right" sortable>
									<template scope="scope">
										<span>{{ scope.row.negative_flag | lanchange}}</span>
									</template>
								</el-table-column>
								<el-table-column prop="proforma_invoice_no" label="Invoice No" align="right" sortable="custom" width="120">
									<template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0 || btn.EditInvoiceNo">
										<el-input v-model="scope.row.proforma_invoice_no" type="text" ></el-input>
									</template>
								</el-table-column>
								<!-- <el-table-column show-overflow-tooltip prop="invoice_no" label="Invoice	No" align="right" sortable></el-table-column> -->
								<el-table-column prop="Issue_Part_Flow" :label="$t('getapi[12533]')" align="right" sortable="custom">
									<template scope="scope">
										<span :value="scope.row.Issue_Part_Flow == 0?$t('getapi[2053]'):$t('getapi[2052]')" type="text" ></span>
									</template>
								</el-table-column>
							</el-table>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[3887]')" name="11">
							<table :height="tableHeight - 380">
								<table>
									<tr>
										<td style="width:60px;min-width:60px">{{ $t('getapi[1228]') }}</td>
										<td style="width:120px;min-width:120px">
											<el-select filterable v-model="dataDetailRed.Head.balance_mode" size="mini" disabled>
												<el-option v-for="item in balanceMode" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
											</el-select>
										</td>
										<td style="width:60px;min-width:60px">{{ $t('getapi[1221]') }}</td>
										<td style="width:120px;min-width:120px"><el-input v-model="dataDetailRed.Head.payment_period" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input></td>
										<td>{{ $t('getapi[3740]') }}</td>
										<td><el-input v-model="dataDetailRed.Head.currency_code" size="mini" :readonly="true" class="readO"></el-input></td>
									</tr>
								</table>
							</table>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[7227]')" name="12">
							<table :height="tableHeight - 380" v-if="!showpdf">
								<div style="height:100%;overflow-y:	auto" class="demo-image__lazy" >
									<el-image v-for="data in dataDetailRed.ImgLists" :key="data.Invoice_No" :src="data.HttpFilePath"></el-image>
								</div>
							</table>
							<div :height="tableHeight - 380" class="pdf" v-if="showpdf">
								<iframe v-bind:src="src" width="100%" :height="tableHeight - 380"></iframe>
							</div>
						</el-tab-pane>
					</el-tabs>
					<div>
						<table>
							<tr>
								<td style="width:100px;min-width:100px">{{ $t('getapi[1890]') }}</td>
								<td style="width:140px;min-width:140px"><el-input v-model="dataDetailRed.Head.create_person" size="mini" :readonly="true" class="readO"></el-input></td>
								<td style="width:100px;min-width:100px">{{ $t('getapi[4043]') }}</td>
								<td style="width:140px;min-width:140px"><el-input v-model="dataDetailRed.Head.audit_person" size="mini" :readonly="true" class="readO"></el-input></td>
								<!-- <td style="width:100px">{{ $t('getapi[733]') }}</td>
								<td style="width:140px"><el-input v-model="dataDetailRed.Head.modify_person" type="number" autocomplete="off" title="" size="mini" :disabled="true"></el-input></td> -->
								<td style="width:100px;min-width:100px">{{ $t('getapi[3749]') }}</td>
								<td style="width:140px;min-width:140px"><el-input v-model="dataDetailRed.Head.net_total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input></td>
							</tr>
							<tr>
								<td>{{ $t('getapi[1859]') }}</td>
								<td>
									<el-date-picker v-model="dataDetailRed.Head.create_date" type="date" size="mini" style="width:100%" :readonly="true" class="readO"></el-date-picker>
								</td>
								<td>{{ $t('getapi[3692]') }}</td>
								<td>
									<el-date-picker v-model="dataDetailRed.Head.audit_date" type="date" size="mini" style="width:100%" :readonly="true" class="readO"></el-date-picker>
								</td>
								<!-- 	<td style="width:100px">{{ $t('getapi[734]') }}</td>
								<td style="width:140px">
									<el-date-picker v-model="dataDetailRed.Head.modify_time" type="date" size="mini" style="width:100%" :disabled="true"></el-date-picker>
								</td> -->
								<td>{{ $t('getapi[3746]') }}</td>
								<td><el-input v-model="dataDetailRed.Head.customer_net_total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input></td>
							</tr>
							<tr>
								<td>{{ $t('getapi[3882]') }}</td>
								<td><el-input v-model="dataDetailRed.Head.request_person" type="text" size="mini" :readonly="true" class="readO"></el-input></td>
								<td>{{ $t('getapi[3881]') }}</td>
								<td>
									<el-date-picker v-model="dataDetailRed.Head.request_date" type="date" size="mini" style="width:100%" :readonly="true" class="readO"></el-date-picker>
								</td>
								<td>{{ $t('getapi[12902]') }}</td>
								<td><el-input v-model="dataDetailRed.Head.customer_total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input></td>
							</tr>
						</table>
					</div>
				</div>
				<div v-else>
					<div>
						<div style="width:100%;display: flex">
							<el-button type="primary" size="mini" @click="RequestAudit" :disabled="!btn.mnuRequestAudit">{{ $t('getapi[3001]') }}</el-button>
							<el-button type="primary" size="mini" @click="RequestAudit_Cancel" :disabled="!btn.mnuRRequestAudit">
								{{ $t('getapi[3875]') }}
							</el-button>

							<el-button type="primary" size="mini" @click="beforeAuditPurInvoice" :disabled="!btn.mnuAudit">{{ $t('getapi[3876]') }}</el-button>
							<el-button type="primary" size="mini" @click="beforeRAuditPurInvoiceRed" :disabled="!btn.mnuRAudit">
								{{ $t('getapi[3877]') }}
							</el-button>

							<el-button type="primary" size="mini" @click="InvoiceHook" :disabled="!btn.mnuBalance">{{ $t('getapi[1868]') }}</el-button>
							<el-button type="primary" size="mini" @click="InvoiceHook_Cancel" :disabled="!btn.mnuRBalance">{{ $t('getapi[1869]') }}</el-button>
							<el-button type="primary" size="mini" @click="beforeSetRatePurInvoice" :disabled="!btn.SetRate">{{ $t('getapi[3720]') }}</el-button>

							<el-button type="primary" size="mini" @click="beforeSetTaxRatePurInvoice" :disabled="!btn.SetTaxRate">{{ $t('getapi[7224]') }}</el-button>
							<!-- <el-button type="primary" size="mini" @click="beforeSetChangeTaxRatePurInvoice" :disabled="!btn.SetTaxRateBack" title="含税税率变更">
								含税税率变更
							</el-button> -->

							<el-button type="primary" size="mini" @click="beforeChangeAuditDate" :disabled="!btn.editAuditDate">
								{{ $t('getapi[3722]') }}
							</el-button>

							<el-button type="primary" size="mini" @click="beforeChangeInvoiceNo" :disabled="!btn.mnuEditInvoice">
								{{ $t('getapi[3879]') }}
							</el-button>
							<el-button type="primary" size="mini" @click="beforeChangeAuditDay" :disabled="$limits.fnIsEmpty(dataDetailRed.Head.audit_date)">{{ $t('getapi[8235]') }}</el-button>
						</div>
						<!-- 	<div style="margin-top:10px">
							<el-radio v-model="billmode" label="1" style="margin-left: 8px">整单模式</el-radio>
							<el-radio v-model="billmode" label="2">行模式</el-radio>
						</div> -->
						<div style="width:990px;min-width:990px">
							<table>
							<tr>
								<td style="width:60px;min-width:60px">{{ $t('getapi[2992]') }}</td>
								<td style="width:160px;min-width:160px"><el-input type="text" size="mini" v-model="dataDetailRed.Head.invoice_no" :readonly="true" class="readO"></el-input></td>
								<td style="width:60px;min-width:60px">{{ $t('getapi[3682]') }}</td>
								<td style="width:160px;min-width:160px">
									<el-select filterable v-model="dataDetailRed.Head.invoice_type_code" size="mini" :disabled="dataDetailRed.Head.invoice_status != 0">
										<el-option
											v-for="item in invoiceType"
											:key="item.Invoice_type_code"
											:label="item.Invoice_type_name"
											:value="item.Invoice_type_code"
											:disabled="dataDetailRed.Head.invoice_status != 0"
										></el-option>
									</el-select>
								</td>
								<td style="width:60px;min-width:60px">{{ $t('getapi[3861]') }}</td>
								<td style="width:160px;min-width:160px">
									<el-date-picker v-model="dataDetailRed.Head.payment_date" type="date" size="mini" style="width:100%" :readonly="true" class="readO"></el-date-picker>
								</td>
								<td style="width:60px;min-width:60px">{{ $t('getapi[3694]') }}</td>
								<td style="width:80px;min-width:80px"><el-input type="text" size="mini" :value="expStatus(dataDetailRed.Head.invoice_status)" :readonly="true" class="readO"></el-input></td>
								<td style="width:30px;min-width:30px">{{ $t('getapi[3287]') }}</td>
								<td style="width:160px;min-width:160px"><el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetailRed.Head.exchange_rate" :readonly="true" class="readO"></el-input></td>
							</tr>
							<tr>
								<td>{{ $t('getapi[3681]') }}</td>
								<td><el-input type="text" size="mini" v-model="dataDetailRed.Head.invoice_code" :readonly="dataDetailRed.Head.invoice_status != 0" :class="{'readO':dataDetailRed.Head.invoice_status != 0}"></el-input></td>
								<td>{{ $t('getapi[3683]') }}</td>
								<td>
									<el-date-picker
										v-model="dataDetailRed.Head.invoice_date"
										type="date"
										size="mini"
										value-format="yyyy-MM-dd"
										style="width:100%"
										:readonly="dataDetailRed.Head.invoice_status != 0"
										:class="{'readO':dataDetailRed.Head.invoice_status != 0}"
									></el-date-picker>
								</td>
								<td>{{ $t('getapi[1976]') }}</td>
								<td>
									<el-select filterable v-model="dataDetailRed.Head.order_type_code" size="mini" :disabled="dataDetail.Head.invoice_status != 0">
										<el-option v-for="item in invoiceOrderType" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
									</el-select>
								</td>
								<td>{{ $t('getapi[3748]') }}</td>
								<td><el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :value="dataDetailRed.Head.total_amount" :readonly="true" class="readO"></el-input></td>
								<td>
									<el-checkbox v-model="dataDetailRed.Head.charge_invoice_flag" true-label="1" false-label="0" :readonly="true" class="readO"></el-checkbox>
									{{ $t('getapi[3724]') }}
								</td>
								<td>
									<el-checkbox v-model="dataDetailRed.Head.e_invoice" true-label="1" false-label="0" :disabled="dataDetailRed.Head.Invoice_Status != 0"></el-checkbox>
									{{ $t('getapi[12667]') }}
								</td>
							</tr>
							<tr>
								<td>{{ $t('getapi[2610]') }}</td>
								<td>
									<routejump :urlNo="31" v-show="dataDetailRed.Head.invoice_status == 0">
									<el-input
										type="text"
										v-model="dataDetailRed.Head.customer_code"
										readonly
										class="mcolor"
										size="mini"
									>
										<i class="el-icon-edit el-input__icon" slot="suffix" @click="selectSupplierred()"></i>
									</el-input>
									</routejump>
									<el-input v-model="dataDetailRed.Head.customer_code" size="mini" v-show="dataDetailRed.Head.invoice_status != 0" :readonly="true" class="readO"></el-input>
								</td>
								<td>{{ $t('getapi[2958]') }}</td>
								<td colspan="3"><el-input type="text" size="mini" v-model="dataDetailRed.Head.customer_name" :readonly="true" class="readO"></el-input></td>
								<td>{{ $t('getapi[3704]') }}</td>
								<td><el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetailRed.Head.tax_total_amount" :readonly="true" class="readO"></el-input></td>
								<td colspan="2">
									<el-checkbox v-model="dataDetailRed.Head.negative_flag" true-label="1" false-label="0" :disabled="true"></el-checkbox>
									{{ $t('getapi[2096]') }}
								</td>
							</tr>
							<tr>
								<td>{{ $t('getapi[3697]') }}</td>
								<td><el-input type="text" size="mini" v-model="dataDetailRed.Head.audit_period" :readonly="true" class="readO"></el-input></td>
								<td>{{ $t('getapi[3855]') }}</td>
								<td><el-input type="text" size="mini" v-model="dataDetailRed.Head.request_no" :readonly="true" class="readO"></el-input></td>
								<td>{{ $t('getapi[3880]') }}</td>

								<td><el-input type="text" size="mini" :value="dataDetailRed.Head.diffAmount" :readonly="true" class="readO"></el-input></td>

								<td colspan="2">
									<el-checkbox
										v-model="dataDetailRed.Head.virtual_flag"
										true-label="1"
										false-label="0"
										:disabled="dataDetailRed.Head.invoice_status != 0"
									></el-checkbox>
									{{ $t('getapi[3700]') }}

									<!-- <span style="margin-left: 8px">
										<el-radio v-model="billmode" label="1" style="margin-left: 3px">整单模式</el-radio>
										<el-radio v-model="billmode" label="2">行模式</el-radio>
									</span> -->
								</td>
							</tr>
							<tr>
								<td>{{ $t('getapi[3688]') }}</td>
                                <td>
                                    <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.remain_amount" :readonly="true" class="readO"></el-input>
                                </td>
								<td>{{ $t('getapi[3689]') }}</td>
								<td>
                                    <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.customer_remain_amount" :readonly="true" class="readO"></el-input>
                                </td>
							</tr>
							<tr>
								<td>{{ $t('getapi[7222]') }}</td>
								<td colspan="4"><el-input v-model="dataDetailRed.Head.invoicenumlst" type="text"></el-input></td>
								<td><el-button type="primary" size="mini" @click="ShowInvoiceNumLst"  :disabled="code==null || code==''" >{{$t('getapi[7259]')}}</el-button></td>
								<td>{{ $t('getapi[8071]') }}</td>
								<td colspan="5"><el-input v-model="dataDetailRed.Head.remark" type="text"></el-input></td>
							</tr>
						</table>
						</div>
					</div>
					<el-tabs :tab-position="'top'" type="" style="margin-top:	0px" @tab-click="selectInfo">
						<el-tab-pane :label="$t('getapi[3726]')" name="20">
							<div>
								<el-button type="primary" size="mini" @click="showAddOrderReds('')" :disabled="!btn.batchadd">{{ $t('getapi[878]') }}</el-button>
								<el-button type="primary" size="mini" @click="batchDelReds(0)" :disabled="!btn.batchdel">{{ $t('getapi[1522]') }}</el-button>
								<el-button type="primary" size="mini" @click="coverInvoice_NoRed">{{ $t('getapi[12598]') }}</el-button>
								<el-button type="primary" size="mini" @click="coverBlankInvoice_NoRed">{{ $t('getapi[13480]') }}</el-button>
							</div>
							<el-table
								id="xdetilpane-20"
								:data="dataDetailRed.Lists"
								v-loading="dloading"
								@selection-change="handleSelectionChangeDetailRed"
								:row-class-name="tableRowClassNameDetail"
								:highlight-current-row="true"
								:height="tableHeight - 400"
								header-row-class-name="headerclass"
								border
								size="mini"
								style="width: 100%; margin-top:3px"
								ref="singleTable4"
							>
								<el-table-column type="selection"></el-table-column>
								<el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="charge_name" :label="$t('getapi[2728]')"></el-table-column>
								<el-table-column prop="co_code" :label="$t('getapi[3884]')" width="120">
									<template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0">
										<el-input v-model="scope.row.co_code" type="text" readonly class="mcolor" size="mini">
											<i class="el-icon-edit el-input__icon" slot="suffix" @click="showAddOrderReds(scope)"></i>
										</el-input>
									</template>
								</el-table-column>
								<el-table-column prop="co_line_no" :label="$t('getapi[1586]')" width="150">
									<template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0">
										<el-input v-model="scope.row.co_line_no" type="text" class="mcolor" size="mini"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="Sale_Discount" :label="$t('getapi[12342]')">
									<template scope="scope">
										<el-checkbox v-model="scope.row.Sale_Discount"></el-checkbox>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="charge_qty" :label="$t('getapi[1628]')" align="right"></el-table-column>
								<!-- <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[888]')"></el-table-column> -->
								<el-table-column show-overflow-tooltip prop="net_unit_price" :label="$t('getapi[2009]')" align="right" width="120"></el-table-column>
								<el-table-column show-overflow-tooltip prop="unit_price" :label="$t('getapi[2011]')" align="right" width="120">
									<template scope="scope">
										<span>{{scope.row.unit_price}}</span>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="net_total_amount" :label="$t('getapi[2010]')" align="right" width="120"></el-table-column>
								<el-table-column show-overflow-tooltip prop="total_amount" :label="$t('getapi[2012]')" align="right" width="120"></el-table-column>
								<el-table-column show-overflow-tooltip prop="base_net_unit_price" :label="$t('getapi[2007]')" align="right" width="120"></el-table-column>
								<el-table-column show-overflow-tooltip prop="base_net_total_amount" :label="$t('getapi[3731]')" align="right" width="120"></el-table-column>
								<el-table-column show-overflow-tooltip prop="base_unit_price" :label="$t('getapi[3744]')" align="right" width="120">
									<template scope="scope">
										<span>{{scope.row.base_unit_price}}</span>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="base_total_amount" :label="$t('getapi[3745]')" align="right" width="120">
									<template scope="scope">{{scope.row.base_total_amount}}</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip  prop="remark" :label="$t('getapi[3870]')"> </el-table-column>
								<el-table-column show-overflow-tooltip prop="contract_info" :label="$t('getapi[3915]')" >
									<template scope="scope">
										<span>{{ scope.row.contract_info}}</span>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip prop="customer_item" :label="$t('getapi[2707]')" align="right"></el-table-column>
								<el-table-column prop="Proforma_Invoice_No" label="Invoice No">
									<template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0 || btn.EditInvoiceNo">
										<el-input size="mini" type="text" v-model="scope.row.Proforma_Invoice_No"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="Issue_Part_Flow" :label="$t('getapi[12533]')" align="right" sortable="custom">
									<template scope="scope">
										<span :value="scope.row.Issue_Part_Flow == 0?$t('getapi[2053]'):$t('getapi[2052]')" type="text" ></span>
									</template>
								</el-table-column>
							</el-table>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[3887]')" name="21">
							<table :height="tableHeight - 380">
								<table>
									<tr>
										<td style="width:60px;min-width:60px">{{ $t('getapi[1228]') }}</td>
										<td style="width:120px;min-width:120px">
											<el-select filterable v-model="dataDetailRed.Head.balance_mode" size="mini" disabled>
												<el-option v-for="item in balanceMode" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
											</el-select>
										</td>
										<td style="width:60px;min-width:60px">{{ $t('getapi[1221]') }}</td>
										<td style="width:120px;min-width:120px"><el-input v-model="dataDetailRed.Head.payment_period" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input></td>
										<td>{{ $t('getapi[3740]') }}</td>
										<td><el-input v-model="dataDetailRed.Head.currency_code" size="mini" :readonly="true" class="readO"></el-input></td>
									</tr>
								</table>
							</table>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[7227]')" name="22">
							<table :height="tableHeight - 380" v-if="!showpdf">
								<div style="height:100%;overflow-y:	auto" class="demo-image__lazy">
									<el-image v-for="data in dataDetailRed.ImgLists" :key="data.Invoice_No" :src="data.HttpFilePath"></el-image>
								</div>
							</table>
							<div :height="tableHeight - 380" class="pdf" v-if="showpdf">
								<iframe v-bind:src="src" width="100%" :height="tableHeight - 380"></iframe>
							</div>
						</el-tab-pane>
						<el-tab-pane :label="$t('getapi[6487]')" name="23">
							<el-upload
								class="upload-demo"
								ref="upload"
								:action="uploadurlred"
								:on-preview="handlePreviewred"
								:on-remove="handleRemovered"
								:on-change="handleChangered"
								:on-success="handleSuccessred"
								:on-error="handleErrorred"
								:before-upload="beforeAvatarUploadred"
								:file-list="fileList3"
								:data="fileparm"
								:limit="1000"
							>
								<el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6422]')}}</el-button>
								<div slot="tip" class="el-upload__tip"></div>
							</el-upload>
							<el-table
								:data="dataDetailRed.FileLists"
								v-loading="loading"
								:height="tableHeight - 320"
								:highlight-current-row="false"
								show-overflow-tooltip="true"
								border
								stripe
								size="mini"
								header-row-class-name="headerclass"
							>
								<el-table-column show-overflow-tooltip prop="Node_Name" :label="$t('getapi[3590]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Doc_Type" :label="$t('getapi[6423]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Doc_Size" :label="$t('getapi[7875]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Upload_Person" :label="$t('getapi[6425]')"></el-table-column>
								<el-table-column show-overflow-tooltip prop="Upload_Time" :label="$t('getapi[6426]')"></el-table-column>
								<el-table-column prop="operate" :label="$t('getapi[6048]')">
									<template slot-scope="scope">
										<el-button @click.native.prevent="openred(scope)" type="text" size="mini">{{$t('getapi[7261]')}}</el-button>
										<el-button @click.native.prevent="filedelred(scope)" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-tab-pane>
					</el-tabs>
					<div style="width:720px">
						<table>
							<tr>
								<td style="width:100px;min-width:100px">{{ $t('getapi[1890]') }}</td>
								<td style="width:140px;min-width:140px"><el-input v-model="dataDetailRed.Head.create_person" size="mini" :readonly="true" class="readO"></el-input></td>
								<td style="width:100px;min-width:100px">{{ $t('getapi[4043]') }}</td>
								<td style="width:140px;min-width:140px"><el-input v-model="dataDetailRed.Head.audit_person" size="mini" :readonly="true" class="readO"></el-input></td>
								<!-- <td style="width:100px">{{ $t('getapi[733]') }}</td>
								<td style="width:140px"><el-input v-model="dataDetailRed.Head.modify_person" type="number" autocomplete="off" title="" size="mini" :disabled="true"></el-input></td> -->
								<td style="width:100px;min-width:100px">{{ $t('getapi[3749]') }}</td>
								<td style="width:140px;min-width:140px"><el-input v-model="dataDetailRed.Head.net_total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input></td>
							</tr>
							<tr>
								<td>{{ $t('getapi[1859]') }}</td>
								<td>
									<el-date-picker v-model="dataDetailRed.Head.create_date" type="date" size="mini" style="width:100%" :readonly="true" class="readO"></el-date-picker>
								</td>
								<td>{{ $t('getapi[3692]') }}</td>
								<td>
									<el-date-picker v-model="dataDetailRed.Head.audit_date" type="date" size="mini" style="width:100%" :readonly="true" class="readO"></el-date-picker>
								</td>
								<!-- <td style="width:100px">{{ $t('getapi[734]') }}</td>
								<td style="width:140px">
									<el-date-picker v-model="dataDetailRed.Head.modify_time" type="date" size="mini" style="width:100%" :disabled="true"></el-date-picker>
								</td> -->
								<td>{{ $t('getapi[3746]') }}</td>
								<td><el-input v-model="dataDetailRed.Head.customer_net_total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input></td>
							</tr>
							<tr>
								<td>{{ $t('getapi[3882]') }}</td>
								<td><el-input v-model="dataDetailRed.Head.request_person" type="text" size="mini" :readonly="true" class="readO"></el-input></td>
								<td>{{ $t('getapi[3881]') }}</td>
								<td>
									<el-date-picker v-model="dataDetailRed.Head.request_date" type="date" size="mini" style="width:100%" :readonly="true" class="readO"></el-date-picker>
								</td>
								<td>{{ $t('getapi[12902]') }}</td>
								<td><el-input v-model="dataDetailRed.Head.customer_total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input></td>
							</tr>
						</table>
					</div>
				</div>
			</li>
		</ul>
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="pageSize"
					:pager-count="5"
					layout="total,	sizes, prev, pager,	next,	jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align:	right;line-height: 30px;color: #545c64;font-size:	95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>

		<!-- <el-dialog :visible.sync="visUpdateUserStatus" title="发票使用状态" width="25%" :close-on-click-modal="false">
			<el-input v-model="userStatus" type="textarea"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="visUpdateUserStatus = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="updateUserStatus">确定</el-button>
			</span>
		</el-dialog> -->
		<el-dialog v-dialogDrag :visible.sync="visAddType" width="25%" :close-on-click-modal="false">
			<el-radio v-model="negativeflag" label="0">{{ $t('getapi[7230]') }}</el-radio>
			<el-radio v-model="negativeflag" label="1">{{ $t('getapi[7231]') }}</el-radio>
			<el-radio v-model="negativeflag" label="2">{{ $t('getapi[7262]') }}</el-radio>
			<span slot="footer" class="dialog-footer">
				<el-button @click="visAddType = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmAdd">{{ $t('getapi[4943]') }}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="auditCheckVisiable" width="25%" :close-on-click-modal="false">
			{{ $t('getapi[7232]') }}
			<el-date-picker
				v-model="auditCheckData.YearMonth"
				:start-placeholder="auditCheckData.DBYM"
				:end-placeholder="auditCheckData.SysYM"
				:picker-options="pickerOptionsInterval"
				type="month"
			></el-date-picker>
			<el-input :value="$t('getapi[7233]') + auditCheckData.DBYM + $t('getapi[7234]') + auditCheckData.SysYM" type="textarea" style="margin-top: 8px"></el-input>

			<span slot="footer" class="dialog-footer">
				<el-button @click="auditCheckFalse">{{ $t('getapi[2053]') }}</el-button>
				<el-button type="primary" @click="auditCheckTrue">{{ $t('getapi[2052]') }}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="visRate" :title="$t('getapi[3878]')" width="15%" :close-on-click-modal="false">
			<tr>
				<td>汇率</td>
				<td><el-input v-model="Exchange_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input></td>
			</tr>

			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visRate = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="SetRate_Click">{{ $t('getapi[1146]') }}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="visTaxRate" :title="$t('getapi[7224]')" width="15%" :close-on-click-modal="false">
			<tr>
				<td>{{$t('getapi[1225]')}}</td>
				<td><el-input v-model="Tax_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input></td>
			</tr>

			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visTaxRate = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="SetTaxRate_Click">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="visChangeAuditDate" :title="$t('getapi[7235]')" width="15%" :close-on-click-modal="false">
			<div style="display: flex;">
				<el-date-picker v-model="Audit_Period" :default-value="Audit_Period"></el-date-picker>
				<el-button size="mini" type="primary" @click="editAuditDate_Click">{{$t('getapi[2092]')}}</el-button>
			</div>
			<div style="height:10px"></div>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="visChangeAuditDay" :title="$t('getapi[8235]')" width="15%" :close-on-click-modal="false">
			<div style="display: flex;">
				<el-date-picker
						v-model="Audit_Period"
						:start-placeholder="changeAuditDay.DBYM"
						:end-placeholder="changeAuditDay.SysYM"
						:picker-options="pickerOptionsInterval1"
						type="date"
				></el-date-picker>
				<el-button size="mini" type="primary" @click="editAuditDay_Click">{{$t('getapi[2092]')}}</el-button>
			</div>
			<div style="height:10px"></div>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="visCusDueDate" :title="$t('getapi[12843]')" width="15%" :close-on-click-modal="false">
			<div style="display: flex;">
				<el-date-picker
						v-model="CusDueDate"
						type="date"
				></el-date-picker>
				<el-button size="mini" type="primary" @click="confirmCusDueDate">{{$t('getapi[2092]')}}</el-button>
			</div>
			<div style="height:10px"></div>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="visChangeTaxRate" :title="$t('getapi[7237]')" width="30%" :close-on-click-modal="false">
			<div style="text-align:	center">
				<span style="color:red">{{$t('getapi[7238]')}}</span>
				<br />
				<span style="color:red">{{$t('getapi[7239]')}}</span>
			</div>
			<tr>
				<td>{{$t('getapi[7240]')}}</td>
				<td><el-input v-model="Old_Tax_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input></td>
				%
			</tr>

			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visChangeTaxRate = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="SetTaxRateBack_Click">{{ $t('getapi[1146]') }}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="visEditInvoice" :title="$t('getapi[3969]')" width="20%" :close-on-click-modal="false">
			<div class="bbl">
				<label>{{ $t('getapi[3970]') }}:&nbsp;</label>
				<el-input style="width: 130px;" v-if="negative_flag == 0" v-model="dataDetail.Head.Invoice_No" type="text" size="mini" :readonly="true" class="readO"></el-input>
				<el-input style="width: 130px;" v-if="negative_flag >= 1" v-model="dataDetailRed.Head.invoice_no" type="text" size="mini" :readonly="true" class="readO"></el-input>
			</div>
			<br />
			<div class="bbl">
				<label>{{ $t('getapi[3971]') }}:&nbsp;</label>
				<el-input style="width: 130px;" v-model="New_Invoice_No" type="text" size="mini"></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visEditInvoice = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="mnuEditInvoice_Click">{{ $t('getapi[1146]') }}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="visShowMessage" :title="$t('getapi[7263]')" width="30%" :close-on-click-modal="false">
			<div style="text-align:	center"><el-input v-model="textareaShowMessage" type="textarea" rows="10"></el-input></div>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visShowMessage = false">{{ $t('getapi[2054]') }}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="visShowInvoiceNumLst" :title="$t('getapi[7264]')" width="30%" :close-on-click-modal="false">
			<!-- 修改发票摘要 -->
			<div style="text-align:	center;"><el-input v-model="txtInvoiceNumLst" type="text" :placeholder="$t('getapi[8903]')" ></el-input></div>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visShowInvoiceNumLst = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="InvoiceNumLst_Click">{{ $t('getapi[1146]') }}</el-button>
			</span>
		</el-dialog>
		<!-- 附件未上传提示 -->
		<el-dialog v-dialogDrag :visible.sync="filvisits" :title="$t('getapi[194]')" width="15%" :close-on-click-modal="false">
			<div style="text-align:	center"><span style="color:red">{{$t('getapi[7265]')}}</span></div>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="filvisits = false">{{$t('getapi[2053]')}}</el-button>
				<el-button size="mini" type="danger" @click="save">{{$t('getapi[2052]')}}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="visCover" :title="$t('getapi[12598]')" width="30%" :close-on-click-modal="false">
			<!-- 覆盖Invoice No -->
			Invoice No<el-input v-model="coverInvoiceNo" type="text" style="width:200px"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visCover = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="confirmCover">{{ $t('getapi[1146]') }}</el-button>
			</span>
		</el-dialog>
		<el-dialog v-dialogDrag :visible.sync="visCoverRed" :title="$t('getapi[12598]')" width="30%" :close-on-click-modal="false">
			<!-- 覆盖Invoice No -->
			Invoice No<el-input v-model="coverInvoiceNo" type="text" style="width:200px"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visCoverRed = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="confirmCoverRed">{{ $t('getapi[1146]') }}</el-button>
			</span>
		</el-dialog>
		<el-dialog v-dialogDrag :visible.sync="visCoverBlank" :title="$t('getapi[13480]')" width="30%" :close-on-click-modal="false">
			<!-- 覆盖Invoice No -->
			Invoice No<el-input v-model="coverBlankInvoiceNo" type="text" style="width:200px"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visCoverBlank = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="confirmCoverBlank">{{ $t('getapi[1146]') }}</el-button>
			</span>
		</el-dialog>
		<el-dialog v-dialogDrag :visible.sync="visCoverBlankRed" :title="$t('getapi[13480]')" width="30%" :close-on-click-modal="false">
			<!-- 覆盖Invoice No -->
			Invoice No<el-input v-model="coverBlankInvoiceNo" type="text" style="width:200px"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visCoverBlankRed = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="confirmCoverBlankRed">{{ $t('getapi[1146]') }}</el-button>
			</span>
		</el-dialog>
		<serce :isVisible="isVisible" queryData="SalInvoiceListViewInfo" ref="ser" @getser="serclick"></serce>
		<!--选择供应商-->
		<selector :isVisible="false" :isBatch="false" :isSplitPage="true" :postUrl="'Finance/SalInvoiceManage/CustomerCode'" @callback="getsupplier" ref="supplier"></selector>
		<!--选择供应商红字-->
		<selector :isVisible="false" :isBatch="false" :isSplitPage="true" :postUrl="'Sal/RedInv/GetCustomerPopupList'" @callback="getsupplierred" ref="supplierred"></selector>
		<!--发票明细-->
		<selectorvxe :isVisible="false" :isBatch="true" :postUrl="'Finance/SalInvoiceManage/CellClick'" @callback="getorder" ref="order"></selectorvxe>
		<!--费用明细-销售订单-->
		<selector :isVisible="false" :isBatch="true" :isSplitPage="true" :postUrl="'Finance/SalInvoiceManage/ChargeLine'" @callback="getorders" ref="orders"></selector>
		<selector :isVisible="false" :isBatch="false" :isSplitPage="true" :postUrl="'/Pur/Invoice/GetPurReceiveInListByVendCode'" @callback="getorder" ref="ordersingle"></selector>
		<!--发票明细-红字-->
		<selector :isVisible="false" :isBatch="true" :isSplitPage="true" :postUrl="'Sal/RedInv/GetIssueOrderNoPopupList'" @callback="getorderred" ref="orderred"></selector>
		<!--其他费用明细-费用红票-->
		<selector :isVisible="false" :isBatch="true" :isSplitPage="true" :postUrl="'Sal/ChargeRed/GetSalOrderNoPopupList'" @callback="getorderreds" ref="orderreds"></selector>
		<!-- 排序 -->
		<ctable :isVisible="false" :title="$t('getapi[3859]')" queryData="SalInvoiceListViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>

		<selector
			:isVisible="false"
			:isBatch="false"
			:isSplitPage="true"
			:postUrl="'/Pur/Invoice/GetPurReturnListByVendCode'"
			@callback="getorderred"
			ref="ordersinglered"
		></selector>
	</div>
</template>


<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import { Loading } from 'element-ui';
import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'

export default {
	name: '3_saleinvoiceview',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			filvisits: false, //附件未上传
			dloading: false,
			uploadurl: '', //上传图片接口地址
			uploadurlred: '', //费用红票上传接口
			fileList3: [],
			fileparm: {
				Invoice_No: '',
				Login_Group:'',
				Login_DB:'',
				Data_Type:7
			},
			dataSet: [], //	主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], //	查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('SalInvoiceListViewInfo'), // 当前页数据量
			SelectIndexs: 1, //当前页面
            RightSelectIndex: '0',
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			dataDetail: {
				Head: {
					Customer_Name: '',
					Invoice_Status_Text: '生成',
					Invoice_type_name: '',
					Order_Type_Code_Text: '',
					SalInvoiceId: '',
					Invoice_No: '',
					Request_No: '',
					Invoice_Code: '',
					Invoice_Type_Code: '',
					Invoice_Date: this.getnewdate(''),
					Order_Type_Code: '',
					Balance_Mode: '',
					Payment_period: 0,
					Tax_code: '',
					Tax_rate: 0,
					Customer_Code: '',
					Payment_Date: '',
					Currency_Code: '',
					Exchange_rate: 0,
					Create_Person: '',
					Create_Date: '',
					Audit_Person: '',
					Audit_Date: '',
					Planner: '',
					Invoice_Status: 0,
					Net_Total_Amount: 0,
					Customer_Net_Total_Amount: 0,
					Customer_Remain_Amount: 0,
					Total_Amount: 0,
					Tax_Total_Amount: 0,
					Exchange_modify_person: '',
					Exchange_modify_date: '',
					Audit_Period: '',
					Request_Person: '',
					Request_Date: '',
					Charge_Invoice_Flag: 0,
					remark: '',
					Modify_Person: '',
					Modify_Time: '',
					ConCurrent_Time: 0,
					virtual_flag: 0,
					Negative_Flag: 0,
					remain_amount: 0,
					InvoiceNumLst: '',
					IsWaiBi:false,
                    ERD_Flag:0,
				},
				Line: [],
				OtherCostLine: [],
				Files: [],
				Imgs: [
					{
						invoice_no: '',
						wxserviceid: '',
						HttpFilePath: '',
						create_date: ''
					}
				]
			},
			dataDetailRed: {
				Head: {
					invoice_no: '',
					request_no: '',
					invoice_code: '',
					invoice_type_code: '',
					invoice_date: this.getnewdate(''),
					order_type_code: '',
					balance_mode: '',
					payment_period: 0,
					tax_code: '',
					tax_rate: 0,
					customer_code: '',
					customer_name: '',
					payment_date: '',
					currency_code: '',
					exchange_rate: 0,
					exchange_modify_person: '',
					exchange_modify_date: '',
					audit_period: '',
					hook_period: '',
					create_person: '',
					create_date: '',
					audit_person: '',
					audit_date: '',
					hookrelation_person: '',
					hookrelation_date: '',
					planner: '',
					invoice_status: 0,
					net_total_amount: 0,
					customer_net_total_amount: 0,
					total_amount: 0,
					tax_total_amount: 0,
					customer_remain_amount: 0,
					remain_amount: 0,
					request_person: '',
					request_date: '',
					remark: '',
					modify_person: '',
					modify_time: '',
					concurrent_time: 0,
					virtual_flag: 0,
					negative_flag: 0,
					charge_invoice_flag: 0,
					invoicenumlst: '',
					isadd: 0
				},
				Lists: [],
				ImgLists: []
			},
			code: '', // 当前选择行代码（唯一）
			selectCodeData: [], //主表勾选invoice_no合集
			selectData: [],
			selectDataDetail: [],
			selectDataDetailRed: [],
			selectDataDetailCost: [],
			invoiceType: [],
			invoiceOrderType: [],
			balanceMode: [],
			billmode: '1', //	选择器模式 ：整单模式	1	、行模式 2
			oneormore: 1,
			rowindex: -1,
			oneormorered: 1,
			rowindexred: -1,
			dataDetailLineNo: 1, //	行号
			dataDetailLineNoCost: 1,
			dataDetailLineNoRed: 1,
			negativeflag: '0', //	0:普通单据1：红字单据
			negative_flag: 0, // 0:普通单据1：红字单据
			visAddType: false, //	新增类型弹窗控制
			auditCheckData: {
				YearMonth: null,
				Message: null,
				DBYM: '',
				SysYM: '',
				Result: false
			},
			beforeEventName: '', //	校验审核期间后执行的方法名称
			visRate: false,
			visTaxRate: false,
			visChangeTaxRate: false,
			visChangeAuditDate: false,
            visChangeAuditDay: false,
            visCusDueDate:false,
            CusDueDate:'',
            changeAuditDay: {
                YearMonth: null,
                Message: null,
                DBYM: '',
                SysYM: '',
                Result: false
            },
			visUpdateUserStatus: false,
			auditCheckVisiable: false,
			userStatus: '',
			Old_Tax_rate: '',
			Exchange_rate: '',
			Tax_rate: '',
			Audit_Period: '',

			visEditInvoice: false,
			New_Invoice_No: '',
			visShowMessage: false,
			textareaShowMessage: '',
			visShowInvoiceNumLst: false,
			txtInvoiceNumLst:'', // 发票摘要
			btn: {
				mnuRequestAudit: false, //申请审核
				mnuRRequestAudit: false, //申请反审
				mnuAudit: false, //发票审核
				mnuRAudit: false, //发票反审
				mnuBalance: false, //记账
				mnuRBalance: false, //反记账
				mnuReadRemark: true, //查看备注
				BatchIn: false, //批量导入
				SetRate: false, //汇率变更
				SetTaxRate: false, //税率变更
				SetTaxRateBack: false, //含税税率变更
				mnuEditInvoice: false, //修改发票号
				editAuditDate: false, //审核期间调整
				mnuProforma: false, //生成形式发票,
				BatchBalance: false,
				BatchNoBalance: false,
				BatchUpVirtual:false,//批量设置虚拟发票
				batchadd: false, //新增
				batchdel: false, //删除
				batchaddcost: false, //新增
				batchdelcost: false, //删除
				munCreate: false, //新建
				EditInvoiceNo: false //编辑Invoice No
			},
			addoredit: 0, //	0:新增2：修改
			pickerOptionsInterval: {
				disabledDate: this.disabledDate
			},
            pickerOptionsInterval1: {
                disabledDate: this.disabledDay
            },
			tableHeader: [],
            oldrow: '',
            iscontinuedblclick: true,
			timeId: null,
			IsEditPriceTaxHJ:0,//价税合计单元格是否可以编辑 0 不可、1 可以
            //pdf文件显示
            src: '', // pdf文件地址
            showpdf: false,//发票图片是否显示pdf
            coverInvoiceNo: '',
			visCover:false,
            visCoverRed: false,
            coverBlankInvoiceNo: '',
            visCoverBlank:false,
            visCoverBlankRed: false,
            scrollTop:0,
            scrollTop1:0,
            scrollTop2:0,
            scrollTop3:0,
            scrollTop4:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
		'dataDetail.Line': function(){
            let that = this
            that.$nextTick(function() {
                that.$processdata.initFormRight(this.RightSelectIndex)
            })
        },
        'dataDetail.OtherCostLine': function(){
            let that = this
            that.$nextTick(function() {
                that.$processdata.initFormRight(this.RightSelectIndex)
            })
        },
        'dataDetail.Files': function(){
            let that = this
            that.$nextTick(function() {
                that.$processdata.initFormRight(this.RightSelectIndex)
            })
        },
        'dataDetailRed.Lists': function(){
            let that = this
            that.$nextTick(function() {
                that.$processdata.initFormRight(this.RightSelectIndex)
            })
        },
		'dataDetailRed.FileLists': function(){
            let that = this
            that.$nextTick(function() {
                that.$processdata.initFormRight(this.RightSelectIndex)
            })
        },
    },
	mounted: function() {
		// 初始化
		let that = this;
        that.$processdata.pushModelCache('3_saleinvoiceview', that)
		that.colsort();
		that.userData = sessionStorage.getItem('userData');
		let token = JSON.parse(that.userData).token;
		that.uploadurl = Common.FileUrl + 'Files/UpFileByDocManage?token=' + token;
		that.uploadurlred = Common.FileUrl + 'Files/UpFileByDocManage?token=' + token;
		// 销售发票类型
		that.invoiceType = Array.methods.getFinSale_InvoiceType();
		// 单据类型
		that.invoiceOrderType = Array.methods.getFinSale_OrderType();
		//价税合计是否可编辑 默认0 不可编辑
        that.IsEditPriceTaxHJ = Array.methods.getSysConfig('A96');

		console.log('hello', that.invoiceOrderType);
		that.balanceMode = Array.methods.getBalanceMode();
		console.log('月结方式', that.balanceMode);
        that.oldDataDetail = JSON.stringify(that.dataDetail)
        that.oldDataDetailRed = JSON.stringify(that.dataDetailRed)
		that.$limits.dragControllerDiv();
		that.authority();
		// 默认蓝字新增
		if (that.btn.munCreate) {
			that.confirmAdd();
		}
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
            that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop1 = res.target.scrollTop
            },false)
            that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop2 = res.target.scrollTop
            },false)
            that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop3 = res.target.scrollTop
            },false)
            that.$refs.singleTable4.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop4 = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                this.$refs.singleTable4.bodyWrapper.scrollTop =this.scrollTop4;
            }, 13)
        })
    },
    beforeRouteEnter(to, form, next) {
        next(vm => {
            if (form.name == 'salelin' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                const data = {...vm.$store.state.sharedParams};
                vm.getDetail(data.order_no);
                setTimeout(() => {
                    vm.openEdit()
                }, 500);
                vm.$store.commit('clearSharedParams')
            }
        });
    },
	methods: {
		colsort() {
			let that = this;
			that.$loadviewfields.Fileds('SalInvoiceListViewInfo', 0, PFileds => {
				that.tableHeader = PFileds;
			});
		},
		sortclick(val) {
			if (val == 1) {
				this.colsort();
			}
		},
		// 修改表格顺序
		opentable() {
			this.$refs.ctab.clearInputs(true);
		},
		//获取当前时间
		getnewdate(ds) {
			var datev = new Date();
			if (ds) {
				datev = new Date(ds);
			}
			var y = datev.getFullYear();
			var m = datev.getMonth() + 1;
			m = m < 10 ? '0' + m : m;
			var d = datev.getDate();
			d = d < 10 ? '0' + d : d;
			var h = datev.getHours();
			var mm = datev.getMinutes();
			var ss = datev.getSeconds();
			h = h < 10 ? '0' + h : h;
			mm = mm < 10 ? '0' + mm : mm;
			ss = ss < 10 ? '0' + ss : ss;
			return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + ss;
		},
		// 审核区间约束
		disabledDate(time) {
			let that = this;
			let starttime = new Date(that.auditCheckData.DBYM).getTime();
			let endtime = new Date(that.auditCheckData.SysYM).getTime();
			return time.getTime() < starttime || time.getTime() > endtime;
		},
        disabledDay(time){
            let that = this;
            let starttime = new Date(that.changeAuditDay.DBYM).getTime();
            let endtime = new Date(that.changeAuditDay.SysYM).getTime();
            return time.getTime() < (starttime - 8.64e7) || time.getTime() > endtime;
		},
		tableRowClassNameDetail({ row, rowIndex }) {
			row.index = rowIndex;
		},
		tableRowClassNameDetailRed({ row, rowIndex }) {
			row.index = rowIndex;
		},
		tableRowClassNameDetailCost({ row, rowIndex }) {
			row.index = rowIndex;
		},
		leftt(e) {
			var left = document.getElementsByClassName('left');
			var mid = document.getElementsByClassName('mid');
			var Box = document.getElementsByClassName('Boxs');
			let bw = Box[0].clientWidth;
			if (e == 1) {
				left[0].style.width = '0px';
				mid[0].style.width = bw - 13 + 'px';
			} else {
				left[0].style.width = bw - 50 + 'px';
				mid[0].style.width = '0px';
			}
		},
        openEdit() {
            let that = this
            clearTimeout(that.timeId)
            if(!that.iscontinuedblclick){
                return
            }
            let left = document.getElementsByClassName('left');
            let mid = document.getElementsByClassName('mid');
            let Box = document.getElementsByClassName('Boxs');
            let bw = Box[0].clientWidth;
            left[0].style.width = '0px';
            mid[0].style.width = '100%';
        },
        colseEdit(){
            let that = this
            let left = document.getElementsByClassName('left');
            let mid = document.getElementsByClassName('mid');
            let Box = document.getElementsByClassName('Boxs');
            let bw = Box[0].clientWidth;
            left[0].style.width = '100%';
            mid[0].style.width = '0px'
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3859]"),this.$t("getapi[3846]"));
        },
		authority() {
			let that = this;
			that.btn.munCreate = false;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
			// console.log("权限1211："+that.$limits.authority('plv2', 244, 1));
			//管理界面
			// 销售发票管理 244
			if (that.$limits.authority('plv2', 244, 1) == 1) {
				if (that.total > 0) {
					//只读权
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
				else{
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				}
			}
			else if (that.$limits.authority('plv2', 244, 1) == 2) {
				// console.log("权限2112："+that.$limits.authority('plv3', 244, 1));
				if (that.$limits.authority('plv3', 244,1) == 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				}
				//操作权
				if (that.$limits.authority('plv3', 244, 1) == 1) {
					console.log("编辑级");
					//编辑级
					that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
					that.btn.munCreate = true;
				}
				if (that.$limits.authority('plv3', 244, 1) == 2) {
					that.btn.munCreate = true;
					console.log("删除级");
					//删除级
					if (that.negative_flag == 0) {
						if (!that.$limits.fnIsEmpty(that.dataDetail.Head.Invoice_No)) {
							if (that.dataDetail.Head.Invoice_Status == 0) {
								that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
							} else {
								that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
							}
						} else {
							that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
						}
					} else {
						if (!that.$limits.fnIsEmpty(that.dataDetailRed.Head.invoice_no)) {
							if (that.dataDetailRed.Head.invoice_status == 0) {
								that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
							} else {
								that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
							}
						} else {
							that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
						}
					}

					
				}
			}else{
				that.$refs.SetBtn.SetButtonEnable('search,refresh');
				if (that.$limits.authority('plv2', 244, 1)>0) {
					if (that.total > 0) {
						that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					}  
				}
			}
			
			that.btnauthority();
		},
		getPLV4(pos) {
			// 297
			let rtn = this.$limits.authority('plv4', pos, 1) == 1 ? true : false;
			return rtn;
		},
		btnauthority() {
			let that = this;
			console.log('权限');
			let btn = this.btn;
			btn.mnuRequestAudit = false; //申请审核
			btn.mnuRRequestAudit = false; //申请反审
			btn.mnuAudit = false; //发票审核
			btn.mnuRAudit = false; //发票反审
			btn.mnuBalance = false; //记账
			btn.mnuRBalance = false; //反记账
			btn.mnuReadRemark = true; //查看备注
			btn.BatchIn = false; //批量导入
			btn.SetRate = false; //汇率变更
			btn.SetTaxRate = false; //税率变更
			btn.SetTaxRateBack = false; //含税税率变更
			btn.mnuEditInvoice = false; //修改发票号
			btn.editAuditDate = false; //审核期间调整
			btn.mnuProforma = false; //生成形式发票
			btn.EditInvoiceNo = false; //编辑Invoice No			

			// btn.batchadd = false; //新增明细
			// btn.batchaddcost = false; //新增费用明细
			btn.batchdel = false; //删除明细
			btn.batchdelcost = false; //删除费用明细
			if(this.$limits.authority('plv4', '587', 1)==1){
				btn.EditInvoiceNo=true;
			}
			// 一览界面
			if (that.btn.BatchBalance) {
				btn.BatchBalance = that.getPLV4(222);
			}
			if (that.btn.BatchNoBalance) {
				btn.BatchNoBalance = that.getPLV4(223);
			}

			// 0生成 1审核 2钩稽	3记账	4月结	5作废6 申请审核
			// if (!that.dataDetail.Head.SalInvoiceId) {
			// 	that.btn.BatchIn = that.getPLV4(265); //修改发票号
			// 	return;
			// } else {
			// 	that.btn.mnuEditInvoice = that.getPLV4(299); //修改发票号
			// 	that.btn.mnuReadRemark = that.getPLV4(224); //查看备注
			// }
			console.log('btnauthority--', that.negative_flag);
			btn.batchadd = false; //新增明细
			btn.batchdel = false; //删除明细
			btn.batchaddcost = false; //新增明细
			btn.batchdelcost = false; //删除明细
			let OrderStatus = 0;
			let sdl = [];
			if (that.negative_flag >= 1) {
				//红字
				OrderStatus = that.dataDetailRed.Head.invoice_status;
				if (!that.dataDetailRed.Head.invoice_no) {
					that.btn.BatchIn = that.getPLV4(265); //批量导入
				} else {
					that.btn.mnuEditInvoice = that.getPLV4(299); //修改发票号
					that.btn.mnuReadRemark = that.getPLV4(224); //查看备注
				}
				sdl = that.selectDataDetailRed;
			} else {
				OrderStatus = that.dataDetail.Head.Invoice_Status;
				if (!that.dataDetail.Head.SalInvoiceId) {
					that.btn.BatchIn = that.getPLV4(265); //批量导入
				} else {
					that.btn.mnuEditInvoice = that.getPLV4(299); //修改发票号
					that.btn.mnuReadRemark = that.getPLV4(224); //查看备注
				}
				sdl = that.selectDataDetail;
			}
			console.log("单据状态："+OrderStatus)
			console.log("单据创建标记："+that.btn.munCreate)
			if (OrderStatus == 0 && that.btn.munCreate) {
				btn.batchadd = true; //新增明细
				if (sdl.length > 0) {
					btn.batchdel = true; //删除明细
				} else {
					btn.batchdel = false; //删除明细
				}

				// 费用明细
				sdl = that.selectDataDetailCost;
				btn.batchaddcost = true; //新增明细
				if (sdl.length > 0) {
					btn.batchdelcost = true; //删除明细
				} else {
					btn.batchdelcost = false; //删除明细
				}
			}

			// 一览选择
			if (that.selectData.length > 0) {
				btn.BatchBalance = true;
				btn.BatchNoBalance = true;
				btn.BatchUpVirtual=false;
				if (that.$limits.authority('plv4', 567, 1)>0) {
					btn.BatchUpVirtual=true;
				}
			} else {
				btn.BatchBalance = false; //批量记账
				btn.BatchNoBalance = false; //批量反记账
				btn.BatchUpVirtual=false;
			}
			// console.log('单据状态', OrderStatus);

			if (that.dataDetail.Head.SalInvoiceId || that.code) {
				console.log(' endit ');
			} else {
				console.log(' create ,no load btn.mnuRequestAudit');
				return;
			}

			if (OrderStatus == 0) {
				//生成
				btn.mnuRequestAudit = true; //申请审核
				//汇率变更被毁掉了，因为有问题 2010-7-21
				btn.SetRate = true; //汇率变更
				btn.SetTaxRate = true; //税率变更
				btn.SetTaxRateBack = true; //含税税率变更
				btn.mnuProforma = true; //生成形式发票
			}

			if (OrderStatus == 1) {
				//发票审核
				btn.mnuRAudit = true; //发票反审
				btn.mnuBalance = true; //记账
				btn.editAuditDate = true; //审核期间调整
                btn.mnuProforma = true; //生成形式发票
			}
			if (OrderStatus == 3) {
				//记账
				btn.mnuRBalance = true; //反记账
				btn.editAuditDate = true; //审核期间调整
                btn.mnuProforma = true; //生成形式发票
			}

			if (OrderStatus == 6) {
				//申请审核
				btn.mnuRRequestAudit = true; //申请反审
				btn.mnuAudit = true; //发票审核
				btn.SetRate = true; //汇率变更
				btn.SetTaxRate = true; //税率变更
				btn.SetTaxRateBack = true; //含税税率变更
				btn.mnuProforma = true; //生成形式发票
			}

			// 管理界面
			if (btn.mnuRequestAudit) {
				btn.mnuRequestAudit = that.getPLV4(296);
			}
			if (btn.mnuRRequestAudit) {
				btn.mnuRRequestAudit = that.getPLV4(297);
			}
			if (btn.mnuAudit) {
				btn.mnuAudit = that.getPLV4(220);
			}
			if (btn.mnuRAudit) {
				btn.mnuRAudit = that.getPLV4(221);
			}
			if (btn.mnuBalance) {
				btn.mnuBalance = that.getPLV4(222);
			}
			if (btn.mnuRBalance) {
				btn.mnuRBalance = that.getPLV4(223);
			}
			if (btn.mnuReadRemark) {
				btn.mnuReadRemark = that.getPLV4(224);
			}
			if (btn.BatchIn) {
				btn.BatchIn = that.getPLV4(265);
			}
			if (btn.SetRate) {
				btn.SetRate = that.getPLV4(272);
			}
			if (btn.SetTaxRate) {
				btn.SetTaxRate = that.getPLV4(272);
			}
			if (btn.SetTaxRateBack) {
				btn.SetTaxRateBack = that.getPLV4(272);
			}
			if (btn.mnuEditInvoice) {
				btn.mnuEditInvoice = that.getPLV4(299);
			}
			if (btn.editAuditDate) {
				btn.editAuditDate = that.getPLV4(336);
			}
			if (btn.mnuProforma) {
				btn.mnuProforma = that.getPLV4(147);
			}
		},
		// btnauthoritys() {
		//     let that = this;
		//     let btn = this.btn;
		//     if (that.selectDataDetailRed.length > 0) {
		//         //btn.batchadd = true; //新增明细
		//         btn.batchdel = true; //删除明细
		//         //btn.batchaddcost = true; //新增明细
		//         btn.batchdelcost = true; //删除明细
		//     }
		// },
		handleSizeChange(val) {
			this.pageSize = val;
			this.$http.savePageSize('SalInvoiceListViewInfo',val);
			this.getView();
			this.authority(1);
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority(1);
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'SalInvoiceListViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/Finance/FrmSaleInvoice/DataList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;

					that.authority();
				} else {
					that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
				}
			});
		},
		getView_Del() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/Finance/FrmSaleInvoice/DataList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;

					// that.authority();
				} else {
					that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
			if (that.addoredit == 0) {
				that.confirmAdd();
			} else {
				// console.log(that.negative_flag,that.code,that.dataDetailRed.Head.invoice_no)
				if(that.negative_flag == 0){
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.Line.length;i++){
                        delete datacopy.Line[i]['index']
                    }
                    for(let i = 0;i<datacopy.OtherCostLine.length;i++){
                        delete datacopy.OtherCostLine[i]['index']
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.save()
                            })
                            .catch(() => {
                                that.getView();
                                that.getDetail(that.code)
                            });
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
				} else if(that.negative_flag == 1){
                    let datacopyred = that.dataDetailRed
                    for(let i = 0;i<datacopyred.Lists.length;i++){
                        delete datacopyred.Lists[i]['index']
                    }
                    if(that.oldDataDetailRed != JSON.stringify(datacopyred)){
                        that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.save()
                            })
                            .catch(() => {
                                that.getView();
                                that.getDetailRed(that.dataDetailRed.Head.invoice_no);
                            });
                    } else {
                        that.getView();
                        that.getDetailRed(that.dataDetailRed.Head.invoice_no);
                    }
				} else if(that.negative_flag == 2){
                    let datacopyred = that.dataDetailRed
                    for(let i = 0;i<datacopyred.Lists.length;i++){
                        delete datacopyred.Lists[i]['index']
                    }
                    if(that.oldDataDetailRed != JSON.stringify(datacopyred)){
                        that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.save()
                            })
                            .catch(() => {
                                that.getView();
                                that.getDetailReds(that.dataDetailRed.Head.invoice_no);
                            });
                    } else {
                        that.getView();
                        that.getDetailReds(that.dataDetailRed.Head.invoice_no);
                    }
				}
			}
		},
		// 导出
		exps() {
			let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
			that.$confirm(that.$t('getapi[8898]'), that.$t('getapi[194]'), {//'是导出图片吗？'
				confirmButtonText: that.$t('getapi[2052]'),
				cancelButtonText: that.$t('getapi[2053]'),
				type: 'warning'
			})
				.then(() => {
					that.$refs.SetBtn.SetOneBtnEnable('exps', false);
					that.$http.urlpost('Finance/FrmSaleInvoice/DataList/ExportToHtml', parm, function(res) {
						that.$refs.SetBtn.SetOneBtnEnable('exps', true);
						if (res.Success == 1) {
							let hrefurl = Common.Url + res.DataContent.URL;
							window.open(hrefurl);
						}
					});
				})
				.catch(() => {
					/*that.$refs.SetBtn.SetOneBtnEnable('exps', false);
					that.$http.urlpost('Finance/FrmSaleInvoice/DataList/ExportToExecl', parm, function(res) {
						that.$refs.SetBtn.SetOneBtnEnable('exps', true);
						if (res.Success == 1) {
							let hrefurl = Common.Url + res.DataContent.URL;
							window.open(hrefurl);
						}
					});*/
                    let param = {
                        query_sign: "SalInvoiceListViewInfo",
                        fromname: that.$t('getapi[3859]'),
                        SelectIndex: 0,
                        MultyVer: that.$processdata.getLanguage(),
                        Param: datac
                    };
                    that.$processdata.commonExport(param)
				});
		},
		// 新增
		add() {
			let that = this;
			if(that.negative_flag == 0){
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Line.length;i++){
                    delete datacopy.Line[i]['index']
                }
                for(let i = 0;i<datacopy.OtherCostLine.length;i++){
                    delete datacopy.OtherCostLine[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.visAddType = true
                        });
                } else {
                    that.openEdit()
                    that.visAddType = true
                }
			} else {
                let datacopyred = that.dataDetailRed
                for(let i = 0;i<datacopyred.Lists.length;i++){
                    delete datacopyred.Lists[i]['index']
                }
                if(that.oldDataDetailRed != JSON.stringify(datacopyred)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.visAddType = true
                        });
                } else {
                    that.openEdit()
                    that.visAddType = true
                }
			}
		},
		confirmAdd() {
			console.log('下一步执行');
			let that = this;
			that.negative_flag = that.negativeflag;
			if(that.negative_flag!=0){
				that.billmode = 1;
            }
            that.addoredit = 0;
			that.visAddType = false;
			that.code = '';
			that.dataDetail.Head = {
				Customer_Name: '',
				Invoice_Status_Text: '生成',
				Invoice_type_name: '',
				Order_Type_Code_Text: '',
				SalInvoiceId: '',
				Invoice_No: '',
				Request_No: '',
				Invoice_Code: '',
				Invoice_Type_Code: '',
				Invoice_Date: that.getnewdate(''),
				Order_Type_Code: that.$limits.getDefaultSelect(that.invoiceOrderType, 'Code'),
				Balance_Mode: '',
				Payment_period: 0,
				Tax_code: '',
				Tax_rate: 0,
				Customer_Code: '',
				Payment_Date: '',
				Currency_Code: '',
				Exchange_rate: 0,
				Create_Person: '',
				Create_Date: '',
				Audit_Person: '',
				Audit_Date: '',
				Planner: '',
				Invoice_Status: 0,
				Net_Total_Amount: 0,
				Customer_Net_Total_Amount: 0,
				Customer_Remain_Amount: 0,
				Total_Amount: 0,
				Tax_Total_Amount: 0,
				Exchange_modify_person: '',
				Exchange_modify_date: '',
				Audit_Period: '',
				Request_Person: '',
				Request_Date: '',
				Charge_Invoice_Flag: 0,
				remark: '',
				Modify_Person: '',
				Modify_Time: '',
				ConCurrent_Time: 0,
				virtual_flag: 0,
				Negative_Flag: 0,
				remain_amount: 0,
				InvoiceNumLst: '',
				Customs_Dcl_Number:'',
				isadd: 1,
				e_invoice:0,
                CusDue_Date:'',
				ERD_Flag:0,//是否汇率差或视同内销，勾选后订单中数量及原币金额默认为灰色无需填写（新增状态下清除）
			};
			that.dataDetail.Files = [];
			that.dataDetail.Line = [];
			that.dataDetail.OtherCostLine = [];
			that.dataDetail.ImgList = [];
            that.oldDataDetail = JSON.stringify(that.dataDetail)
			that.dataDetailRed.Head = {
				invoice_no: '',
				invoice_code: '',
				invoice_type_code: '',
				invoice_date: that.getnewdate(''),
				order_type_code: that.invoiceOrderType[0].Code,
				balance_mode: '',
				payment_period: '',
				tax_code: '',
				tax_rate: '',
				vender_name: '',
				vender_code: '',
				payment_date: '',
				Currency_Code: '',
				Exchange_rate: '',
				create_person: '',
				create_date: '',
				audit_person: '',
				audit_date: '',
				net_total_amount: '',
				vender_net_total_amount: '',
				buyer: null,
				invoice_status: 0,
				vender_remain_amount: 0.0,
				remain_amount: 0.0,
				remark: null,
				total_amount: '',
				tax_total_amount: '',
				exchange_modify_person: null,
				exchange_modify_date: null,
				Audit_Period: '',
				charge_invoice_flag: 0,
				virtual_flag: 0,
				negative_flag: '1',
				concurrent_time: '',
				invoicenumlst: '',
				invoice_usestatus: null,
				payment_due_date: null,
				bank_account_name: '',
				bank_account_number: '',
				tax_number: '',
				Customs_Dcl_Number:'',
				isadd: 1,
				e_invoice:0,
			};
			if (that.negative_flag == 2) {
				that.dataDetailRed.Head.charge_invoice_flag = '1';
			}
			that.dataDetailRed.Lists = [];
			that.dataDetailRed.FileLists = [];
			that.dataDetailRed.ImgList = [];
            that.oldDataDetailRed = JSON.stringify(that.dataDetailRed)
			// console.log(that.dataDetail.Head.Invoice_Date, that.dataDetailRed.Head.invoice_date);
			that.authority();
			that.$forceUpdate();
		},
		save() {
			let that = this;
			let parm = {
				Head: that.dataDetail.Head,
				Line: that.dataDetail.Line,
				OtherCostLine: that.dataDetail.OtherCostLine,
				Files: that.dataDetail.Files,
				LangType: that.$processdata.getLang(),
			};
			let flg = parseInt(that.negative_flag);
			switch (flg) {
				case 0:
                    for (let i = 0; i < that.dataDetail.OtherCostLine.length; i++) {
                        if (that.dataDetail.OtherCostLine[i].Proforma_Invoice_No.indexOf(" ") != -1) {
                            that.$message.warning(that.$t('getapi[8904]') + (i + 1) + that.$t('getapi[8905]'))
                            return
                        }
                    }
					if(parm.Head.Invoice_Date.length<11){
						parm.Head.Invoice_Date = parm.Head.Invoice_Date + ' 00:00:00';
					}
					that.$http.urlpost('Finance/SalInvoiceManage/SaveData', parm, function(res) {
						// console.log(res);
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[3153]'));//'保存成功'
							that.code = res.DataContent.Head.Invoice_No;
							that.getDetail(res.DataContent.Head.Invoice_No);
						}
						else if (res.Success == 2) {
							that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
								confirmButtonText: that.$t('getapi[1146]'),
								cancelButtonText: that.$t('getapi[2054]'),
								type: 'warning'
							})
							.then(() => {
								parm.Head.iscontinue = res.Success
								that.$http.urlpost('Finance/SalInvoiceManage/SaveData', parm, function (res3) {
									if (res3.Success == 1) {
										that.$message.success(that.$t('getapi[3153]'));//'保存成功'
										that.code = res3.DataContent.Head.Invoice_No;
										that.getDetail(that.code);
									}
								})
							})
							.catch(() => {
								that.getdlist(that.formInline.exclusively_id, '', '');
							});
						}
                        that.$refs.SetBtn.SetOneBtnEnable('save', true);
					});
					break;
				case 1:
					parm = {
						Head: that.dataDetailRed.Head,
						Lists: that.dataDetailRed.Lists,
						LangType: that.$processdata.getLang(),
					};
					console.log('红字发票保存', parm);
                    that.$refs.SetBtn.SetOneBtnEnable('save', false);
					that.$http.urlpost('Sal/RedInv/SaveSalRedInv', parm, function(res) {
						console.log(res);
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[3153]'));//'保存成功'
							that.code = res.UniqueNum;
							that.getDetailRed(res.UniqueNum);
						}
                        that.$refs.SetBtn.SetOneBtnEnable('save', true);
					});
					break;
				case 2:
                    for (let i = 0; i < that.dataDetailRed.Lists.length; i++) {
                        if (that.dataDetailRed.Lists[i].Proforma_Invoice_No.indexOf(" ") != -1) {
                            that.$message.warning(that.$t('getapi[8906]') + (i + 1) + that.$t('getapi[8905]'))
                            return
                        }
                    }
					parm = {
						Head: that.dataDetailRed.Head,
						Lists: that.dataDetailRed.Lists,
						FileLists: that.dataDetailRed.Files,
						LangType: that.$processdata.getLang(),
					};
					// console.log('费用红字发票保存', parm);
                    that.$refs.SetBtn.SetOneBtnEnable('save', false);
					that.$http.urlpost('Sal/ChargeRed/SaveChargeRedInv', parm, function(res) {
						console.log(res);
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[3153]'));//'保存成功'
							that.filvisits = false;
							that.code = res.UniqueNum;
							that.getDetailReds(res.UniqueNum);
						}
                        that.$refs.SetBtn.SetOneBtnEnable('save', true);
					});

					break;
			}
		},
		del() {
			let that = this;
			let parm = {};
			let flg = parseInt(that.negative_flag);
			this.$confirm(that.$t('getapi[4532]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
				.then(() => {                        
					switch (flg) {
						case 0:
							parm = {
								Invoice_No: that.dataDetail.Head.Invoice_No,
								ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
								LangType: that.$processdata.getLang(),
							};
							that.$http.urlpost('Finance/SalInvoiceManage/Delete/Invoice', parm, function(res) {
								console.log(res);
								if (res.Success == 1) {
									that.$message.success(that.$t('getapi[659]'));//'刪除成功'
									that.getView_Del();
									that.confirmAdd();
								}
							});
							break;
						case 1:
							parm = {
								invoice_no: that.dataDetailRed.Head.invoice_no,
								concurrent_time: that.dataDetailRed.Head.concurrent_time,
								LangType: that.$processdata.getLang(),
							};
							that.$http.urlpost('Sal/RedInv/DelSalRedInv', parm, function(res) {
								console.log(res);
								if (res.Success == 1) {
									that.$message.success(that.$t('getapi[659]'));//'刪除成功'
									that.getView();
									that.confirmAdd();
								}
							});
							break;
						case 2:
							parm = {
								invoice_no: that.dataDetailRed.Head.invoice_no,
								concurrent_time: that.dataDetailRed.Head.concurrent_time,
								virtual_flag: that.dataDetailRed.Head.virtual_flag,
								List: that.dataDetailRed.Lists
							};
							that.$http.urlpost('Sal/ChargeRed/DelBillChargeRedInv', parm, function(res) {
								console.log(res);
								if (res.Success == 1) {
									that.$message.success(that.$t('getapi[659]'));//'刪除成功'
									that.getView();
									that.confirmAdd();
								}
							});
							break;
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: that.$t('getapi[8574]')
					});
				});

		},
		edits(row) {
			let that = this;
            if (that.code == row.Invoice_No) {
                return
            }
            that.timeId = setTimeout(() => {
                if (row.negative_flag == '否') {
                    /*that.negative_flag = 0;
                    that.getDetail(row.Invoice_No)*/
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.Line.length;i++){
                        delete datacopy.Line[i]['index']
                    }
                    for(let i = 0;i<datacopy.OtherCostLine.length;i++){
                        delete datacopy.OtherCostLine[i]['index']
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.Invoice_No
                                that.getDetail(row.Invoice_No)
                                that.negative_flag = 0
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow)
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.Invoice_No
                        that.getDetail(row.Invoice_No)
                        that.negative_flag = 0
                    }
                } else if (row.negative_flag == '是') {
                    if (row.Charge_Invoice_Flag == '是') {
                        /*that.negative_flag = 2;
                        that.getDetailReds(row.Invoice_No);*/
                        let datacopyred = that.dataDetailRed
                        for(let i = 0;i<datacopyred.Lists.length;i++){
                            delete datacopyred.Lists[i]['index']
                        }
                        if(that.oldDataDetailRed != JSON.stringify(datacopyred)){
                            that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                                confirmButtonText: that.$t('getapi[2052]'),
                                cancelButtonText: that.$t('getapi[2053]'),
                                closeOnClickModal: false,
                                type: 'warning'
                            })
                                .then(() => {
                                    that.iscontinuedblclick = true
                                    that.oldrow = row
                                    that.code = row.Invoice_No
                                    that.getDetailReds(row.Invoice_No)
                                })
                                .catch(() => {
                                    that.iscontinuedblclick = false
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow)
                                });
                        } else {
                            that.iscontinuedblclick = true
                            that.oldrow = row
                            that.code = row.Invoice_No
                            that.getDetailReds(row.Invoice_No)
                        }
                    } else {
                        /*that.negative_flag = 1;
                        that.getDetailRed(row.Invoice_No);*/
                        let datacopyred = that.dataDetailRed
                        for(let i = 0;i<datacopyred.Lists.length;i++){
                            delete datacopyred.Lists[i]['index']
                        }
                        if(that.oldDataDetailRed != JSON.stringify(datacopyred)){
                            that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                                confirmButtonText: that.$t('getapi[2052]'),
                                cancelButtonText: that.$t('getapi[2053]'),
                                closeOnClickModal: false,
                                type: 'warning'
                            })
                                .then(() => {
                                    that.iscontinuedblclick = true
                                    that.oldrow = row
                                    that.code = row.Invoice_No
                                    that.getDetailRed(row.Invoice_No)
                                    that.negative_flag = 1
                                })
                                .catch(() => {
                                    that.iscontinuedblclick = false
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow)
                                });
                        } else {
                            that.iscontinuedblclick = true
                            that.oldrow = row
                            that.code = row.Invoice_No
                            that.getDetailRed(row.Invoice_No)
                            that.negative_flag = 1
                        }
                    }
                }
            }, 100);
		},
		// 获取详情数据
		getDetail(code) {
			let that = this;
			that.dloading = true;
			that.addoredit = 1;
			let parm = {
				Invoice_No: code
			};
			that.negative_flag = 0;
            let loadingInstance = Loading.service(Common.maskoption);
            that.$http.urlpost('/Finance/SalInvoiceManage/Refresh', parm, function(res) {
                console.log(res);
                that.dloading = false;
                if (res.Success == 1) {
                    that.dataDetail = res.DataContent;
                    that.dataDetail.Head.isadd = 0;
                    that.dataDetail.Head.Negative_Flag = parseInt(that.dataDetail.Head.Negative_Flag);
                    that.dataDetail.Head.virtual_flag = that.dataDetail.Head.virtual_flag + '';
                    that.dataDetail.Head.Charge_Invoice_Flag = that.dataDetail.Head.Charge_Invoice_Flag + '';
                    that.dataDetail.Head.ERD_Flag = that.dataDetail.Head.ERD_Flag + '';
					that.dataDetail.Head.e_invoice = that.dataDetail.Head.e_invoice + '';
					
                    if(that.dataDetail.Imgs.length == 1){
                        let str = that.dataDetail.Imgs[0].HttpFilePath
                        if(str.slice(str.length - 3,str.length).toLowerCase()=='pdf'){
                            that.src = str
                            that.showpdf = true
                        } else {
                            that.showpdf = false
                        }
                    }
                    that.oldDataDetail = JSON.stringify(that.dataDetail)
                    that.authority();
                }
                loadingInstance.close()
				that.checkVirtualInvoice();
            });
		},
		checkVirtualInvoice(){
			//检验发票是否为虚拟发票 提示再次保存
			let that=this;
			if(that.dataDetail==null){
				return;
			}
			if(that.dataDetail.Head==null){
				return;
			}
			if(that.dataDetail.Head.virtual_flag==0 && that.dataDetail.Head.Invoice_Status==0 && that.dataDetail.Head.Total_Amount==0){
				that.$confirm(that.$t('getapi[12290]'), that.$t('getapi[194]'), {
					confirmButtonText: that.$t('getapi[2052]'),
					cancelButtonText: that.$t('getapi[2053]'),
					closeOnClickModal: false,
					type: 'warning'
				})
				.then(() => {
					that.dataDetail.Head.virtual_flag=1;
					that.save();
				})
				.catch(() => {
					console.log("");
				});
			}

		},
		// 获取详情数据-红单
		getDetailRed(code) {
			let that = this;
			let parm = {
				Code: code
			};
			that.negative_flag = 1;
			that.addoredit = 1;
            let loadingInstance = Loading.service(Common.maskoption);
            that.$http.urlpost('/Sal/RedInv/GetSalRedInvBillInfo', parm, function(res) {
                console.log('红字', res);
                if (res.Success == 1) {
                    that.dataDetailRed = res.DataContent;
                    that.dataDetailRed.Head.isadd = 0;
                    that.dataDetailRed.Head.negative_flag = that.dataDetailRed.Head.negative_flag.toString();
                    that.dataDetailRed.Head.virtual_flag = that.dataDetailRed.Head.virtual_flag.toString();
                    that.dataDetailRed.Head.charge_invoice_flag = that.dataDetailRed.Head.charge_invoice_flag.toString();
					that.dataDetailRed.Head.e_invoice = that.dataDetailRed.Head.e_invoice.toString();
                    if(that.dataDetailRed.ImgLists.length == 1){
                        let str = that.dataDetailRed.ImgLists[0].HttpFilePath
                        if(str.slice(str.length - 3,str.length).toLowerCase()=='pdf'){
                            that.src = str
                            that.showpdf = true
                        } else {
                            that.showpdf = false
                        }
                    }
                    if (that.dataDetailRed.Head.charge_invoice_flag == 1) {
                        that.negative_flag = 2;
                    } else {
                        that.negative_flag = 1;
                    }
                    that.oldDataDetailRed = JSON.stringify(that.dataDetailRed)
                    that.authority();
                }
                loadingInstance.close()
            });
		},
		// 获取详情数据-红单
		getDetailReds(code) {
			let that = this;
			let parm = {
				Code: code
			};
			that.addoredit = 1;
            let loadingInstance = Loading.service(Common.maskoption);
            that.$http.urlpost('Sal/ChargeRed/GetSalChargeRedInvBillInfo', parm, function(res) {
                console.log('费用发票', res);
                if (res.Success == 1) {
                    that.dataDetailRed = res.DataContent;
                    that.dataDetailRed.Files = res.DataContent.FileLists;
                    that.dataDetailRed.Head.isadd = 0;
                    that.dataDetailRed.Head.negative_flag = that.dataDetailRed.Head.negative_flag.toString();
                    that.dataDetailRed.Head.virtual_flag = that.dataDetailRed.Head.virtual_flag.toString();
                    that.dataDetailRed.Head.charge_invoice_flag = that.dataDetailRed.Head.charge_invoice_flag.toString();
					that.dataDetailRed.Head.e_invoice = that.dataDetailRed.Head.e_invoice.toString();
					console.log(that.dataDetailRed.Lists)
                    if (that.dataDetailRed.Head.charge_invoice_flag == 1) {
                        that.negative_flag = 2;
                    } else {
                        that.negative_flag = 1;
                    }
                    that.oldDataDetailRed = JSON.stringify(that.dataDetailRed)
                    that.authority();
                }
                loadingInstance.close()
            });
		},
		handleSelectionChange(val) {
			// 一览选择
			let that = this;
			that.selectCodeData = [];
			that.selectData = [];
			for (let i = 0; i < val.length; i++) {
				that.selectCodeData.push(val[i].Invoice_No);
				that.selectData.push(val[i]);
			}
			that.btnauthority();
		},
		// 勾选发票明细
		handleSelectionChangeDetail(val) {
			// 明细选择
			let that = this;
			that.selectDataDetail = [];
			for (let i = 0; i < val.length; i++) {
				that.selectDataDetail.push(val[i]);
			}
			console.log('--handleSelectionChangeDetail-');
			that.btnauthority();
		},
		// 勾选发票明细	-	红字
		handleSelectionChangeDetailRed(val) {
			let that = this;
			that.selectDataDetailRed = [];
			for (let i = 0; i < val.length; i++) {
				that.selectDataDetailRed.push(val[i]);
			}
			console.log('--handleSelectionChangeDetailRed-');
			that.btnauthority();
		},
		// 勾选费用明细
		handleSelectionChangeDetailCost(val) {
			let that = this;
			that.selectDataDetailCost = [];
			for (let i = 0; i < val.length; i++) {
				that.selectDataDetailCost.push(val[i]);
			}
			that.btnauthority();
		},
		beforeUpdateUserStatus() {
			let that = this;
			that.userStatus = that.selectData[0].invoice_usestatus;
			that.visUpdateUserStatus = true;
		},
		// 更行发票使用状态
		// updateUserStatus() {
		// 	let that = this;
		// 	console.log(that.selectData);
		// 	let parm = {
		// 		invoice_no: that.selectData[0].Invoice_No,
		// 		UseStatus: that.userStatus
		// 	};
		// 	that.$http.urlpost('/Pur/Invoice/PurInvoiceUpdateUserStatus', parm, function(res) {
		// 		if (res.Success == 1) {
		// 			that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
		// 			that.visUpdateUserStatus = false;
		// 			that.getView();
		// 		}
		// 	});
		// },
		beforeBatchAudit() {
			let that = this;
			that.beforeEventName = 'batchAudit';
			that.checkAuditTime();
		},
		// 批量审核
		// batchAudit() {
		// 	let that = this;
		// 	if (that.selectCodeData.length == 0) {
		// 		that.$message.warning('请选择数据！');
		// 		return;
		// 	}
		// 	let ids = '';
		// 	for (let i = 0; i < that.selectCodeData.length; i++) {
		// 		ids = ids + that.selectCodeData[i] + ',';
		// 	}
		// 	let parm = {
		// 		ids: ids,
		// 		YearMonth: that.auditCheckData.YearMonth
		// 	};
		// 	that.$http.urlpost('/Pur/Invoice/PurInvBatchAudit', parm, function(res) {
		// 		if (res.Success == 1) {
		// 			that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
		// 			that.getView();
		// 		}
		// 	});
		// },
		expInvoiceStatus(val) {
			if (val == 0) {
				return '生成';
			} else if (val == 1) {
				return '审核';
			} else if (val == 2) {
				return '钩稽';
			} else if (val == 3) {
				return '记账';
			} else if (val == 4) {
				return '月结';
			} else if (val == 5) {
				return '作废';
			} else {
				return '';
			}
		},
		showAddOrders(row) {
			let that = this;
			if (that.dataDetail.Head.Customer_Code == '' || that.dataDetail.Head.Customer_Code == null) {
				that.$message.warning(that.$t('getapi[3937]'));
				return;
			}
			let inds = 0;
			if (row != '') {
				inds = row.$index;
			}
			let param = {
				Customer_Code: that.dataDetail.Head.Customer_Code,
				Exchange_rate: that.dataDetail.Head.Exchange_rate,
				IsWaiBi: that.dataDetail.Head.IsWaiBi,
				rowIndex: inds
			};
			that.rowindex = inds;
			that.$refs.orders.clearInput(true, param);
		},
		// 新增单据
		showAddOrder(row) {
			let that = this;
			if (that.dataDetail.Head.Customer_Code == '' || that.dataDetail.Head.Customer_Code == null) {
				that.$message.warning(that.$t('getapi[3937]'));
				return;
			}
			let param = {
				Customer_Code: that.dataDetail.Head.Customer_Code,
				Invoice_No: that.dataDetail.Head.Invoice_No,
				IsAllMode: that.billmode == 1 ? true : false
			};
			that.rowindex = row.$index;
			that.$refs.order.clearInput(true, param);
		},
		// 新增明细	-	红字
		showAddOrderRed(row) {
			let that = this;
			if (that.dataDetailRed.Head.customer_code == '' || that.dataDetailRed.Head.customer_code == null) {
				that.$message.warning(that.$t('getapi[3937]'));
				return;
			}
			if (row == '') {
				that.oneormorered = 1;
				let param = {
					billmode: that.billmode,
					customer_code: that.dataDetailRed.Head.customer_code
				};
				that.$refs.orderred.clearInput(true, param);
			} else {
				that.oneormorered = 2;
				that.rowindexred = row.$index;
				let param = {
					billmode: that.billmode,
					vendcode: that.dataDetailRed.Head.Customer_Code
				};
				that.$refs.ordersinglered.clearInput(true, param);
			}
		},
		//费用红票新增明细弹框
		showAddOrderReds(row) {
			let that = this;
			if (that.dataDetailRed.Head.customer_code == '' || that.dataDetailRed.Head.customer_code == null) {
				that.$message.warning(that.$t('getapi[3937]'));
				return;
			}
			let param = {
				customer_code: that.dataDetailRed.Head.customer_code
			};
			that.$refs.orderreds.clearInput(true, param);
		},
		getorder(data) {
			let that = this;
			let orderArr = [];
			let AllModllist = [];
			if (data.length > 0) {
				for (let i = 0; i < data.length; i++) {
					let datastr = data[i];
					if (data[i].Exclusively_Id) {
						AllModllist.push({ Exclusively_Id: data[i].Exclusively_Id });
					}
					if (data[i].relation_id) {
						datastr.Relation_Id = datastr.relation_id;
						datastr.Exclusively_Id = datastr.relation_id;
					}
					orderArr.push(datastr);
				}
			} else {
				orderArr.push(data);
			}

			let parm = {
				Customer_Code: that.dataDetail.Head.Customer_Code,
				IsWaiBi: that.dataDetail.Head.IsWaiBi,
				Exchange_rate: that.dataDetail.Head.Exchange_rate,
				IsAllMode: that.billmode == 1 ? true : false,
				AllMode: AllModllist,
				LineMode: orderArr
			};
			console.log("请求数据:"+JSON.stringify(parm));
            let loadingInstance = Loading.service(Common.maskoption1);
			that.$http.urlpost('Finance/SalInvoiceManage/CellClick/SelSalIn', parm, function(res) {
				console.log('出库单详情》》》', res);
				if (res.Success == 1) {
					let resData = res.DataContent;
					resData.forEach(item => {
						let maxlineno = 0;
						if (that.dataDetail.Line.length > 0) {
							maxlineno = Math.max.apply(
								Math,
								that.dataDetail.Line.map(item => {
									return item.Line_No;
								})
							);
						}
						item.Line_No = maxlineno + 1;
						console.log('最大值》》》', maxlineno);
						that.dataDetail.Line = that.dataDetail.Line.concat(item);
					});
					//  for (let i = 0; i < that.dataDetail.Line.length; i++) {
					//      if (that.dataDetail.Line[i].line_no >= that.dataDetailLineNo) {
					//          that.dataDetailLineNo = that.dataDetail.Line[i].line_no + 1;
					//      }
					//  }

					// that.dataDetail.Line.forEach(function (res, index) {
					//     res.Line_No = index + 1;
					// });
					console.log('出库单数据', that.dataDetail.Line);
				}
                loadingInstance.close()
			});
		},
		getorders(data) {
			let that = this;
			console.log(data);
            let lineNo = 1
            for (let i = 0; i < that.dataDetail.OtherCostLine.length; i++) {
                if (that.dataDetail.OtherCostLine[i].Line_No >= lineNo) {
                    lineNo = that.dataDetail.OtherCostLine[i].Line_No + 1
                }
            }
            for(let i=0;i<data.length;i++){
                that.dataDetail.OtherCostLine = [...that.dataDetail.OtherCostLine,{
                    "Contract_info": data[i].Contract_info,
                    "Exclusively_Id": data[i].Exclusively_Id,
                    "Relation_Invoice_No": data[i].Relation_Invoice_No,
                    "Line_No": lineNo++,
                    "Charge_Name": data[i].Charge_Name,
                    "Net_Unit_Price": data[i].Net_Unit_Price  ,
                    "Unit_Price": data[i].Unit_Price ,
                    "Net_Total_Amount":data[i].Net_Total_Amount ,
                    "Total_Amount":  data[i].Total_Amount,
                    "Charge_Qty":data[i].Charge_Qty ,
                    "Base_Net_Unit_Price": data[i].Base_Net_Unit_Price,
                    "Base_Unit_Price": data[i].Base_Unit_Price,
                    "Base_Net_Total_Amount": data[i].Base_Net_Total_Amount,
                    "Base_Total_Amount": data[i].Base_Total_Amount,
                    "CO_Code": data[i].CO_Code,
                    "CO_Line_No": data[i].CO_Line_No,
                    "remark": data[i].remark,
                    Proforma_Invoice_No: '',
                    Issue_Part_Flow:data[i].Issue_Part_Flow,
					after_flag:data[i].after_flag,
                }]
			}
		},
		//删除文件
		filedel(row) {
			let that = this;
			let index = row.$index;
			that.ids = this.selectIDData;
			that.$confirm(that.$t('getapi[8599]'), that.$t('getapi[194]'), {//此操作将永久删除该文件, 是否继续?
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					let src = typeof row.row.FileSrc == 'undefined' ? '' : row.row.FileSrc;
					let parm = {
						Invoice_No: that.dataDetail.Head.Invoice_No,
						ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
						Line: [],
						LangType: that.$processdata.getLang(),
					};
					parm.Line.push(row.row);
					console.log(JSON.stringify(parm));
					that.$http.urlpost('Finance/SalInvoiceManage/Delete/File', parm, res => {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[659]'));//'删除成功'
							that.dataDetail.Files.splice(index, 1);
						}
					});
				})
				.catch(() => {});
		},
		//打开文件
		open(row) {
			let that = this;
			if (!that.$limits.fnIsEmpty(row.row.Path1)) {
				window.open(row.row.Path1);
			}
		},
		//删除文件
		filedelred(row) {
			let that = this;
			let index = row.$index;
			that.ids = this.selectIDData;
			that.$confirm(that.$t('getapi[8599]'), that.$t('getapi[194]'), {//此操作将永久删除该文件, 是否继续?
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					let src = typeof row.row.FileSrc == 'undefined' ? '' : row.row.FileSrc;
					let parm = {
						Invoice_No: that.dataDetailRed.Head.invoice_no,
						ConCurrent_Time: that.dataDetailRed.Head.concurrent_time,
						Line: []
					};
					parm.Line.push(row.row);
					console.log(JSON.stringify(parm));
					that.$http.urlpost('Finance/SalInvoiceManage/Delete/File', parm, res => {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[659]'));//'删除成功'
							that.dataDetailRed.FileLists.splice(index, 1);
						}
					});
				})
				.catch(() => {});
		},
		//打开文件
		openred(row) {
			let that = this;
			if (!that.$limits.fnIsEmpty(row.row.Path1)) {
				window.open(row.row.Path1);
			}
		},
		handleChange(file, fileList) {
			let that = this;
			console.log('------handleChange---', file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
					//
					// that.datajson = file.response.DataContent;
				}
			}
		},
		handleSuccess(res, file, fileList) {
			let that = this;
			that.$refs.upload.clearFiles();
			console.log('------handleSuccess---', res);
			let response = res.Success;
			if (response == 0) {
				that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				that.$message.success(that.$t('getapi[498]'));//'成功'
				that.getDetail(that.dataDetail.Head.Invoice_No);
				// 后台没有返回数据
				//that.FileList	=	res.DataContent.FileList;
				// that.FileList.push({Node_Name:'',Doc_Type:'',Doc_Size:'',Upload_Person,'',Upload_Time''})
				//that.datajson	=	res.DataContent;
			}
		},
		handleError(err, file, fileList) {
			let that = this;
			that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
		},
		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePreview(file) {
			let that = this;
			that.fileparm.Invoice_No = that.dataDetail.Head.Invoice_No;
			that.userData = sessionStorage.getItem('userData');
            const key = generatekey(8); // 也可直接指定key let key = 'des';
            that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
            that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
			
		},
		beforeAvatarUpload(file) {
			let that = this;
			that.fileparm.Invoice_No = that.dataDetail.Head.Invoice_No;
			if (that.dataDetail.Head.Invoice_No == '' || that.dataDetail.Head.Invoice_No == null) {
				that.$message.error(that.$t('getapi[4868]'));//'必须保存后才能上传文件'
				return false;
			}
			that.userData = sessionStorage.getItem('userData');
            const key = generatekey(8); // 也可直接指定key let key = 'des';
            that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
            that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
			console.log('---beforeAvatarUpload--', that.fileparm);
			console.log(file);

			return true;
		},
		// 费用发票上传附件
		handleChangered(file, fileList) {
			let that = this;
			console.log('------handleChange---', file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
					//
					// that.datajson = file.response.DataContent;
				}
			}
		},
		handleSuccessred(res, file, fileList) {
			let that = this;
			that.$refs.upload.clearFiles();
			console.log('------handleSuccess---', res);
			let response = res.Success;
			if (response == 0) {
				that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				
				that.$message.success(that.$t('getapi[498]'));//'成功'
				that.getDetailReds(that.dataDetailRed.Head.invoice_no);
				//that.getDetail(that.dataDetailRed.Head.Invoice_No);
				// that.dataDetailRed.Head.invoice_no = res.DataContent.invoice_no;
				// that.dataDetailRed.Files = res.DataContent.FileLists;
				// 后台没有返回数据
				//that.FileList	=	res.DataContent.FileList;
				// that.FileList.push({Node_Name:'',Doc_Type:'',Doc_Size:'',Upload_Person,'',Upload_Time''})
				//that.datajson	=	res.DataContent;
			}
		},
		handleErrorred(err, file, fileList) {
			let that = this;
			that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
		},
		handleRemovered(file, fileList) {
			console.log(file, fileList);
		},
		handlePreviewred(file) {
			let that = this;
			that.fileparm.Invoice_No = that.dataDetailRed.Head.invoice_no;
			that.userData = sessionStorage.getItem('userData');
            const key = generatekey(8); // 也可直接指定key let key = 'des';
            that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
            that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
		},
		beforeAvatarUploadred(file) {
			let that = this;
			that.fileparm.Invoice_No = that.dataDetailRed.Head.invoice_no;
			that.userData = sessionStorage.getItem('userData');
            const key = generatekey(8); // 也可直接指定key let key = 'des';
            that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
            that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
			console.log('---beforeAvatarUpload--', that.fileparm);
			console.log(file);
			return true;
		},
		calcAmount(rows, index){
			let that=this;
			if(that.IsEditPriceTaxHJ==1){
				that.pricetaxhj(rows, index);
			}else{
				that.sums(rows, index);
			}
		},
		//发票明细计算
		sums(rows, index) {
			let that = this;
			let dind = rows.$index;
			let datastr = rows.row;
			let amount = 0;
			if (that.negative_flag == 0) {
				switch (index) {
					//数量
					case 0:
						if (that.dataDetail.Head.IsWaiBi) {
							that.dataDetail.Line[dind].Tax_Amount = 0;
							amount = 0;
						} else {
							//税率
							amount = parseFloat(datastr.Net_Unit_Price) * parseFloat(that.dataDetail.Head.Tax_rate / 100) * parseFloat(datastr.Invoice_Qty);
							amount = amount.toFixed(2);
							that.dataDetail.Line[dind].Tax_Amount = amount;
						}
						that.dataDetail.Line[dind].Customer_Line_Net_Total_Amount = (parseFloat(datastr.Invoice_Qty) * parseFloat(datastr.Customer_Net_Unit_Price)).toFixed(2); //原币不含税金额
						that.dataDetail.Line[dind].Line_Net_Total_Amount = (parseFloat(datastr.Invoice_Qty) * parseFloat(datastr.Net_Unit_Price)).toFixed(2); //本币不含税金额
						that.dataDetail.Line[dind].Line_Total_Amount = (parseFloat(amount) + parseFloat(datastr.Line_Net_Total_Amount)).toFixed(2); //本币价格税合计
						break;
					//原币不含税金额
					case 1:
						that.dataDetail.Line[dind].Customer_Net_Unit_Price = (parseFloat(datastr.Customer_Line_Net_Total_Amount) / parseFloat(datastr.Invoice_Qty)).toFixed(6); //原币不含税单价
						that.dataDetail.Line[dind].Customer_Unit_Price = (parseFloat(that.dataDetail.Line[dind].Customer_Net_Unit_Price) * parseFloat(1+that.dataDetail.Head.Tax_rate/100)).toFixed(6); //原币含税单价

						that.dataDetail.Line[dind].Net_Unit_Price = (parseFloat(datastr.Customer_Net_Unit_Price) * parseFloat(that.dataDetail.Head.Exchange_rate)).toFixed(6); //本币不含税单价
						that.dataDetail.Line[dind].Unit_Price = (parseFloat(that.dataDetail.Line[dind].Net_Unit_Price) * parseFloat(1+that.dataDetail.Head.Tax_rate/100)).toFixed(6); //本币含税单价

						that.dataDetail.Line[dind].Line_Net_Total_Amount = (parseFloat(datastr.Invoice_Qty) * parseFloat(datastr.Net_Unit_Price)).toFixed(2); //本币不含税金额
						amount = parseFloat(datastr.Net_Unit_Price) * parseFloat(that.dataDetail.Head.Tax_rate / 100) * parseFloat(datastr.Invoice_Qty);
						amount = amount.toFixed(2);
						that.dataDetail.Line[dind].Tax_Amount = amount;
						that.dataDetail.Line[dind].Line_Total_Amount = (parseFloat(amount) + parseFloat(datastr.Line_Net_Total_Amount)).toFixed(2); //本币价格税合计
						break;
					//本币税额
					default:
						that.dataDetail.Line[dind].Line_Total_Amount = (parseFloat(datastr.Tax_Amount) + parseFloat(datastr.Line_Net_Total_Amount)).toFixed(2);
				}
			}
			if (that.negative_flag == 1) {
				switch (index) {
					//数量
					case 0:
						if (that.dataDetailRed.Head.iswaibi) {
							that.dataDetailRed.Lists[dind].tax_amount = 0;
							amount = 0;
						} else {
							//税率
							amount = parseFloat(datastr.net_unit_price) * parseFloat(that.dataDetailRed.Head.tax_rate / 100) * parseFloat(datastr.invoice_qty);
							amount = amount.toFixed(2);
							that.dataDetailRed.Lists[dind].tax_amount = amount;
						}
						that.dataDetailRed.Lists[dind].customer_line_net_total_amount = (parseFloat(datastr.invoice_qty) * parseFloat(datastr.customer_net_unit_price)).toFixed(2); //原币不含税金额
						that.dataDetailRed.Lists[dind].line_net_total_amount = (parseFloat(datastr.invoice_qty) * parseFloat(datastr.net_unit_price)).toFixed(2); //本币不含税金额
						that.dataDetailRed.Lists[dind].line_total_amount = (parseFloat(amount) + parseFloat(datastr.line_net_total_amount)).toFixed(2); //本币价格税合计
						break;
					//原币不含税金额
					case 1:
						that.dataDetailRed.Lists[dind].customer_net_unit_price = (parseFloat(datastr.customer_line_net_total_amount) / parseFloat(datastr.invoice_qty)).toFixed(6); //原币不含税单价
						that.dataDetailRed.Lists[dind].customer_unit_price = (parseFloat(that.dataDetailRed.Lists[dind].customer_net_unit_price) * parseFloat(1+that.dataDetailRed.Head.tax_rate/100)).toFixed(6); //原币含税单价

						that.dataDetailRed.Lists[dind].net_unit_price = (parseFloat(datastr.customer_net_unit_price) *  parseFloat(that.dataDetailRed.Head.exchange_rate)).toFixed(6); //本币不含税单价
						that.dataDetailRed.Lists[dind].unit_price = (parseFloat(that.dataDetailRed.Lists[dind].net_unit_price) * parseFloat(1+that.dataDetailRed.Head.tax_rate/100)).toFixed(6); //本币含税单价

						that.dataDetailRed.Lists[dind].line_net_total_amount = (parseFloat(datastr.invoice_qty) * parseFloat(datastr.net_unit_price)).toFixed(2); //本币不含税金额
						amount = parseFloat(datastr.net_unit_price) * parseFloat(that.dataDetailRed.Head.tax_rate / 100) * parseFloat(datastr.invoice_qty);
						console.log(parseFloat(datastr.net_unit_price), parseFloat(that.dataDetailRed.Head.tax_rate / 100), parseFloat(datastr.invoice_qty));
						amount = amount.toFixed(2);
						that.dataDetailRed.Lists[dind].tax_amount = amount;
						that.dataDetailRed.Lists[dind].line_total_amount = (parseFloat(amount) + parseFloat(datastr.line_net_total_amount)).toFixed(2); //本币价格税合计
						break;
					//本币税额
					default:
						that.dataDetailRed.Lists[dind].line_total_amount = (parseFloat(datastr.tax_amount) + parseFloat(datastr.line_net_total_amount)).toFixed(2);
				}
			}
		},
		//编辑价税合计计算方法
		pricetaxhj(rows, index){
			let that = this;
			let dind = rows.$index;
			let datastr = rows.row;
			let amount = 0;
			if (that.negative_flag == 0) {
				switch (index) {
					//数量
					case 0:
						if (that.dataDetail.Head.IsWaiBi) {
							that.dataDetail.Line[dind].Tax_Amount = 0;
							amount = 0;
						} else {
							//税率
							amount = parseFloat(datastr.Net_Unit_Price) * parseFloat(that.dataDetail.Head.Tax_rate / 100) * parseFloat(datastr.Invoice_Qty);
							amount = amount.toFixed(2);
							that.dataDetail.Line[dind].Tax_Amount = amount;
						}
						that.dataDetail.Line[dind].Customer_Line_Net_Total_Amount = (parseFloat(datastr.Invoice_Qty) * parseFloat(datastr.Customer_Net_Unit_Price)).toFixed(2); //原币不含税金额
						that.dataDetail.Line[dind].Line_Net_Total_Amount = (parseFloat(datastr.Invoice_Qty) * parseFloat(datastr.Net_Unit_Price)).toFixed(2); //本币不含税金额
						that.dataDetail.Line[dind].Line_Total_Amount = (parseFloat(amount) + parseFloat(datastr.Line_Net_Total_Amount)).toFixed(2); //本币价格税合计
						break;
					//本币价税合计
					case 1:						 
						//1本币不含税金额=本币价税合计/税率
						that.dataDetail.Line[dind].Line_Net_Total_Amount=(that.dataDetail.Line[dind].Line_Total_Amount/(1+that.dataDetail.Head.Tax_rate/100)).toFixed(2);
						//2本币不含税单价=不含税金额/数量
						that.dataDetail.Line[dind].Net_Unit_Price=(that.dataDetail.Line[dind].Line_Net_Total_Amount/that.dataDetail.Line[dind].Invoice_Qty).toFixed(6);
						//3本币含税单价=本币不含税单价/客户税率
						that.dataDetail.Line[dind].Unit_Price=(that.dataDetail.Line[dind].Net_Unit_Price*(1+that.dataDetail.Head.Tax_rate/100)).toFixed(6);
						//4原币含税单价=本币含税单价/汇率
						that.dataDetail.Line[dind].Customer_Unit_Price=(that.dataDetail.Line[dind].Unit_Price/that.dataDetail.Head.Exchange_rate).toFixed(6);
						that.dataDetail.Line[dind].Customer_Net_Unit_Price=(that.dataDetail.Line[dind].Customer_Unit_Price/(1+that.dataDetail.Head.Tax_rate/100)).toFixed(6);
						that.dataDetail.Line[dind].Customer_Line_Net_Total_Amount=(that.dataDetail.Line[dind].Customer_Net_Unit_Price*that.dataDetail.Line[dind].Invoice_Qty).toFixed(2);

						that.dataDetail.Line[dind].Tax_Amount=(parseFloat(that.dataDetail.Line[dind].Net_Unit_Price) * parseFloat(that.dataDetail.Head.Tax_rate / 100) * parseFloat(that.dataDetail.Line[dind].Invoice_Qty)).toFixed(2);
						break
					//本币税额
					case 2:
						//本币不含税金额=本币价税合计-本币税额
						that.dataDetail.Line[dind].Line_Net_Total_Amount=(parseFloat(that.dataDetail.Line[dind].Line_Total_Amount)-parseFloat(that.dataDetail.Line[dind].Tax_Amount)).toFixed(2);
						break;
					//本币税额
					default:
						that.dataDetail.Line[dind].Line_Total_Amount = (parseFloat(datastr.Tax_Amount) + parseFloat(datastr.Line_Net_Total_Amount)).toFixed(2);
				}
			}
		},
		//发票明细红字
		getorderred(data) {
			console.log(data);
			let that = this;
			if (that.billmode == 2) {
				data.forEach(item => {
					let maxlineno = 0;
					if (that.dataDetailRed.Lists.length > 0) {
						maxlineno = Math.max.apply(
							Math,
							that.dataDetailRed.Lists.map(item => {
								return item.line_no;
							})
						);
					}
					console.log('最大值》》》', maxlineno);
					let p = {
						contract_info: item.contract_info,
						customer_id: item.customer_id,
						customer_item: item.customer_item,
						customer_order: item.customer_order,
						index: item.index,
						invoice_qty: item.invoice_qty,
						issue_order_line_no: item.issue_order_line_no,
						issue_order_no: item.issue_order_no,
						line_no: maxlineno + 1,
						measure_unit: item.measure_unit,
						net_unit_price: item.net_unit_price,
						unit_price: item.unit_price,
						part_code: item.part_code,
						part_model: item.part_model,
						part_name: item.part_name,
						part_spec: item.part_spec,
						part_version: item.part_version,
						releaseinvoiceqty: item.releaseinvoiceqty,
						relation_invoice_no: '',
						invoicerecord_no: '',
						invoicerecord_line_no: 0,
						line_net_total_amount: 0,
						tax_amount: 0,
						old_tax_amount: 0,
						line_total_amount: 0,
						customer_net_unit_price: 0,
						customer_unit_price: 0,
						customer_line_net_total_amount: 0,
						old_customer_line_net_total_amount: 0,
						line_remark: '',
						cust_part: '',
						co_line_id: item.line_no,
						proforma_invoice_no: '',
						invoice_no:'',
					};
					that.dataDetailRed.Lists.push(p);
				});
			} else {
				let liss = [];
				data.forEach(item => {
					liss.push({
						exclusively_id: item.exclusively_id
					});
				});
				let parmd = {
					customercode: that.dataDetailRed.Head.customer_code,
					exchange_rate: that.dataDetailRed.Head.exchange_rate,
					iswai: that.dataDetailRed.Head.iswaibi,
					Lists: liss
				};
				console.log(parmd);
				that.$http.urlpost('Sal/RedInv/GetSalRedInvLinesByOrderNo', parmd, function(res) {
					console.log(res);
					if (res.Success == 1) {
						res.DataContent.Lists.forEach(item => {
							let maxlineno = 0;
							if (that.dataDetailRed.Lists.length > 0) {
								maxlineno = Math.max.apply(
									Math,
									that.dataDetailRed.Lists.map(item => {
										return item.line_no;
									})
								);
							}
							// let line_net_total_amount = item.invoice_qty*item.net_unit_price//本币不含税金额
							// let tax_amount = line_net_total_amount*that.dataDetailRed.Head.tax//本币不含税金额
							// let line_net_total_amount = item.invoice_qty*item.net_unit_price//本币不含税金额
							let p = {
								contract_info: item.contract_info,
								customer_id: item.customer_id,
								customer_item: item.customer_item,
								customer_order: item.customer_order,
								invoice_qty: item.invoice_qty,
								issue_order_line_no: item.issue_order_line_no,
								issue_order_no: item.issue_order_no,
								line_no: maxlineno + 1,
								measure_unit: item.measure_unit,
								net_unit_price: item.net_unit_price,
								unit_price: item.unit_price,
								part_code: item.part_code,
								part_model: item.part_model,
								part_name: item.part_name,
								part_spec: item.part_spec,
								part_version: item.part_version,
								releaseinvoiceqty: item.releaseinvoiceqty,
								relation_invoice_no: item.relation_invoice_no,
								invoicerecord_no: item.invoicerecord_no,
								invoicerecord_line_no: item.invoicerecord_line_no,
								line_net_total_amount: item.line_net_total_amount,
								tax_amount: item.tax_amount,
								old_tax_amount: item.old_tax_amount,
								line_total_amount: item.line_total_amount,
								customer_net_unit_price: item.customer_net_unit_price,
								customer_unit_price: item.customer_unit_price,
								customer_line_net_total_amount: item.customer_line_net_total_amount,
								old_customer_line_net_total_amount: item.old_customer_line_net_total_amount,
								line_remark: item.line_remark,
								cust_part: item.cust_part,
								co_line_id: item.co_line_id,
								proforma_invoice_no: item.proforma_invoice_no,
                                invoice_no: ''
							};
							that.dataDetailRed.Lists.push(p);
						});
					}
				});
			}
		},
		//费用红字发票其他费用明细
		getorderreds(data) {
			console.log(data);
			let that = this;
			let liss = [];
			data.forEach(item => {
				// let amout = 0;
				// if (that.dataDetailRed.Head.iswaibi==0) {
				// 	amout = that.dataDetailRed.Head.tax_rate;
				// }
				let ind = that.dataDetailRed.Lists.some(res => {
					return res.co_code == item.customer_order && res.co_line_no == item.line_no;
				});
				if (!ind) {
					let bp = (parseFloat(item.net_unitprice) * parseFloat(that.dataDetailRed.Head.exchange_rate)).toFixed(2);
					let bps = (parseFloat(item.total_unitprice) * parseFloat(that.dataDetailRed.Head.exchange_rate)).toFixed(2);
					let maxlineno = 0;
					if (that.dataDetailRed.Lists.length > 0) {
						maxlineno = Math.max.apply(
							Math,
							that.dataDetailRed.Lists.map(item => {
								return item.line_no;
							})
						);
					}
					let p = {
						relation_invoice_no: '',
						line_no: maxlineno + 1,
						charge_name: item.cost_item,
						co_line_no: item.line_no,
						co_code: item.customer_order,
						net_unit_price: item.net_unitprice,
						unit_price: item.total_unitprice,
						net_total_amount: item.net_amount,
						total_amount: item.total_amount,
						charge_qty: item.quantity,
						base_net_unit_price: bp,
						base_unit_price: bps,
						base_net_total_amount: parseFloat(bp * item.quantity).toFixed(2),
						base_total_amount: parseFloat(bps * item.quantity).toFixed(2),
						remark: item.remark,
						contract_info: item.contract_info,
                        Proforma_Invoice_No: ''
					};
					that.dataDetailRed.Lists.push(p);
				}
			});
		},
		batchDel_Click() {
			// 删除明细
			// 整单模式需要删除全部行
			// 确认要删除选择的行吗？
			let that = this;
			let parm = {
				Invoice_No: that.dataDetail.Head.Invoice_No,
				ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
				AllMode: that.billmode == 1 ? true : false,
				Line: [],
				LangType: that.$processdata.getLang(),
			};

			let msginfo;
			if (parm.AllMode) {
				// 整单模式
				msginfo = that.$t('getapi[3921]')//'此出库单的所有行将被删除，是否执行？';
			} else {
				msginfo = that.$t('getapi[3821]')//'确认要删除选择的行吗？';
			}

			this.$confirm(msginfo, that.$t('getapi[194]'), {
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					if (parm.AllMode) {
						// 整单模式
						for (let i = that.selectDataDetail.length - 1; i >= 0; i--) {
							let Issue_Order_No = that.selectDataDetail[i].Issue_Order_No;
							for (let j = that.dataDetail.Line.length - 1; j >= 0; j--) {
								if (that.dataDetail.Line[j].Issue_Order_No != Issue_Order_No) {
									continue;
								}

								if (that.dataDetail.Line[j].Exclusively_Id != '') {
									parm.Line.push(that.dataDetail.Line[j]);
								}
								that.dataDetail.Line.splice(j, 1);
							}
						}
					} else {
						for (let i = that.selectDataDetail.length - 1; i >= 0; i--) {
							that.dataDetail.Line.splice(that.selectDataDetail[i].index, 1);
							if (that.selectDataDetail[i].Exclusively_Id != '') {
								parm.Line.push(that.selectDataDetail[i]);
							}
						}
					}

					if (parm.Line.length > 0) {
						that.$http.urlpost('Finance/SalInvoiceManage/Delete/Line', parm, function(res) {
							if (res.Success == 1) {
								that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
								// 刷新数据
								that.dataDetail.Head = res.DataContent.Head;
							}
						});
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: that.$t('getapi[8574]')
					});
				});
		},
        //批量生辰InvoiceNo
        batchCreateInvoiceNo() {
            let that = this
            let parm = {
                Invoice_No: that.dataDetail.Head.Invoice_No,
                ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
            }
            that.$http.urlpost('/Finance/SalInvoiceManage/BatchCreateInvoiceNo', parm, function (res) {
                if (res.Success == 1) {
                    that.getDetail(that.code);
                }
            });
        },
		batchDelRed() {
			let that = this;
			this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					let parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time,
						billmode: that.billmode,
						virtual_flag: that.dataDetailRed.Head.virtual_flag,
						Lists: [],
						LangType: that.$processdata.getLang(),
					};
					for (let i = that.selectDataDetailRed.length - 1; i >= 0; i--) {
						that.dataDetailRed.Lists.splice(that.selectDataDetailRed[i].index, 1);
						if (that.selectDataDetailRed[i].relation_order_no != '') {
							let datatmp = {
								relation_invoice_no: that.selectDataDetailRed[i].relation_invoice_no,
								issue_order_no: that.selectDataDetailRed[i].issue_order_no,
								line_no: that.selectDataDetailRed[i].line_no
							};
							parm.Lists.push(datatmp);
						}
					}
					if (parm.invoice_no) {
						that.$http.urlpost('Sal/RedInv/DelLineSalRedInv', parm, function(res) {
							if (res.Success == 1) {
								// that.$message.success('');
							}
						});
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: that.$t('getapi[8574]')
					});
				});
		},
        batchCreateInvoiceNoRed(){
            let that = this
            let parm = {
                Invoice_No: that.dataDetailRed.Head.Invoice_No,
                ConCurrent_Time: that.dataDetailRed.Head.ConCurrent_Time,
            }
            that.$http.urlpost('/Finance/SalInvoiceManage/BatchCreateInvoiceNo', parm, function (res) {
                if (res.Success == 1) {
                    that.getDetail(that.code);
                }
            });
		},
		//费用红票删除明细
		batchDelReds(val) {
			let that = this;
			this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					let parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time,
						iscontinue: val,
						SelList: [],
						AllList: that.dataDetailRed.Lists
					};
					for (let i = that.selectDataDetailRed.length - 1; i >= 0; i--) {
						that.dataDetailRed.Lists.splice(that.selectDataDetailRed[i].index, 1);
						if (that.selectDataDetailRed[i].co_code != '') {
							let datatmp = {
								line_no: that.selectDataDetailRed[i].line_no,
								co_line_no: that.selectDataDetailRed[i].co_line_no,
								co_code: that.selectDataDetailRed[i].co_code
							};
							parm.SelList.push(datatmp);
						}
					}
					if (parm.invoice_no) {
						that.$http.urlpost('Sal/ChargeRed/DelChargeRedInvRowLine', parm, function(res) {
							if (res.Success == 1) {
								// that.$message.success('');
							} else if(res.Success == 2){
                                that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                    confirmButtonText: that.$t('getapi[1146]'),
                                    cancelButtonText: that.$t('getapi[2054]'),
                                    type: 'warning'
                                })
                                    .then(() => {
                                        that.batchDelReds(2);
                                    })
                                    .catch(() => {
                                        this.$message({
                                            type: 'info',
                                            message: that.$t('getapi[6096]')
                                        });
                                    });
							}
						});
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: that.$t('getapi[8574]')
					});
				});
		},
		//获取采购订单
		selectSupplier() {
			let that = this;
			if(that.dataDetail.Line.length>0){
				that.$message.warning(that.$t('getapi[13142]'));
				return;
			}

			if(that.dataDetail.OtherCostLine.length>0){
				that.$message.warning(that.$t('getapi[13143]'));
				return;
			}
			that.$refs.supplier.clearInput(true);
		},
		// 获取客户信息
		getsupplier(data) {
			console.log(data);
			let that = this;
			that.dataDetail.Head.Customer_Code = data.Customer_ID;
			that.dataDetail.Head.Customer_Name = data.Customer_Name;
			let parm = {
				Customer_ID: data.Customer_ID,
				Customer_Name: data.Customer_Name,
				BalanceMode_Name: data.BalanceMode_Name
			};
			that.$http.urlpost('/Finance/SalInvoiceManage/CustomerCode/SelSalInvoiceCode', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					let resData = res.DataContent[0];
					that.dataDetail.Head.Payment_period = resData.Payment_period;
					that.dataDetail.Head.Tax_code = resData.Tax_code;
					that.dataDetail.Head.Tax_rate = resData.Tax_rate;
					that.dataDetail.Head.Currency_Code = resData.Currency_Code;
					that.dataDetail.Head.bank_account_name = resData.bank_account_name;
					that.dataDetail.Head.bank_account_number = resData.bank_account_number;
					that.dataDetail.Head.tax_number = resData.tax_number;
					that.dataDetail.Head.Exchange_rate = resData.Exchange_rate;
					that.dataDetail.Head.Balance_Mode = resData.Balance_Mode;
					that.dataDetail.Head.Planner = resData.Planner;
					that.dataDetail.Head.IsWaiBi = resData.IsWaiBi;
				}
				else{
					that.dataDetail.Head.Customer_Code ="";
					that.dataDetail.Head.Customer_Name ="";
				}
			});
		},
		//获取采购订单red
		selectSupplierred() {
			let that = this;
			if(that.dataDetail.Line.length>0){
				that.$message.warning(that.$t('getapi[13142]'));
				return;
			}

			if(that.dataDetail.OtherCostLine.length>0){
				that.$message.warning(that.$t('getapi[13143]'));
				return;
			}
			that.$refs.supplierred.clearInput(true);
		},
		// 获取客户信息reds
		getsupplierred(data) {
			console.log(data);
			let that = this;
			that.dataDetailRed.Head.customer_code = data.customer_id;
			that.dataDetailRed.Head.customer_name = data.customer_name;
			that.dataDetailRed.Head.balance_mode = data.balancemode_code;
			let parm = {
				Code: data.customer_id
			};
			that.$http.urlpost('Sal/RedInv/GetCustBlankInfo', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					let resData = res.DataContent.CusInfo;
					that.dataDetailRed.Head.payment_period = resData.checkout_cycle;
					that.dataDetailRed.Head.currency_code = resData.currency_code_id;
					that.dataDetailRed.Head.exchange_rate = resData.exchange_rate;
					that.dataDetailRed.Head.Currency_Code = resData.Currency_Code;
					that.dataDetailRed.Head.iswaibi = resData.iswai;
					that.dataDetailRed.Head.tax_rate = resData.tax_rate;
				}
			});
			that.$forceUpdate();
		},
		// 新增费用明细行
		addOtherCostLine() {
			let that = this;
			that.dataDetailLineNoCost = 1;
			for (let i = 0; i < that.dataDetail.OtherCostLine.length; i++) {
				if (that.dataDetail.OtherCostLine[i].line_no >= that.dataDetailLineNoCost) {
					that.dataDetailLineNoCost = that.dataDetail.OtherCostLine[i].line_no + 1;
				}
			}
			that.dataDetail.OtherCostLine = [
				...that.dataDetail.OtherCostLine,
				{
					Contract_info: '',
					Exclusively_Id: '',
					Relation_Invoice_No: '',
					Line_No: that.dataDetailLineNoCost++,
					Charge_Name: '',
					Net_Unit_Price: 0,
					Unit_Price: 0,
					Net_Total_Amount: 0,
					Total_Amount: 0,
					Charge_Qty: 0,
					Base_Net_Unit_Price: 0,
					Base_Unit_Price: 0,
					Base_Net_Total_Amount: 0,
					Base_Total_Amount: 0,
					CO_Code: '',
					CO_Line_No: 0,
					remark: ''
				}
			];
		},
		changechargedata(row) {
			let that = this;
			let index = row.$index;
			if (that.dataDetail.OtherCostLine[index].charge_qty == '') {
				that.net_total_amount = 0;
				that.total_amount = 0;
				that.base_net_unit_price = 0;
				that.base_unit_price = 0;
				that.base_net_total_amount = 0;
				that.base_total_amount = 0;
			}
			if (that.dataDetail.OtherCostLine[index].charge_qty != '' && that.dataDetail.OtherCostLine[index].net_unit_price != '') {
				that.dataDetail.OtherCostLine[index].net_total_amount = that.dataDetail.OtherCostLine[index].charge_qty * that.dataDetail.OtherCostLine[index].net_unit_price;
				that.dataDetail.OtherCostLine[index].base_net_unit_price = that.dataDetail.OtherCostLine[index].net_total_amount * that.dataDetail.Head.Exchange_rate;
				that.dataDetail.OtherCostLine[index].base_net_total_amount =
					that.dataDetail.OtherCostLine[index].charge_qty * that.dataDetail.OtherCostLine[index].base_net_unit_price;
			}
			if (that.dataDetail.OtherCostLine[index].charge_qty != '' && that.dataDetail.OtherCostLine[index].unit_price != '') {
				that.dataDetail.OtherCostLine[index].total_amount = that.dataDetail.OtherCostLine[index].charge_qty * that.dataDetail.OtherCostLine[index].unit_price;
				that.dataDetail.OtherCostLine[index].base_unit_price = that.dataDetail.OtherCostLine[index].total_amount * that.dataDetail.Head.Exchange_rate;
				that.dataDetail.OtherCostLine[index].base_total_amount = that.dataDetail.OtherCostLine[index].charge_qty * that.dataDetail.OtherCostLine[index].base_unit_price;
			}
		},
		batchDelOtherCostLine() {
			let that = this;
			this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					let parm = {
						Invoice_No: that.dataDetail.Head.Invoice_No,
						ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
						Line: [],
						LangType: that.$processdata.getLang(),
					};
					for (let i = that.selectDataDetailCost.length - 1; i >= 0; i--) {
						that.dataDetail.OtherCostLine.splice(that.selectDataDetailCost[i].index, 1);
						if (that.selectDataDetailCost[i].Exclusively_Id != '') {
							let datatmp = that.selectDataDetailCost[i];
							parm.Line.push(datatmp);
						}
					}
					if (parm.Line.length > 0) {
						that.$http.urlpost('Finance/SalInvoiceManage/Delete/OtherCost', parm, function(res) {
							if (res.Success == 1) {
								that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
							}
						});
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: that.$t('getapi[8574]')
					});
				});
		},
		checkAuditTime() {
			let that = this;
            if (that.timeId) {
                clearTimeout(that.timeId)
            }
            that.timeId = setTimeout(() => {
                let parm = {};
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Finance/Invoice/CheckAuditTime', parm, function(res) {
                    if (res.Success == 1) {
                        that.auditCheckData = res.DataContent;
                        that.auditCheckData.SysYM=that.auditCheckData.YearMonth;
                        that.auditCheckTrue();
                    } else if (res.Success == 2) {
                        that.auditCheckData = res.DataContent;
                        that.auditCheckData.YearMonth = that.auditCheckData.SysYM;
                        that.auditCheckVisiable = true;
                    }
                    loadingInstance.close()
                });
            }, 500);
		},
		auditCheckFalse() {
			let that = this;
			// 冻结期间
			that.auditCheckData.YearMonth = that.auditCheckData.DBYM;
			that.auditCheckVisiable = false;
			if (that.beforeEventName == 'auditPurInvoice') {
				that.InvoiceAudit();
			} else if (that.beforeEventName == 'batchAudit') {
				that.batchAudit();
			} else if (that.beforeEventName == 'auditPurInvoiceRed') {
				that.InvoiceAudit();
			} else if (that.beforeEventName == 'rAuditPurInvoiceRed') {
				that.InvoiceAudit_Cancel();
			} else {
				// 未冻结期间
				that.InvoiceAudit();
			}
		},
		//日期调整
		auditCheckTrue() {
			let that = this;
			that.auditCheckVisiable = false;
			if (that.beforeEventName == 'auditPurInvoice') {
				// console.log("中间方法:"+that.auditCheckData.SysYM);
				that.auditCheckData.YearMonth = that.auditCheckData.SysYM;
				that.InvoiceAudit();
			} else if (that.beforeEventName == 'batchAudit') {
				that.batchAudit();
			} else if (that.beforeEventName == 'auditPurInvoiceRed') {
				that.auditCheckData.YearMonth = that.auditCheckData.SysYM;
				that.InvoiceAudit();
			} else if (that.beforeEventName == 'rAuditPurInvoiceRed') {
				that.InvoiceAudit_Cancel();
			} else {
				// 未冻结期间
				that.auditCheckData.YearMonth = that.auditCheckData.SysYM;
				that.InvoiceAudit();
			}
		},
		beforeAuditPurInvoice() {
			let that = this;
			if (that.negative_flag == 0) {
				that.beforeEventName = 'auditPurInvoice';
			} else {
				that.beforeEventName = 'auditPurInvoiceRed';
			}
			that.checkAuditTime();
		},
		// 审核
		// auditPurInvoice() {
		// 	let that = this;
		// 	let parm = {
		// 		invoice_no: that.dataDetail.Head.Invoice_No,
		// 		concurrent_time: that.dataDetail.Head.concurrent_time,
		// 		yearmonth: that.auditCheckData.YearMonth
		// 	};
		// 	that.$http.urlpost('/Pur/Invoice/AuditPurInvoice', parm, function(res) {
		// 		if (res.Success == 1) {
		// 			that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
		// 			that.getDetail(that.code);
		// 		}
		// 	});
		// },
		// 审核	-	红字
		// auditPurInvoiceRed() {
		// 	let that = this;
		// 	let arr = [];
		// 	for (let i = 0; i < that.dataDetailRed.Lists; i++) {
		// 		arr = [
		// 			...arr,
		// 			{
		// 				receive_order_no: that.dataDetailRed.Lists[i].receive_order_no
		// 			}
		// 		];
		// 	}
		// 	let parm = {
		// 		invoice_no: that.dataDetailRed.Head.Invoice_No,
		// 		concurrent_time: that.dataDetailRed.Head.concurrent_time,
		// 		yearmonth: that.auditCheckData.YearMonth,
		// 		Tax_rate: that.dataDetailRed.Head.Tax_rate,
		// 		virtual_flag: that.dataDetailRed.Head.virtual_flag,
		// 		Lists: arr
		// 	};
		// 	that.$http.urlpost('/Pur/Invoice/RedAuditPurInvoice', parm, function(res) {
		// 		if (res.Success == 1) {
		// 			that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
		// 			that.getDetailRed(that.code);
		// 		}
		// 	});
		// },
		// 反审核
		// rAuditPurInvoice() {
		// 	let that = this;
		// 	let parm = {
		// 		invoice_no: that.dataDetail.Head.Invoice_No,
		// 		concurrent_time: that.dataDetail.Head.concurrent_time,
		// 		audit_date: that.dataDetail.Head.audit_date
		// 	};
		// 	that.$http.urlpost('/Pur/Invoice/RAuditPurInvoice', parm, function(res) {
		// 		if (res.Success == 1) {
		// 			that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
		// 			that.getDetail(that.code);
		// 		}
		// 	});
		// },
		beforeRAuditPurInvoiceRed() {
			let that = this;
			that.beforeEventName = 'rAuditPurInvoiceRed';
			that.checkAuditTime();
		},
		// 反审核-红字
		// rAuditPurInvoiceRed() {
		// 	let that = this;
		// 	let arr = [];
		// 	for (let i = 0; i < that.dataDetailRed.Lists; i++) {
		// 		arr = [
		// 			...arr,
		// 			{
		// 				receive_order_no: that.dataDetailRed.Lists[i].receive_order_no
		// 			}
		// 		];
		// 	}
		// 	let parm = {
		// 		invoice_no: that.dataDetailRed.Head.Invoice_No,
		// 		concurrent_time: that.dataDetailRed.Head.concurrent_time,
		// 		yearmonth: that.auditCheckData.YearMonth,
		// 		Audit_Period: that.dataDetailRed.Head.Audit_Period,
		// 		virtual_flag: that.dataDetailRed.Head.virtual_flag,
		// 		Lists: arr
		// 	};
		// 	that.$http.urlpost('/Pur/Invoice/RRedAuditPurInvoice', parm, function(res) {
		// 		if (res.Success == 1) {
		// 			that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
		// 			that.getDetailRed(that.code);
		// 		}
		// 	});
		// },
		// 记账
		// balancePurInvoice() {
		// 	let that = this;
		// 	let parm = {
		// 		invoice_no: that.dataDetail.Head.Invoice_No,
		// 		concurrent_time: that.dataDetail.Head.concurrent_time
		// 	};
		// 	that.$http.urlpost('/Pur/Invoice/BalancePurInvoice', parm, function(res) {
		// 		if (res.Success == 1) {
		// 			that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
		// 			that.getDetail(that.code);
		// 		}
		// 	});
		// },
		// 记账	-	红字
		// balancePurInvoiceRed() {
		// 	let that = this;
		// 	let parm = {
		// 		invoice_no: that.dataDetailRed.Head.Invoice_No,
		// 		concurrent_time: that.dataDetailRed.Head.concurrent_time
		// 	};
		// 	that.$http.urlpost('/Pur/Invoice/RedBalancePurInvoice', parm, function(res) {
		// 		if (res.Success == 1) {
		// 			that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
		// 			that.getDetailRed(that.code);
		// 		}
		// 	});
		// },
		// 反记账
		// rBalancePurInvoice() {
		// 	let that = this;
		// 	let parm = {
		// 		invoice_no: that.dataDetail.Head.Invoice_No,
		// 		concurrent_time: that.dataDetail.Head.concurrent_time
		// 	};
		// 	that.$http.urlpost('/Pur/Invoice/RBalancePurInvoice', parm, function(res) {
		// 		if (res.Success == 1) {
		// 			that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
		// 			that.getDetail(that.code);
		// 		}
		// 	});
		// },
		// 反记账	-	红字
		// rBalancePurInvoiceRed() {
		// 	let that = this;
		// 	let parm = {
		// 		invoice_no: that.dataDetailRed.Head.Invoice_No,
		// 		concurrent_time: that.dataDetailRed.Head.concurrent_time
		// 	};
		// 	that.$http.urlpost('/Pur/Invoice/RRedBalancePurInvoice', parm, function(res) {
		// 		if (res.Success == 1) {
		// 			that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
		// 			that.getDetailRed(that.code);
		// 		}
		// 	});
		// },
		beforeSetTaxRatePurInvoice() {
			let that = this;
			that.visTaxRate = true;
			let flg = parseInt(that.negative_flag);
			switch (flg) {
				case 0:
					that.Tax_rate = that.dataDetail.Head.Tax_rate;
					break;
				case 1:
					that.Tax_rate = that.dataDetailRed.Head.tax_rate;
					break;
				case 2:
					that.Tax_rate = that.dataDetailRed.Head.tax_rate;
					break;
			}
		},
		// 变更税率
		setTaxRatePurInvoice() {
			let that = this;
			let parm = {};
			if (that.negative_flag == 0) {
				parm = {
					invoice_no: that.dataDetail.Head.Invoice_No,
					concurrent_time: that.dataDetail.Head.concurrent_time,
					order_type: 'pur',
					Tax_rate: that.dataDetail.Tax_rate
				};
			} else {
				parm = {
					invoice_no: that.dataDetailRed.Head.Invoice_No,
					concurrent_time: that.dataDetailRed.Head.concurrent_time,
					order_type: 'pur_n',
					Tax_rate: that.dataDetailRed.Tax_rate
				};
			}
			that.$http.urlpost('Finance/Invoice/SetTaxRate', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					that.visTaxRate = false;
					if (that.negative_flag == 0) {
						that.getDetail(that.code);
					} else {
						that.getDetailRed(that.code);
					}
				}
			});
		},
		beforeSetChangeTaxRatePurInvoice() {
			let that = this;
			that.visChangeTaxRate = true;
		},

		batchImport() {
			let that = this;
			let parm = {
				Code: that.dataDetailRed.Head.Customer_Code
			};
			that.$http.urlpost('/Pur/Invoice/GetPurReturnBatchImport', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
				}
			});
		},
		//生成形式发票
		proformaInovice() {
			let that = this;
			if (that.$limits.fnIsEmpty(that.dataDetail.Head.Invoice_No)) {
				return;
			}
			that.$refs.SetBtn.SetOneBtnEnable('print', false);
			that.dloading = true;
			let parm = {
				Invoice_No: that.dataDetail.Head.Invoice_No,
				LangType: that.$processdata.getLang(),
			};
			that.$http.urlpost('/Finance/SalInvoiceManage/Proforma', parm, function(res) {
				that.$refs.SetBtn.SetOneBtnEnable('print', true);
				if (res.Success == 1) {
					//let hrefurl = res.Key;
					//window.open(hrefurl);
					that.getDetail(that.code);
					that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					//console.log(res);
				}
				that.dloading = false;
			});
		},
		beforeChangeAuditDate() {
			// 审核期间调整
			let that = this;
			that.visChangeAuditDate = true;
			let date = new Date();

			let currentMonth = date.getMonth();
			let nextMonth = 0;

			let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
			let oneDay = 1000 * 60 * 60 * 24;
			let lastTime = new Date(nextMonthFirstDay - oneDay);
			let day = lastTime.getDate();
			let flg = parseInt(that.negative_flag);
			switch (flg) {
				case 0:
					date = new Date(that.dataDetail.Head.Audit_Period);

					currentMonth = date.getMonth();
					nextMonth = ++currentMonth;

					nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
					oneDay = 1000 * 60 * 60 * 24;
					lastTime = new Date(nextMonthFirstDay - oneDay);
					day = lastTime.getDate();
					that.Audit_Period = that.dataDetail.Head.Audit_Period + '-' + day;
					break;
				case 2:
					date = new Date(that.dataDetailRed.Head.audit_period);

					currentMonth = date.getMonth();
					nextMonth = ++currentMonth;

					nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
					oneDay = 1000 * 60 * 60 * 24;
					lastTime = new Date(nextMonthFirstDay - oneDay);
					day = lastTime.getDate();
					that.Audit_Period = that.dataDetailRed.Head.audit_period + '-' + day;
					break;
				case 1:
					date = new Date(that.dataDetailRed.Head.audit_period);

					currentMonth = date.getMonth();
					nextMonth = ++currentMonth;
					nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
					oneDay = 1000 * 60 * 60 * 24;
					lastTime = new Date(nextMonthFirstDay - oneDay);
					day = lastTime.getDate();
					that.Audit_Period = that.dataDetailRed.Head.audit_period + '-' + day;
					break;
			}
		},
        beforeCusDueDate(){
            let that = this;
            that.visCusDueDate = true;
            that.CusDueDate = ''
		},
        confirmCusDueDate(){
			let that = this;
			if(that.CusDueDate == ''){
				that.$message.warning(this.$t('getapi[12844]'))
				return;
			}
			let arr = [];
			arr = [...arr,{
                "Invoice_No": that.dataDetail.Head.Invoice_No,
                "CusDue_Date": that.CusDueDate,
			}]
			let parm = arr
            that.$http.urlpost('/Finance/FrmSaleInvoice/SaveInvoiceCusDateTTransaction', parm, function(res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    that.getDetail(that.dataDetail.Head.Invoice_No);
                    that.visCusDueDate = false;
                }
            });
		},
		changeAuditDate() {
			let that = this;
			let parm = {};
			if (that.negative_flag == 0) {
				parm = {
					invoice_no: that.dataDetail.Head.Invoice_No,
					Audit_Period: that.dataDetail.Head.Audit_Period,
					concurrent_time: that.dataDetail.Head.concurrent_time,
					auditdate: that.Audit_Period,
					billtype: 2
				};
			} else {
				parm = {
					invoice_no: that.dataDetailRed.Head.Invoice_No,
					Audit_Period: that.getnewdate(that.dataDetailRed.Head.Audit_Period),
					concurrent_time: that.dataDetailRed.Head.concurrent_time,
					auditdate: that.Audit_Period,
					billtype: 2
				};
			}
			that.$http.urlpost('/Finance/Invoice/ChanageAuditDate', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					that.visChangeAuditDate = false;
					if (that.negative_flag == 0) {
						that.getDetail(that.code);
					} else {
						that.getDetailRed(that.code);
					}
				}
			});
		},
        beforeChangeAuditDay(){
            // 审核日期调整
            let that = this;
            that.visChangeAuditDay = true;
            let date = new Date();

            let currentMonth = date.getMonth();
            let nextMonth = 0;
            let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
            let oneDay = 1000 * 60 * 60 * 24;
            let lastTime = new Date(nextMonthFirstDay - oneDay);
            let day = lastTime.getDate();
            let flg = parseInt(that.negative_flag);
            switch (flg) {
                case 0:
                    date = new Date(that.dataDetail.Head.Audit_Date);

                    currentMonth = date.getMonth();
                    nextMonth = ++currentMonth;
                    nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
                    oneDay = 1000 * 60 * 60 * 24;
                    lastTime = new Date(nextMonthFirstDay - oneDay);
                    day = lastTime.getDate();
                    that.changeAuditDay.DBYM = date.getFullYear() +'-'+(date.getMonth()+1)+ '-01';
                    that.changeAuditDay.SysYM = date.getFullYear() +'-'+(date.getMonth()+1) + '-' + day;
                    that.Audit_Period = that.dataDetail.Head.Audit_Date;
                    break;
                case 2:
                    date = new Date(that.dataDetailRed.Head.audit_date);

                    currentMonth = date.getMonth();
                    nextMonth = ++currentMonth;
                    nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
                    oneDay = 1000 * 60 * 60 * 24;
                    lastTime = new Date(nextMonthFirstDay - oneDay);
                    day = lastTime.getDate();
                    that.changeAuditDay.DBYM = date.getFullYear() +'-'+(date.getMonth()+1) + '-01'
                    that.changeAuditDay.SysYM = date.getFullYear() +'-'+(date.getMonth()+1) + '-' + day;
                    that.Audit_Period = that.dataDetailRed.Head.audit_date;
                    break;
                case 1:
                    date = new Date(that.dataDetailRed.Head.audit_date);

                    currentMonth = date.getMonth();
                    nextMonth = ++currentMonth;
                    nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
                    oneDay = 1000 * 60 * 60 * 24;
                    lastTime = new Date(nextMonthFirstDay - oneDay);
                    day = lastTime.getDate();
                    that.changeAuditDay.DBYM = date.getFullYear() +'-'+(date.getMonth()+1) + '-01';
                    that.changeAuditDay.SysYM = date.getFullYear() +'-'+(date.getMonth()+1) + '-' + day;
                    that.Audit_Period = that.dataDetailRed.Head.audit_date
                    break;
            }
		},
        editAuditDay_Click() {
            // 审核期间调整API
            let that = this;
            let parm = {
                Invoice_No: that.dataDetail.Head.Invoice_No,
                Audit_Date: that.Audit_Period,
				LangType: that.$processdata.getLang(),
            };
            let flg = parseInt(that.negative_flag);
            switch (flg) {
                case 0:
                    that.$http.urlpost('/Finance/SalInvoiceManage/ChanageAuditDateNew', parm, function(res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.visChangeAuditDay = false;
                            // 刷新数据
                            that.getDetail(that.dataDetail.Head.Invoice_No);
                            //
                            that.authority();
                        }
                    });
                    break;
                case 1:
                    parm = {
                        Invoice_No: that.dataDetailRed.Head.invoice_no,
                        Audit_Date: that.getnewdate(that.Audit_Period),
                    };
                    that.$http.urlpost('/Finance/SalInvoiceManage/ChanageAuditDateNew', parm, function(res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[498]'));//'成功'
                            that.visChangeAuditDay = false;
                            // 刷新数据
                            that.getDetailRed(that.dataDetailRed.Head.invoice_no);
                            //
                            that.authority();
                        }
                    });
                    break;
                case 2:
                    parm = {
                        invoice_no: that.dataDetailRed.Head.invoice_no,
                        Audit_Date: that.getnewdate(that.Audit_Period),
                    };
                    that.$http.urlpost('/Finance/SalInvoiceManage/ChanageAuditDateNew', parm, function(res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[498]'));//'成功'
                            that.visChangeAuditDay = false;
                            // 刷新数据
                            that.getDetailReds(that.dataDetailRed.Head.invoice_no);
                            //
                            that.authority();
                        }
                    });
                    break;
            }
        },
		/**************************************************/
		RequestAudit() {
			// 申请审核
			console.log('申请审核');
			let that = this;
			let parm = {
				Invoice_No: that.dataDetail.Head.Invoice_No,
				ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
				LangType: that.$processdata.getLang(),
			};
			let flg = parseInt(that.negative_flag);
			switch (flg) {
				case 0:
					that.$http.urlpost('Finance/SalInvoiceManage/RequestAudit', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
							// 刷新数据
                            that.getDetail(that.dataDetail.Head.Invoice_No);
							//
							that.authority();
						}
					});
					break;
				case 1:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time
					};
					that.$http.urlpost('Sal/RedInv/RequestAuditSalRedInv', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							// 刷新数据
							that.getDetailRed(parm.invoice_no);
							//
							that.authority();
						}
					});
					break;
				case 2:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time
					};
					console.log('费用红票', parm);
					that.$http.urlpost('Sal/ChargeRed/ChargeRedInvAudit', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							// 刷新数据
							that.getDetailReds(parm.invoice_no);
							//
							that.authority();
						}
					});
					break;
			}
		},
		RequestAudit_Cancel() {
			// 申请反审
			let that = this;
			let parm = {
				Invoice_No: that.dataDetail.Head.Invoice_No,
				ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time
			};
			let flg = parseInt(that.negative_flag);
			switch (flg) {
				case 0:
					that.$http.urlpost('Finance/SalInvoiceManage/RequestAudit/Cancel', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
							// 刷新数据
                            that.getDetail(that.dataDetail.Head.Invoice_No);
							//
							that.authority();
						}
					});
					break;
				case 1:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time
					};
					that.$http.urlpost('Sal/RedInv/RequestRAuditSalRedInv', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							// 刷新数据
							that.getDetailRed(parm.invoice_no);
							//
							that.authority();
						}
					});
					break;
				case 2:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time
					};
					that.$http.urlpost('Sal/ChargeRed/ChargeRedInvRAudit', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							// 刷新数据
							that.getDetailReds(parm.invoice_no);
							//
							that.authority();
						}
					});
					break;
			}
		},
		InvoiceAudit() {
			// 发票审核
			let that = this;
			// console.log("sssss："+that.auditCheckData.YearMonth)
			// 审核期间
			that.dataDetail.Head.Audit_Period = that.auditCheckData.YearMonth;
			let parm = {
				Invoice_No: that.dataDetail.Head.Invoice_No,
				ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
				Audit_Period: that.dataDetail.Head.Audit_Period,
				LangType: that.$processdata.getLang(),
			};
			let flg = parseInt(that.negative_flag);
			switch (flg) {
				case 0:
					that.$http.urlpost('Finance/SalInvoiceManage/InvoiceAudit', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
							// 刷新数据
                            that.getDetail(that.dataDetail.Head.Invoice_No);
							//
							that.authority();
						}						
						else if (res.Success == 2) {
							that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
								confirmButtonText: that.$t('getapi[1146]'),
								cancelButtonText: that.$t('getapi[2054]'),
								type: 'warning'
							})
							.then(() => {
								parm.iscontinue = res.Success
								that.$http.urlpost('Finance/SalInvoiceManage/InvoiceAudit', parm, function (res3) {
									if (res3.Success == 1) {
										that.$message.success(res3.Msg);
										// 刷新数据
										that.getDetail(that.dataDetail.Head.Invoice_No);
										//
										that.authority();
									}
								})
							})
							.catch(() => {
								that.getdlist(that.formInline.exclusively_id, '', '');
							});
						}
					});
					break;
				case 1:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time,
						invoice_date: that.dataDetailRed.Head.invoice_date,
						create_date: that.dataDetailRed.Head.create_date,
						audit_date: that.dataDetailRed.Head.audit_date,
						yearmonth: that.auditCheckData.YearMonth,
						List: that.dataDetailRed.Lists
					};
					that.$http.urlpost('Sal/RedInv/AuditSalRedInvoice', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							// 刷新数据
							that.getDetailRed(parm.invoice_no);
							//
							that.authority();
						}
					});
					break;
				case 2:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time,
						invoice_date: that.dataDetailRed.Head.invoice_date,
						create_date: that.dataDetailRed.Head.create_date,
						audit_date: that.dataDetailRed.Head.audit_date,
						yearmonth: that.auditCheckData.YearMonth
					};
					that.$http.urlpost('Sal/ChargeRed/ChargeRedAudit', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							// 刷新数据
							that.getDetailReds(parm.invoice_no);
							//
							that.authority();
						}
					});
					break;
			}
		},
		InvoiceAudit_Cancel() {
			// 发票反审
			let that = this;
			let parm = {
				Invoice_No: that.dataDetail.Head.Invoice_No,
				ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
				LangType: that.$processdata.getLang(),
			};
			let flg = parseInt(that.negative_flag);
			switch (flg) {
				case 0:
					that.$http.urlpost('Finance/SalInvoiceManage/InvoiceAudit/Cancel', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
							// 刷新数据
                            that.getDetail(that.dataDetail.Head.Invoice_No);
							//
							that.authority();
						}
					});
					break;
				case 1:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time,
						audit_period: that.dataDetailRed.Head.audit_period,
						List: that.dataDetailRed.Lists,
						LangType: that.$processdata.getLang(),
					};
					that.$http.urlpost('Sal/RedInv/RAuditSalRedInvoice', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							// 刷新数据
							that.getDetailRed(parm.invoice_no);
							//
							that.authority();
						}
					});
					break;
				case 2:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time,
						invoice_date: that.dataDetailRed.Head.invoice_date,
						create_date: that.dataDetailRed.Head.create_date,
						// audit_date: that.dataDetailRed.Head.audit_date,
						yearmonth: that.auditCheckData.YearMonth,
						LangType: that.$processdata.getLang(),
					};
					that.$http.urlpost('Sal/ChargeRed/ChargeRedRAudit', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							// 刷新数据
							that.getDetailReds(parm.invoice_no);
							//
							that.authority();
						}
					});
					break;
			}
		},
		InvoiceHook() {
			// 发票记账
			let that = this;
			let parm = {
				Invoice_No: that.dataDetail.Head.Invoice_No,
				ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
				LangType: that.$processdata.getLang(),
			};
			let flg = parseInt(that.negative_flag);
			switch (flg) {
				case 0:
					that.$http.urlpost('Finance/SalInvoiceManage/InvoiceHook', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
							// 刷新数据
                            that.getDetail(that.dataDetail.Head.Invoice_No);
							//
							that.authority();
						}
					});
					break;
				case 1:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time
					};
					that.$http.urlpost('Sal/RedInv/BalanceSalRedInv', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							// 刷新数据
							that.getDetailRed(parm.invoice_no);
							//
							that.authority();
						}
					});
					break;
				case 2:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time
					};
					that.$http.urlpost('Sal/ChargeRed/ChargeRedInvBalance', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							// 刷新数据
							that.getDetailReds(parm.invoice_no);
							//
							that.authority();
						}
					});
					break;
			}
		},
		InvoiceHook_Cancel() {
			// 发票反记账
			let that = this;
			let parm = {
				Invoice_No: that.dataDetail.Head.Invoice_No,
				ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
				LangType: that.$processdata.getLang(),
			};
			let flg = parseInt(that.negative_flag);
			switch (flg) {
				case 0:
					that.$http.urlpost('Finance/SalInvoiceManage/InvoiceHook/Cancel', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
							// 刷新数据
                            that.getDetail(that.dataDetail.Head.Invoice_No);
							//
							that.authority();
						}
					});
					break;
				case 1:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time
					};
					that.$http.urlpost('Sal/RedInv/RBalanceSalRedInv', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							// 刷新数据
							that.getDetailRed(parm.invoice_no);
							//
							that.authority();
						}
					});
					break;
				case 2:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						concurrent_time: that.dataDetailRed.Head.concurrent_time
					};
					that.$http.urlpost('Sal/ChargeRed/ChargeRedInvRBalance', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							// 刷新数据
							that.getDetailReds(parm.invoice_no);
							//
							that.authority();
						}
					});
					break;
			}
		},
		beforeSetRatePurInvoice() {
			// 变更汇率
			let that = this;
			that.visRate = true;
			if (that.negative_flag == 0) {
				that.Exchange_rate = that.dataDetail.Head.Exchange_rate;
			} else {
				that.Exchange_rate = that.dataDetailRed.Head.exchange_rate;
			}
		},
		SetRate_Click() {
			// 变更汇率 API
			let that = this;
			let parm = {
				Exchange_rate: that.Exchange_rate,
				ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
				Invoice_No: that.dataDetail.Head.Invoice_No,
				LangType: that.$processdata.getLang(),
			};
			let flg = parseInt(that.negative_flag);
			switch (flg) {
				case 0:
					that.$http.urlpost('Finance/SalInvoiceManage/ChangeRate', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
							that.visRate = false;
							// 刷新数据
                            that.getDetail(that.dataDetail.Head.Invoice_No);
							//
							that.authority();
						}
					});
					break;
				case 1:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						frmflg: 4,
						exchange_rate: that.Exchange_rate,
						tax_rate: that.dataDetailRed.Head.tax_rate,
						concurrent_time: that.dataDetailRed.Head.concurrent_time
					};
					that.$http.urlpost('Finance/Invoice/SetRate', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							that.visRate = false;
							// 刷新数据
							that.getDetailRed(that.dataDetailRed.Head.invoice_no);
							//
							that.authority();
						}
					});
					break;
				case 2:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						frmflg: 5,
						exchange_rate: that.Exchange_rate,
						tax_rate: that.dataDetailRed.Head.tax_rate,
						concurrent_time: that.dataDetailRed.Head.concurrent_time
					};
					that.$http.urlpost('Finance/Invoice/SetRate', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							that.visRate = false;
							// 刷新数据
							that.getDetailReds(that.dataDetailRed.Head.invoice_no);
							//
							that.authority();
						}
					});
					break;
			}
		},
		SetTaxRate_Click() {
			// 税率变更 API
			let that = this;
			let parm = {
				Tax_rate: that.Tax_rate,
				ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
				Invoice_No: that.dataDetail.Head.Invoice_No,
				LangType: that.$processdata.getLang(),
			};
			let flg = parseInt(that.negative_flag);
			switch (flg) {
				case 0:
					that.$http.urlpost('Finance/SalInvoiceManage/ChangeTaxRate', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
							that.visTaxRate = false;
							// 刷新数据
                            that.getDetail(that.dataDetail.Head.Invoice_No);
							//
							that.authority();
						}
					});
					break;
				case 1:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						order_type: 'sal_n',
						tax_rate: that.Tax_rate,
						concurrent_time: that.dataDetailRed.Head.concurrent_time
					};
					that.$http.urlpost('Finance/Invoice/SetTaxRate', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							that.visTaxRate = false;
							// 刷新数据
							that.getDetailRed(that.dataDetailRed.Head.invoice_no);
							//
							that.authority();
						}
					});
					break;
				case 2:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						order_type: 'sal_n_cost',
						tax_rate: that.Tax_rate,
						concurrent_time: that.dataDetailRed.Head.concurrent_time
					};
					that.$http.urlpost('Finance/Invoice/SetTaxRate', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							that.visTaxRate = false;
							// 刷新数据
							that.getDetailReds(that.dataDetailRed.Head.invoice_no);
							//
							that.authority();
						}
					});
					break;
			}
		},
		SetTaxRateBack_Click() {
			// 变更含税税率 API
			let that = this;
			let parm = {
				Old_Tax_rate: that.Old_Tax_rate,
				ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
				Invoice_No: that.dataDetail.Head.Invoice_No,
				LangType: that.$processdata.getLang(),
			};
			let flg = parseInt(that.negative_flag);
			switch (flg) {
				case 0:
					that.$http.urlpost('Finance/SalInvoiceManage/ChangeTaxRateBack', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
							that.visChangeTaxRate = false;
							// 刷新数据
                            that.getDetail(that.dataDetail.Head.Invoice_No);
							//
							that.authority();
						}
					});
					break;
				case 1:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						order_type: 'sal_n',
						old_tax_rate: that.Old_Tax_rate,
						tax_rate: that.dataDetailRed.Head.tax_rate,
						exchange_rate: that.dataDetailRed.Head.exchange_rate,
						concurrent_time: that.dataDetailRed.Head.concurrent_time
					};
					that.$http.urlpost('Finance/Invoice/ChanageSetTaxRate', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							that.visChangeTaxRate = false;
							// 刷新数据
							that.getDetailRed(that.dataDetailRed.Head.invoice_no);
							//
							that.authority();
						}
					});
					break;
			}
		},
		beforeChangeInvoiceNo() {
			let that = this;
			if (!that.dataDetail.Head.Invoice_No && that.negative_flag == 0) {
				return;
			}
			if (!that.dataDetailRed.Head.invoice_no && that.negative_flag >= 1) {
				return;
			}
			that.visEditInvoice = true;
			//that.New_Invoice_No = that.dataDetail.Head.Invoice_No;
		},
		mnuEditInvoice_Click() {
			// 修改发票号 API
			let that = this;
			if (!that.New_Invoice_No) {
				return;
			}

			let parm = {
				New_Invoice_No: that.New_Invoice_No,
				ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
				Invoice_No: that.dataDetail.Head.Invoice_No
			};
			// if (parm.New_Invoice_No == parm.Invoice_No) {
			//   return;
			// }
			if (that.negative_flag >= 1) {
				parm = {
					New_Invoice_No: that.New_Invoice_No,
					ConCurrent_Time: that.dataDetailRed.Head.concurrent_time,
					Invoice_No: that.dataDetailRed.Head.invoice_no,
					LangType: that.$processdata.getLang(),
				};
			}
			that.$http.urlpost('Finance/SalInvoiceManage/ChangeInvoiceNo', parm, function(res) {
				if (res.Success == 1) {
					that.New_Invoice_No = '';
					that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					that.code = parm.New_Invoice_No;
					that.visEditInvoice = false;
					that.getView();
					// 刷新数据
					let flg = parseInt(that.negative_flag);
					switch (flg) {
						case 0:
							that.dataDetail.Head.Invoice_No = parm.New_Invoice_No;
							that.getDetail(that.dataDetail.Head.Invoice_No)
							break;
						case 1:
							that.dataDetailRed.Head.invoice_no = parm.New_Invoice_No;
                            that.getDetailRed(that.dataDetailRed.Head.invoice_no);
							break;
						case 2:
							that.dataDetailRed.Head.invoice_no = parm.New_Invoice_No;
                            that.getDetailReds(that.dataDetailRed.Head.invoice_no);
							break;
					}
					that.authority();
				}
			});
		},
		editAuditDate_Click() {
			// 审核期间调整API
			let that = this;
			let parm = {
				Invoice_No: that.dataDetail.Head.Invoice_No,
				Audit_Period: that.dataDetail.Head.Audit_Period,
				ConCurrent_Time: that.dataDetail.Head.ConCurrent_Time,
				auditdate: that.Audit_Period,
				LangType: that.$processdata.getLang(),
			};
			let flg = parseInt(that.negative_flag);
			switch (flg) {
				case 0:
					that.$http.urlpost('Finance/SalInvoiceManage/ChanageAuditDate', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
							that.visChangeAuditDate = false;
							// 刷新数据
                            that.getDetail(that.dataDetail.Head.Invoice_No);
							//
							that.authority();
						}
					});
					break;
				case 1:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						billtype: '5',
						auditdate: that.getnewdate(that.Audit_Period),
						audit_period: that.dataDetailRed.Head.audit_period
					};
					that.$http.urlpost('Finance/Invoice/ChanageAuditDate', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							that.visChangeAuditDate = false;
							// 刷新数据
							that.getDetailRed(that.dataDetailRed.Head.invoice_no);
							that.authority();
						}
					});
					break;
				case 2:
					parm = {
						invoice_no: that.dataDetailRed.Head.invoice_no,
						billtype: '6',
						auditdate: that.getnewdate(that.Audit_Period),
						audit_period: that.dataDetailRed.Head.audit_period
					};
					that.$http.urlpost('Finance/Invoice/ChanageAuditDate', parm, function(res) {
						if (res.Success == 1) {
							that.$message.success(that.$t('getapi[498]'));//'成功'
							that.visChangeAuditDate = false;
							// 刷新数据
							that.getDetailReds(that.dataDetailRed.Head.invoice_no);
							that.authority();
						}
					});
					break;
			}
		},
		BatchBalance_Click() {
			//批量记账
			let that = this;
			if (that.selectCodeData.length == 0) {
				that.$message.warning(that.$t('getapi[1158]'));//请选择数据！
				return;
			}
			let parm = { 
				Rows: that.selectCodeData,
				LangType: that.$processdata.getLang()
			};
			that.$http.urlpost('Finance/SalInvoiceManage/InvoiceHookBatch', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					that.getView();
				}
				if (res.DataContent) {
					that.visShowMessage = true;
					that.textareaShowMessage = res.DataContent;
					return;
				}
			});
		},
		BatchNoBalance_Click() {
			//批量反记账
			let that = this;
			if (that.selectCodeData.length == 0) {
				that.$message.warning(that.$t('getapi[1158]'));//请选择数据！
				return;
			}

			let parm = { 
				Rows: that.selectCodeData,
				LangType: that.$processdata.getLang(), 
			};
			that.$http.urlpost('Finance/SalInvoiceManage/InvoiceHookBatch/Cancel', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					that.getView();
				}
				if (res.DataContent) {
					that.visShowMessage = true;
					that.textareaShowMessage = res.DataContent;
					return;
				}
			});
		},
		BatchUpdateSalInvVirtual() {
			//批量更新虚拟发票
			let that = this;
			if (that.selectData.length == 0) {
				that.$message.warning(that.$t('getapi[1158]'));//请选择数据！
				return;
			}
			
			that.$confirm(that.$t('getapi[12316]'), that.$t('getapi[194]'), {
					confirmButtonText: that.$t('getapi[2052]'),
					cancelButtonText: that.$t('getapi[2053]'),
					closeOnClickModal: false,
					type: 'warning'
			})
			.then(() => {
				let parm = { 
					List: that.selectData,
					LangType: that.$processdata.getLang(), 
				};
				that.$http.urlpost('Sal/RedInv/BatchUpdateSalInvVirtualFlag', parm, function(res) {
					if (res.Success == 1) {
						that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
						that.getView();
					}
				});
			})
			.catch(() => {
				console.log("");
			});
			
		},
		ShowInvoiceNumLst(){
			console.log('修改发票摘要');
			let that = this;
			if (!that.code){
				return;
			}
			let flg = parseInt(that.negative_flag);
			if (flg == 0){
				that.code =that.dataDetail.Head.Invoice_No ;				
				that.txtInvoiceNumLst =that.dataDetail.Head.InvoiceNumLst;
			}
			else
			{
				that.code =that.dataDetailRed.Head.invoice_no;
				that.txtInvoiceNumLst =that.dataDetailRed.Head.invoicenumlst;
			}
			that.visShowInvoiceNumLst = true;		
		},
		InvoiceNumLst_Click(){
			console.log('修改发票摘要');
			let that = this;
			if (!that.code){
				return;
			}
			let parm = { 
				Invoice_No: that.code, 
				InvoiceNumLst:that.txtInvoiceNumLst,
				LangType: that.$processdata.getLang(),
			};
			that.$http.urlpost('Finance/SalInvoiceManage/InvoiceNumLst', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
				}
				let flg = parseInt(that.negative_flag);
				if (flg  == 0){
					that.dataDetail.Head.InvoiceNumLst = that.txtInvoiceNumLst ;
				}else
				{
					that.dataDetailRed.Head.invoicenumlst = that.txtInvoiceNumLst;
				}
				that.visShowInvoiceNumLst = false;
			});
		},
        sortChange(column){
            let that = this
            let name = column.prop
            console.log(column)
            if(column.order == "ascending"){
                let compare = function (obj1, obj2) {
                    let val1 = obj1[name];
                    let val2 = obj2[name];
                    if (val1 < val2) {
                        return -1;
                    } else if (val1 > val2) {
                        return 1;
                    } else {
                        return that.dataDetail.Line.indexOf(obj1) - that.dataDetail.Line.indexOf(obj2);
                    }
                }
                that.dataDetail.Line = that.dataDetail.Line.sort(compare);
            } else if(column.order == "descending"){
                let compare = function (obj1, obj2) {
                    let val1 = obj1[name];
                    let val2 = obj2[name];
                    if (val1 < val2) {
                        return 1;
                    } else if (val1 > val2) {
                        return -1;
                    } else {
                        return that.dataDetail.Line.indexOf(obj2) - that.dataDetail.Line.indexOf(obj1);
                    }
                }
                that.dataDetail.Line = that.dataDetail.Line.sort(compare);
            }
        },
        selectInfo(tab, event) {
            let that = this;
            that.RightSelectIndex = tab.name;
            that.$nextTick(function(){
                that.$processdata.initFormRight(that.RightSelectIndex)
            });
        },
		// 税务金额调整导入
        taxDifImp(){
            let item = {
                label: this.$t("getapi[8911]"),
                name: '3_taxdifimp',
                path: '/taxdifimp',
                url: '/taxdifimp',
                icon: 'video-play'
            };
            this.$router.push({path: '/taxdifimp'});
            this.$store.commit('selectMenu', item);
		},
		//到期日调整
		cusDate(){
            let item = {
                label: this.$t("getapi[12843]"),
                name: '3_cusdate',
                path: '/cusdate',
                url: '/cusdate',
                icon: 'video-play'
            };
            this.$router.push({path: '/cusdate'});
            this.$store.commit('selectMenu', item);
        },
        expStatus(val){
            let that = this
            if(val == 0){
                return that.$t('getapi[1422]')//'生成'
            } else if(val == 1){
                return that.$t('getapi[3876]')//'发票审核'
            } else if(val == 2){
                return that.$t('getapi[8921]')//'钩稽'
            } else if(val == 3){
                return that.$t('getapi[1868]')//'记账'
            } else if(val == 4){
                return that.$t('getapi[3754]')//'月结'
            } else if(val == 5){
                return that.$t('getapi[3755]')//'作废'
            } else if(val == 6){
                return that.$t('getapi[3001]')//'申请审核'
            } else {
                return ''
            }
        },
        checkDataChange(){
            let that = this
            //如果无保存权限，直接关闭
            if(that.$limits.authority('plv3', 244,1) < 1){
                return false
            }
            let flag = true
            if(that.negative_flag == 0){
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Line.length;i++){
                    delete datacopy.Line[i]['index']
                }
                for(let i = 0;i<datacopy.OtherCostLine.length;i++){
                    delete datacopy.OtherCostLine[i]['index']
                }
                flag =  that.oldDataDetail != JSON.stringify(datacopy)
            } else {
                let datacopyred = that.dataDetailRed
                for(let i = 0;i<datacopyred.Lists.length;i++){
                    delete datacopyred.Lists[i]['index']
                }
                flag =  that.oldDataDetailRed != JSON.stringify(datacopyred)
            }
            return flag
        },
		/**************************************************/
        coverInvoice_No(){
            let that = this
			that.coverInvoiceNo = ''
			that.visCover = true
		},
        coverBlankInvoice_No(){
            let that = this
            that.coverBlankInvoiceNo = ''
            that.visCoverBlank = true
		},
		confirmCover(){
            let that = this
			if(that.negative_flag==1){
				for(let i=0;i<that.dataDetailRed.Lists.length;i++){
					that.dataDetailRed.Lists[i].proforma_invoice_no = that.coverInvoiceNo
				}
			}
			else{
				for(let i=0;i<that.dataDetail.Line.length;i++){
					that.dataDetail.Line[i].Proforma_Invoice_No = that.coverInvoiceNo
				}
			}
            that.visCover = false
		},
		confirmCoverBlank(){
            let that = this
            if(that.negative_flag==1){
                for(let i=0;i<that.dataDetailRed.Lists.length;i++){
                    if(that.dataDetailRed.Lists[i].proforma_invoice_no == ''){
                        that.dataDetailRed.Lists[i].proforma_invoice_no = that.coverBlankInvoiceNo
					}
                }
            }
            else{
                for(let i=0;i<that.dataDetail.Line.length;i++){
                    if(that.dataDetail.Line[i].Proforma_Invoice_No == ''){
                        that.dataDetail.Line[i].Proforma_Invoice_No = that.coverBlankInvoiceNo
                    }
                }
            }
            that.visCoverBlank = false
        },
        coverInvoice_NoRed(){
            let that = this
            that.coverInvoiceNo = ''
            that.visCoverRed = true
        },
        coverBlankInvoice_NoRed(){
            let that = this
            that.coverBlankInvoiceNo = ''
            that.visCoverBlankRed = true
        },
        confirmCoverRed(){
            let that = this
            for(let i=0;i<that.dataDetailRed.Lists.length;i++){
                that.dataDetailRed.Lists[i].invoice_no = that.coverInvoiceNo
                that.dataDetailRed.Lists[i].proforma_invoice_no = that.coverInvoiceNo
            }
            that.visCoverRed = false
        },
		confirmCoverBlankRed(){
            let that = this
            for(let i=0;i<that.dataDetailRed.Lists.length;i++){
                if(that.dataDetailRed.Lists[i].invoice_no == ''){
                    that.dataDetailRed.Lists[i].invoice_no = that.coverBlankInvoiceNo
                }
                if(that.dataDetailRed.Lists[i].proforma_invoice_no == ''){
                    that.dataDetailRed.Lists[i].proforma_invoice_no = that.coverBlankInvoiceNo
                }
            }
            that.visCoverBlankRed = false
        },
		//售后价 费用明细 可修改原币不含税金额
		getPriceWithAfterFlag(row){
			let that =  this
			let index = row.$index
			//原币不含税单价
			that.dataDetail.OtherCostLine[index].Net_Unit_Price = that.$processdata.floatDiv(that.dataDetail.OtherCostLine[index].Net_Total_Amount,that.dataDetail.OtherCostLine[index].Charge_Qty)
			//原币含税单价
            that.dataDetail.OtherCostLine[index].Unit_Price = that.$processdata.floatMul(that.dataDetail.OtherCostLine[index].Net_Unit_Price,parseFloat(1+that.dataDetail.Head.Tax_rate/100))
			//原币含税金额
            that.dataDetail.OtherCostLine[index].Total_Amount = that.$processdata.floatMul(that.dataDetail.OtherCostLine[index].Unit_Price,that.dataDetail.OtherCostLine[index].Charge_Qty)
			//本币不含税单价
            that.dataDetail.OtherCostLine[index].Base_Net_Unit_Price = that.$processdata.floatMul(that.dataDetail.OtherCostLine[index].Net_Unit_Price,that.dataDetail.Head.Exchange_rate)
            //本币含税单价
            that.dataDetail.OtherCostLine[index].Base_Unit_Price = that.$processdata.floatMul(that.dataDetail.OtherCostLine[index].Unit_Price,that.dataDetail.Head.Exchange_rate)
            //本币不含税金额
            that.dataDetail.OtherCostLine[index].Base_Net_Total_Amount = that.$processdata.floatMul(that.dataDetail.OtherCostLine[index].Base_Net_Unit_Price,that.dataDetail.OtherCostLine[index].Charge_Qty)
            //本币含税金额
            that.dataDetail.OtherCostLine[index].Base_Total_Amount = that.$processdata.floatMul(that.dataDetail.OtherCostLine[index].Base_Unit_Price,that.dataDetail.OtherCostLine[index].Charge_Qty)
		}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;

	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
